// ============================================================================
// SS1 COMMERCE — COMPLETE LEARNING MODULE (24 TOPICS × 20 QUESTIONS = 480 Qs)
// NERDC Scheme of Work — First Term to Third Term
// ============================================================================

export const WAEC_COMMERCE_LEARN_SS1 = [
  {
    "topic": "Introduction — Meaning of Commerce",
    "topicCode": "SS1-COM-01",
    "module": "Introduction to Commerce",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Introduction — Meaning of Commerce</span>: Commerce = Trade + Aids to Trade. Removes hindrances: Transport(place), Warehousing(time), Insurance(risk), Banking(finance), Advertising(knowledge), Communication(information).</div>",
    "questions": [
      {
        "q": "Commerce is best defined as:",
        "o": [
          "Only production of goods",
          "All activities concerned with the buying, selling, and distribution of goods and services",
          "Only foreign trade",
          "Growing food for consumption"
        ],
        "a": 1,
        "e": "Commerce = Trade + Aids to Trade. Encompasses all activities involved in getting goods from producers to consumers.",
        "h": "Commerce = Trade + Aids to Trade.",
        "yr": "SS1"
      },
      {
        "q": "Which of the following is NOT an aid to trade?",
        "o": [
          "Transportation",
          "Insurance",
          "Mining",
          "Banking"
        ],
        "a": 2,
        "e": "Mining is extractive industry (primary production), not an aid to trade.",
        "h": "Mining = production. Aids: transport, warehousing, insurance, banking, advertising.",
        "yr": "SS1"
      },
      {
        "q": "Transportation removes the hindrance of:",
        "o": [
          "Time",
          "Risk",
          "Place",
          "Finance"
        ],
        "a": 2,
        "e": "Transport removes PLACE hindrance.",
        "h": "Transport removes PLACE hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Warehousing removes the hindrance of:",
        "o": [
          "Place",
          "Time",
          "Risk",
          "Knowledge"
        ],
        "a": 1,
        "e": "Warehousing removes TIME hindrance.",
        "h": "Warehousing removes TIME hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Insurance removes the hindrance of:",
        "o": [
          "Time",
          "Place",
          "Knowledge",
          "Risk"
        ],
        "a": 3,
        "e": "Insurance removes RISK hindrance.",
        "h": "Insurance removes RISK hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Banking removes the hindrance of:",
        "o": [
          "Risk",
          "Time",
          "Finance",
          "Place"
        ],
        "a": 2,
        "e": "Banking removes FINANCE hindrance.",
        "h": "Banking removes FINANCE hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Advertising removes the hindrance of:",
        "o": [
          "Place",
          "Knowledge/Information",
          "Time",
          "Risk"
        ],
        "a": 1,
        "e": "Advertising removes KNOWLEDGE/INFORMATION hindrance.",
        "h": "Advertising removes KNOWLEDGE hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Commerce consists of:",
        "o": [
          "Industry and agriculture",
          "Trade and aids to trade",
          "Production and distribution only",
          "Import and export only"
        ],
        "a": 1,
        "e": "Commerce = Trade + Aids to Trade.",
        "h": "Commerce = Trade + Aids to Trade.",
        "yr": "SS1"
      },
      {
        "q": "The correct chain from production to consumption:",
        "o": [
          "Consumption → Commerce → Production",
          "Commerce → Production → Consumption",
          "Production → Commerce → Consumption",
          "Production → Consumption → Commerce"
        ],
        "a": 2,
        "e": "Production → Commerce → Consumption. Commerce bridges producers and consumers.",
        "h": "Chain: Production → Commerce → Consumption.",
        "yr": "SS1"
      },
      {
        "q": "Which is an importance of commerce?",
        "o": [
          "Directly manufactures goods",
          "Creates employment for millions of Nigerians",
          "Extracts natural resources",
          "Grows agricultural produce"
        ],
        "a": 1,
        "e": "Commerce creates employment: traders, bankers, transporters, insurance agents.",
        "h": "Commerce importance: creates employment, raises living standards, generates govt revenue.",
        "yr": "SS1"
      },
      {
        "q": "Communication removes the hindrance of:",
        "o": [
          "Risk",
          "Time",
          "Place",
          "Information between buyers and sellers"
        ],
        "a": 3,
        "e": "Communication removes INFORMATION hindrance.",
        "h": "Communication removes INFORMATION hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Which sector produces goods that commerce distributes?",
        "o": [
          "Commerce",
          "Industry",
          "Trade",
          "Retail"
        ],
        "a": 1,
        "e": "Industry produces; commerce distributes. Interdependent.",
        "h": "Industry produces; commerce distributes.",
        "yr": "SS1"
      },
      {
        "q": "A logistics company moving goods from Lagos to Abuja is:",
        "o": [
          "Production",
          "Commerce (transport — aid to trade)",
          "Industry",
          "Agriculture"
        ],
        "a": 1,
        "e": "Transportation = aid to trade = commerce.",
        "h": "Transport = aid to trade = commerce.",
        "yr": "SS1"
      },
      {
        "q": "The main difference between trade and commerce:",
        "o": [
          "They are identical",
          "Trade is broader than commerce",
          "Trade is just one part of commerce (commerce also includes aids)",
          "Commerce is only for foreign goods"
        ],
        "a": 2,
        "e": "Trade ⊂ Commerce. Commerce = Trade + Aids to Trade.",
        "h": "Trade ⊂ Commerce. Commerce is broader.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria earns foreign exchange primarily through:",
        "o": [
          "Home retail trade",
          "Warehousing",
          "Foreign trade (exports of crude oil)",
          "Advertising"
        ],
        "a": 2,
        "e": "Nigeria earns forex through foreign trade — especially crude oil exports (~90% of forex).",
        "h": "Foreign exchange = exports = foreign trade = commerce.",
        "yr": "SS1"
      },
      {
        "q": "How does commerce promote specialisation?",
        "o": [
          "Commerce teaches skills",
          "Provides markets — producers specialise knowing trade will distribute output",
          "Forces all to make same goods",
          "Replaces specialisation"
        ],
        "a": 1,
        "e": "Commerce provides markets for specialised output.",
        "h": "Commerce promotes specialisation by providing markets.",
        "yr": "SS1"
      },
      {
        "q": "NAFDAC registration relates to:",
        "o": [
          "Warehousing",
          "Advertising/knowledge (product safety info)",
          "Transportation",
          "Insurance"
        ],
        "a": 1,
        "e": "NAFDAC certification = product safety information = knowledge function of commerce.",
        "h": "NAFDAC = product safety info = knowledge/advertising function.",
        "yr": "SS1"
      },
      {
        "q": "The scope of commerce covers all EXCEPT:",
        "o": [
          "Buying and selling (trade)",
          "Transport and warehousing",
          "Mining and oil extraction",
          "Banking and insurance"
        ],
        "a": 2,
        "e": "Mining = extractive industry (primary production), not commerce.",
        "h": "Commerce: trade + aids. Mining = production, NOT commerce.",
        "yr": "SS1"
      },
      {
        "q": "Government revenue from commerce comes through:",
        "o": [
          "Paying salaries to traders",
          "Taxes (VAT, customs duties, company taxes)",
          "Selling goods to consumers",
          "Providing free services to businesses"
        ],
        "a": 1,
        "e": "Government revenue from commerce: VAT, customs duties, corporate taxes.",
        "h": "Govt revenue: VAT + customs duties + corporate taxes.",
        "yr": "SS1"
      },
      {
        "q": "Which statement about commerce is CORRECT?",
        "o": [
          "Commerce includes manufacture of goods",
          "Commerce is limited to foreign trade",
          "Commerce is study of government policies",
          "Commerce is branch of business dealing with distribution of goods"
        ],
        "a": 3,
        "e": "Commerce = distribution of goods/services. NOT manufacturing.",
        "h": "Commerce = distribution. NOT manufacturing (that is industry).",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "History of Commerce",
    "topicCode": "SS1-COM-02",
    "module": "Introduction to Commerce",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">History of Commerce</span>: Commerce evolved: Barter → commodity money (cowries) → coins/paper → banking/credit → e-commerce. Nigeria: cowries, trans-Saharan trade, palm oil, naira (1973), mobile money.</div>",
    "questions": [
      {
        "q": "Barter is defined as:",
        "o": [
          "Use of coins to buy goods",
          "Direct exchange of goods for goods without money",
          "Buying on credit",
          "Trading shares"
        ],
        "a": 1,
        "e": "Barter = direct exchange of goods for goods without money. Earliest form of trade.",
        "h": "Barter = goods for goods. No money.",
        "yr": "SS1"
      },
      {
        "q": "The main problem of barter that money solved:",
        "o": [
          "Lack of buyers",
          "Double coincidence of wants",
          "Too much production",
          "Poor transport"
        ],
        "a": 1,
        "e": "Double coincidence: must find someone who has what you want AND wants what you have.",
        "h": "Barter's main problem = double coincidence of wants.",
        "yr": "SS1"
      },
      {
        "q": "Pre-colonial Nigeria used as money:",
        "o": [
          "Naira notes",
          "Cowrie shells",
          "US dollars",
          "British pounds"
        ],
        "a": 1,
        "e": "Cowrie shells (and brass rods, iron bars) were used as money in pre-colonial Nigeria.",
        "h": "Pre-colonial Nigeria: cowrie shells, brass rods as money.",
        "yr": "SS1"
      },
      {
        "q": "The Nigerian naira was introduced in:",
        "o": [
          "1960",
          "1963",
          "1973",
          "1999"
        ],
        "a": 2,
        "e": "Nigeria introduced the naira on January 1, 1973, replacing the British pound sterling.",
        "h": "Naira: January 1, 1973.",
        "yr": "SS1"
      },
      {
        "q": "Trans-Saharan trade carried northward from West Africa:",
        "o": [
          "Crude oil and gas",
          "Kola nuts, gold, ivory, and slaves",
          "Manufactured electronics",
          "Refined petroleum"
        ],
        "a": 1,
        "e": "Trans-Saharan (northward): kola nuts, gold, ivory, enslaved people. Southward: cloth, salt, horses.",
        "h": "Trans-Saharan northward: kola nuts, gold, slaves.",
        "yr": "SS1"
      },
      {
        "q": "'Indivisibility' as a barter problem means:",
        "o": [
          "Double coincidence of wants",
          "Goods cannot be split for exchange (e.g., cannot split a cow to buy sandals)",
          "No common measure",
          "Lack of storage"
        ],
        "a": 1,
        "e": "Indivisibility: some goods cannot be divided. A cow cannot be split to make change.",
        "h": "Indivisibility = can't split goods for exchange.",
        "yr": "SS1"
      },
      {
        "q": "Banks as commercial institutions developed primarily to:",
        "o": [
          "Control government",
          "Safely store money, provide credit, facilitate payments",
          "Print paper money",
          "Reduce competition"
        ],
        "a": 1,
        "e": "Banks: safe storage, credit/loans for trade, payment facilitation.",
        "h": "Banks: safe storage + credit + payment facilitation.",
        "yr": "SS1"
      },
      {
        "q": "First Bank of Nigeria established in:",
        "o": [
          "1960",
          "1947",
          "1894",
          "1973"
        ],
        "a": 2,
        "e": "First Bank (Bank of British West Africa) established 1894. Nigeria's first bank.",
        "h": "First Bank Nigeria = 1894 (colonial era).",
        "yr": "SS1"
      },
      {
        "q": "Money solved barter problems because money is:",
        "o": [
          "More beautiful than shells",
          "Divisible, portable, durable, generally accepted, standard measure of value",
          "Only accepted in cities",
          "Always government-issued"
        ],
        "a": 1,
        "e": "Money: divisible, portable, durable, generally accepted, standard measure of value.",
        "h": "Money: divisible, portable, durable, accepted, standard measure.",
        "yr": "SS1"
      },
      {
        "q": "E-commerce in Nigeria exemplified by:",
        "o": [
          "NNPC and Dangote",
          "Jumia, Konga, and Flutterwave",
          "First Bank and UBA",
          "NPA and NIMASA"
        ],
        "a": 1,
        "e": "Jumia (marketplace), Konga (retail), Flutterwave (payments) = Nigerian e-commerce.",
        "h": "Nigeria e-commerce: Jumia, Konga, Flutterwave.",
        "yr": "SS1"
      },
      {
        "q": "Palm oil became Nigeria's major export after:",
        "o": [
          "Independence 1960",
          "Oil discovery 1956",
          "Abolition of transatlantic slave trade (19th century)",
          "Naira introduction 1973"
        ],
        "a": 2,
        "e": "After slave trade ended, palm oil (south) and groundnuts (north) replaced slaves as main exports.",
        "h": "After slave trade ended: palm oil + groundnuts = legitimate exports.",
        "yr": "SS1"
      },
      {
        "q": "Commodity money means:",
        "o": [
          "Paper notes from government",
          "Using valuable physical goods (cowries, metals) as currency",
          "Digital cryptocurrency",
          "Stock market shares"
        ],
        "a": 1,
        "e": "Commodity money: using scarce valuable goods as money — cowries, gold, salt.",
        "h": "Commodity money = valuable physical goods used as currency.",
        "yr": "SS1"
      },
      {
        "q": "Lagos Chamber of Commerce (LCCI) is a:",
        "o": [
          "Bank",
          "Insurance company",
          "Chamber of Commerce — promotes trade interests",
          "Government ministry"
        ],
        "a": 2,
        "e": "LCCI = Chamber of Commerce. Promotes commercial interests of Lagos businesses.",
        "h": "LCCI = Chamber of Commerce = promotes trade interests.",
        "yr": "SS1"
      },
      {
        "q": "NGX (Nigerian Exchange Group) facilitates:",
        "o": [
          "Importing goods",
          "Buying and selling of company shares (stock exchange)",
          "Insurance of goods",
          "Transport of goods"
        ],
        "a": 1,
        "e": "NGX = stock exchange where company shares are bought and sold.",
        "h": "NGX = stock exchange = market for company shares.",
        "yr": "SS1"
      },
      {
        "q": "Transatlantic slave trade affected Nigerian commerce by:",
        "o": [
          "Boosting agricultural trade",
          "Disrupting legitimate commerce — replacing goods trade with trade in humans",
          "Developing new beneficial routes",
          "Having no effect"
        ],
        "a": 1,
        "e": "Slave trade devastated commerce: replaced goods trade with human trade.",
        "h": "Slave trade: disrupted legitimate commerce.",
        "yr": "SS1"
      },
      {
        "q": "Correct EVOLUTION of commerce:",
        "o": [
          "Money → Barter → E-commerce",
          "Barter → commodity money → coins → banking/credit → e-commerce",
          "E-commerce → banking → barter",
          "Coins → barter → e-commerce"
        ],
        "a": 1,
        "e": "Evolution: Barter → Commodity money → Coins/paper → Banking/credit → E-commerce.",
        "h": "Evolution: Barter → Commodity money → Coins → Banking → E-commerce.",
        "yr": "SS1"
      },
      {
        "q": "Mobile money (OPay, Paga) represents:",
        "o": [
          "Return to barter",
          "Most modern evolution — digital financial inclusion via mobile phones",
          "Traditional banking only",
          "Insurance services"
        ],
        "a": 1,
        "e": "OPay, Paga, Moniepoint = mobile money = latest commerce evolution.",
        "h": "Mobile money = modern digital commerce evolution, financial inclusion.",
        "yr": "SS1"
      },
      {
        "q": "'No common measure of value' as a barter problem:",
        "o": [
          "Buyers and sellers don't meet",
          "No standard to compare values (how many yams = one cow?)",
          "Goods have no value",
          "Money has no value"
        ],
        "a": 1,
        "e": "Without money, no standard unit to compare relative values of diverse goods.",
        "h": "No common measure: how many yams = one cow? Money provides standard.",
        "yr": "SS1"
      },
      {
        "q": "NAFDAC ensures imported goods:",
        "o": [
          "Nigeria Customs (collects duties)",
          "NEPC",
          "NAFDAC — ensures imported food/drugs meet Nigerian safety standards",
          "CBN"
        ],
        "a": 2,
        "e": "NAFDAC ensures imported food, drugs, cosmetics meet Nigerian safety standards.",
        "h": "NAFDAC = ensures safety of imported food/drugs/consumer goods.",
        "yr": "SS1"
      },
      {
        "q": "Credit as a commerce stage means:",
        "o": [
          "Using coins to buy",
          "Obtaining goods now, paying money at a later agreed date",
          "Returning goods after purchase",
          "Exchanging goods directly"
        ],
        "a": 1,
        "e": "Credit = take goods now, pay later. Enables trade beyond immediate cash.",
        "h": "Credit = get goods now, pay money later.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Meaning of Occupation",
    "topicCode": "SS1-COM-03",
    "module": "Introduction to Commerce",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Meaning of Occupation</span>: Occupation = legitimate activity to earn livelihood. Three types: Industrial (extractive/manufacturing), Commercial (trade/banking/insurance/transport), Service (personal/professional/government).</div>",
    "questions": [
      {
        "q": "An occupation is:",
        "o": [
          "Any illegal activity for profit",
          "Any legitimate activity regularly performed to earn a livelihood",
          "Working for government only",
          "Only physical labour"
        ],
        "a": 1,
        "e": "Occupation = any legitimate activity regularly done to earn a living.",
        "h": "Occupation = legitimate activity regularly done to earn livelihood.",
        "yr": "SS1"
      },
      {
        "q": "Mining is classified as:",
        "o": [
          "Commercial",
          "Service",
          "Industrial — extractive industry",
          "Professional service"
        ],
        "a": 2,
        "e": "Mining = extractive (primary) industry = industrial occupation.",
        "h": "Mining = extractive industry = industrial occupation.",
        "yr": "SS1"
      },
      {
        "q": "A market trader is engaged in:",
        "o": [
          "Industrial occupation",
          "Commercial occupation (trade)",
          "Service occupation",
          "Extractive occupation"
        ],
        "a": 1,
        "e": "Market trader = trade = commercial occupation.",
        "h": "Market trader = trade = commercial occupation.",
        "yr": "SS1"
      },
      {
        "q": "Teaching is classified as:",
        "o": [
          "Industrial",
          "Commercial",
          "Service (professional)",
          "Extractive"
        ],
        "a": 2,
        "e": "Teaching = professional service = service occupation.",
        "h": "Teaching = professional service = service occupation.",
        "yr": "SS1"
      },
      {
        "q": "Palm oil processing is:",
        "o": [
          "Extractive",
          "Manufacturing (processing) industry",
          "Commercial",
          "Service"
        ],
        "a": 1,
        "e": "Palm oil processing converts raw fruits to oil = manufacturing = industrial occupation.",
        "h": "Palm oil processing = manufacturing = industrial occupation.",
        "yr": "SS1"
      },
      {
        "q": "Hairdressing is classified as:",
        "o": [
          "Industrial",
          "Commercial",
          "Service (direct personal)",
          "Extractive"
        ],
        "a": 2,
        "e": "Hairdressing = direct personal service = service occupation.",
        "h": "Hairdressing = direct personal service = service occupation.",
        "yr": "SS1"
      },
      {
        "q": "Banking is classified as:",
        "o": [
          "Industrial",
          "Service",
          "Commercial (aid to trade)",
          "Extractive"
        ],
        "a": 2,
        "e": "Banking = commercial occupation = aid to trade (removes finance hindrance).",
        "h": "Banking = commercial occupation = aid to trade.",
        "yr": "SS1"
      },
      {
        "q": "Constructive industry (building roads) is:",
        "o": [
          "Extractive",
          "Manufacturing (secondary) industrial",
          "Commercial",
          "Service"
        ],
        "a": 1,
        "e": "Constructive industry = building = manufacturing/secondary industrial occupation.",
        "h": "Building = manufacturing = industrial occupation.",
        "yr": "SS1"
      },
      {
        "q": "Fishing is classified as:",
        "o": [
          "Manufacturing",
          "Extractive (primary) industry",
          "Commercial",
          "Service"
        ],
        "a": 1,
        "e": "Fishing = extractive industry = takes natural resources (fish) from nature.",
        "h": "Fishing = extractive industry.",
        "yr": "SS1"
      },
      {
        "q": "The three main occupation types are:",
        "o": [
          "Farming, trading, manufacturing",
          "Industrial, commercial, service",
          "Primary, secondary, quaternary",
          "Extractive, distributive, professional"
        ],
        "a": 1,
        "e": "Three types: Industrial (produce), Commercial (distribute), Service (provide services).",
        "h": "Three types: Industrial + Commercial + Service.",
        "yr": "SS1"
      },
      {
        "q": "A police officer is engaged in:",
        "o": [
          "Commercial",
          "Industrial",
          "Government/public service (service)",
          "Extractive"
        ],
        "a": 2,
        "e": "Police = government/public service = service occupation.",
        "h": "Police = government service = service occupation.",
        "yr": "SS1"
      },
      {
        "q": "Industrial and commercial occupations relate:",
        "o": [
          "Completely independent",
          "Industrial produces goods, commercial distributes — interdependent",
          "Commercial produces what industrial distributes",
          "Same thing"
        ],
        "a": 1,
        "e": "Industrial produces; commercial distributes. Interdependent.",
        "h": "Industrial produces → Commercial distributes. Interdependent.",
        "yr": "SS1"
      },
      {
        "q": "A lawyer providing legal advice is:",
        "o": [
          "Industrial",
          "Commercial",
          "Professional service",
          "Extractive"
        ],
        "a": 2,
        "e": "Lawyer = professional service = service occupation.",
        "h": "Lawyer = professional service = service occupation.",
        "yr": "SS1"
      },
      {
        "q": "Quarrying (extracting stone) is:",
        "o": [
          "Manufacturing",
          "Extractive (primary) industry",
          "Service",
          "Commercial"
        ],
        "a": 1,
        "e": "Quarrying = extractive industry = takes minerals from ground.",
        "h": "Quarrying = extractive industry.",
        "yr": "SS1"
      },
      {
        "q": "Service occupations produce:",
        "o": [
          "Agricultural goods",
          "Manufactured products",
          "Intangible services (no physical product)",
          "Raw materials"
        ],
        "a": 2,
        "e": "Service = intangible services. No physical product.",
        "h": "Service = intangible services. No physical product.",
        "yr": "SS1"
      },
      {
        "q": "A supermarket selling to consumers is:",
        "o": [
          "Extractive",
          "Manufacturing",
          "Commercial (retail trade)",
          "Service"
        ],
        "a": 2,
        "e": "Supermarket = retail = commercial occupation.",
        "h": "Supermarket = retail trade = commercial occupation.",
        "yr": "SS1"
      },
      {
        "q": "Becoming a medical doctor in Nigeria requires:",
        "o": [
          "Family tradition only",
          "Educational qualifications (WAEC, UTME, 6-year medical degree)",
          "Location only",
          "Personal interest alone"
        ],
        "a": 1,
        "e": "Doctor: WAEC, UTME, 6-year medical school, housemanship, NYSC.",
        "h": "Doctor: WAEC + UTME + 6-year medical school.",
        "yr": "SS1"
      },
      {
        "q": "Cassava flour milling falls under:",
        "o": [
          "Extractive",
          "Processing (manufacturing) industrial",
          "Commercial",
          "Service"
        ],
        "a": 1,
        "e": "Flour milling = processing = manufacturing = industrial occupation.",
        "h": "Flour milling = processing = manufacturing.",
        "yr": "SS1"
      },
      {
        "q": "Which is a COMMERCIAL occupation?",
        "o": [
          "Groundnut farming",
          "Shoe manufacturing",
          "Market trading (wholesale/retail)",
          "Teaching mathematics"
        ],
        "a": 2,
        "e": "Market trading = commercial. Farming = extractive. Shoe making = manufacturing. Teaching = service.",
        "h": "Market trading = commercial occupation.",
        "yr": "SS1"
      },
      {
        "q": "How do service occupations support others?",
        "o": [
          "They don't",
          "Doctors keep workers healthy, teachers educate, lawyers advise — all supporting other sectors",
          "Services replace industrial",
          "Only government provides services"
        ],
        "a": 1,
        "e": "Services support all: doctors keep workers healthy; teachers educate; lawyers advise businesses.",
        "h": "Services support others: doctors, teachers, lawyers all support industry and commerce.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Production, Division of Labour, Specialisation and Exchange I",
    "topicCode": "SS1-COM-04",
    "module": "Production and Trade",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Production, Division of Labour, Specialisation and Exchange I</span>: Production = creating goods/services. Utilities: Form, Place, Time, Possession. Levels: Primary, Secondary, Tertiary. Factors: Land(rent), Labour(wages), Capital(interest), Enterprise(profit). Division of labour = each worker does one task.</div>",
    "questions": [
      {
        "q": "Production is best defined as:",
        "o": [
          "Only growing crops",
          "Creating/transforming resources into goods and services satisfying human wants",
          "Buying and selling in markets",
          "Manufacturing only"
        ],
        "a": 1,
        "e": "Production = creation/transformation of resources into goods/services satisfying wants.",
        "h": "Production = creating/transforming resources into goods/services.",
        "yr": "SS1"
      },
      {
        "q": "'Form utility' means:",
        "o": [
          "Moving goods to where needed",
          "Changing physical form (cotton → cloth)",
          "Storing goods until needed",
          "Transferring ownership"
        ],
        "a": 1,
        "e": "Form utility = changing physical form. E.g., cotton → cloth; cassava → garri.",
        "h": "Form utility = changing shape/form of resources.",
        "yr": "SS1"
      },
      {
        "q": "Reward for LAND is:",
        "o": [
          "Wages",
          "Interest",
          "Profit",
          "Rent"
        ],
        "a": 3,
        "e": "Land → Rent; Labour → Wages; Capital → Interest; Enterprise → Profit.",
        "h": "Land = Rent.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour means:",
        "o": [
          "Sharing work equally",
          "Breaking production into tasks, each worker does ONE specific task",
          "Dividing workers into departments",
          "Paying different wages"
        ],
        "a": 1,
        "e": "Division of labour = splitting production into stages, each worker does one task.",
        "h": "Division of labour = each worker does ONE specific task.",
        "yr": "SS1"
      },
      {
        "q": "Adam Smith's pin factory showed:",
        "o": [
          "Pins are difficult to make",
          "10 specialised workers = 48,000 pins/day vs 20 if each worked alone",
          "Pins should be imported",
          "Machines replace workers"
        ],
        "a": 1,
        "e": "10 specialised workers = 48,000 pins/day. One worker doing all = ~20. Specialisation = 2,400× output.",
        "h": "Smith's pin factory: 10 workers = 48,000 pins vs 20 alone.",
        "yr": "SS1"
      },
      {
        "q": "International specialisation means:",
        "o": [
          "Every country makes all it needs",
          "Countries focus on comparative advantage, trade for rest",
          "Countries refuse to trade",
          "Workers sent abroad"
        ],
        "a": 1,
        "e": "International specialisation: each country focuses on comparative advantage.",
        "h": "International specialisation: comparative advantage → trade for rest.",
        "yr": "SS1"
      },
      {
        "q": "CAPITAL includes:",
        "o": [
          "Natural resources",
          "Human effort",
          "Human-made tools, machines, buildings used in production",
          "Ability to organise"
        ],
        "a": 2,
        "e": "Capital = human-made resources: machines, tools, factory buildings. Reward = interest.",
        "h": "Capital = human-made resources (machines, tools, buildings). Reward = interest.",
        "yr": "SS1"
      },
      {
        "q": "Warehouse storing yams until December adds:",
        "o": [
          "Form utility",
          "Place utility",
          "Time utility — makes goods available later",
          "Possession utility"
        ],
        "a": 2,
        "e": "Warehouse = time utility: stores yams until needed (December when scarce).",
        "h": "Warehouse = time utility.",
        "yr": "SS1"
      },
      {
        "q": "Which level converts raw materials to finished goods?",
        "o": [
          "Primary (extractive)",
          "Secondary (manufacturing)",
          "Tertiary (service)",
          "Quaternary"
        ],
        "a": 1,
        "e": "Secondary/manufacturing = converts raw materials into finished goods.",
        "h": "Secondary/manufacturing = converts raw materials to finished goods.",
        "yr": "SS1"
      },
      {
        "q": "Reward for LABOUR is:",
        "o": [
          "Rent",
          "Interest",
          "Wages or salary",
          "Profit"
        ],
        "a": 2,
        "e": "Labour → Wages/Salary.",
        "h": "Labour reward = wages or salary.",
        "yr": "SS1"
      },
      {
        "q": "Regional specialisation in Nigeria shown by:",
        "o": [
          "All states producing same goods",
          "Kano (groundnuts), Benue (yams), Rivers (oil)",
          "Urban areas farming",
          "Everyone doing same job"
        ],
        "a": 1,
        "e": "Regional specialisation: Kano = groundnuts; Benue = yams; Rivers = oil.",
        "h": "Kano=groundnuts; Benue=yams; Rivers=oil. Regional specialisation.",
        "yr": "SS1"
      },
      {
        "q": "Transporter moving cocoa from Ondo to Lagos port adds:",
        "o": [
          "Form utility",
          "Time utility",
          "Place utility",
          "Possession utility"
        ],
        "a": 2,
        "e": "Transport = place utility: moves cocoa from production (Ondo) to export (Lagos port).",
        "h": "Transport = place utility.",
        "yr": "SS1"
      },
      {
        "q": "Entrepreneur is rewarded with:",
        "o": [
          "Rent",
          "Wages",
          "Interest",
          "Profit — for organising and bearing risks"
        ],
        "a": 3,
        "e": "Entrepreneur: organises production, takes risks → rewarded with profit.",
        "h": "Entrepreneur reward = Profit.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour needs large market because:",
        "o": [
          "Workers need more space",
          "High output of specialised production needs large market to absorb all goods",
          "More workers needed",
          "Large markets have better roads"
        ],
        "a": 1,
        "e": "High output from specialisation needs large market to buy all produced goods.",
        "h": "Division of labour → high output → needs large market.",
        "yr": "SS1"
      },
      {
        "q": "Tertiary level includes:",
        "o": [
          "Farming and mining",
          "Manufacturing",
          "Services: banking, trade, transport, education",
          "Extractive activities"
        ],
        "a": 2,
        "e": "Tertiary = all services: banking, insurance, transport, retail, education, medicine.",
        "h": "Tertiary = services (banking, transport, trade, medicine, education).",
        "yr": "SS1"
      },
      {
        "q": "Dangote Cement converting limestone to cement is:",
        "o": [
          "Primary",
          "Secondary (manufacturing)",
          "Tertiary",
          "Quaternary"
        ],
        "a": 1,
        "e": "Limestone → cement = manufacturing = secondary level.",
        "h": "Limestone → cement = manufacturing = secondary level.",
        "yr": "SS1"
      },
      {
        "q": "Exchange is necessary because of specialisation as:",
        "o": [
          "Exchange is not necessary",
          "Specialists only produce one thing — must trade for everything else",
          "Exchange eliminates money",
          "Only governments exchange"
        ],
        "a": 1,
        "e": "Specialists only produce one thing; must exchange for everything else needed.",
        "h": "Specialisation → only one product → must exchange for rest.",
        "yr": "SS1"
      },
      {
        "q": "'Possession utility' created by:",
        "o": [
          "Manufacturing goods",
          "Moving goods",
          "Storing goods",
          "Transferring ownership to those who want them"
        ],
        "a": 3,
        "e": "Possession utility = transferring ownership through trade/selling.",
        "h": "Possession utility = transferring ownership through trade.",
        "yr": "SS1"
      },
      {
        "q": "Which factor does a Benue yam farmer primarily provide?",
        "o": [
          "Capital only",
          "Labour — physical effort in farming",
          "Enterprise — organising farm (if owner)",
          "All: land, labour, enterprise"
        ],
        "a": 3,
        "e": "Small farm owner-farmer provides: Land (farm), Labour (effort), Enterprise (organises production).",
        "h": "Farm owner-farmer: provides Land + Labour + Enterprise.",
        "yr": "SS1"
      },
      {
        "q": "Adam Smith was:",
        "o": [
          "Nigerian economist",
          "German philosopher",
          "Scottish economist — father of economics, Wealth of Nations (1776)",
          "French politician"
        ],
        "a": 2,
        "e": "Adam Smith (1723-1790) = Scottish economist, father of modern economics.",
        "h": "Adam Smith = Scottish economist, father of economics, Wealth of Nations (1776).",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Production, Division of Labour, Specialisation and Exchange II",
    "topicCode": "SS1-COM-05",
    "module": "Production and Trade",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Production, Division of Labour, Specialisation and Exchange II</span>: Division of labour: advantages (productivity, skill, time saving, machinery, training, cost) and disadvantages (monotony, craftsmanship loss, interdependence, unemployment, large market needed, alienation).</div>",
    "questions": [
      {
        "q": "Most important advantage of division of labour:",
        "o": [
          "Eliminates education need",
          "Increased productivity — specialised workers produce far more",
          "Makes goods expensive",
          "Workers can easily change jobs"
        ],
        "a": 1,
        "e": "Most important = INCREASED PRODUCTIVITY. Specialised workers produce far more.",
        "h": "Division of labour advantage = increased productivity.",
        "yr": "SS1"
      },
      {
        "q": "Monotony and boredom as disadvantages:",
        "o": [
          "Workers overpaid",
          "Repeating same task endlessly = tedious, reduces morale/creativity",
          "Workers learn too many skills",
          "Machines do everything"
        ],
        "a": 1,
        "e": "Same repetitive task daily = monotony/boredom → reduces morale.",
        "h": "Monotony = same task endlessly → boredom.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria's crude oil dependence illustrates:",
        "o": [
          "Advantages of specialisation",
          "Disadvantage of over-specialisation — vulnerable when oil prices fall",
          "Division of labour in petroleum",
          "Regional specialisation benefiting all"
        ],
        "a": 1,
        "e": "Nigeria ≈90% forex from oil = over-specialisation disadvantage. Crashes devastate economy.",
        "h": "Nigeria oil dependence = over-specialisation disadvantage.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour encourages machinery because:",
        "o": [
          "Machines are cheaper",
          "Standardised tasks easier to automate with machines",
          "All workers prefer machines",
          "Machines never err"
        ],
        "a": 1,
        "e": "Standardised repetitive tasks (from division of labour) ideal for machine automation.",
        "h": "Standardised tasks → easier to automate with machines.",
        "yr": "SS1"
      },
      {
        "q": "'Loss of craftsmanship' means:",
        "o": [
          "Skilled workers no longer needed",
          "Workers no longer make complete product with pride — only one small part",
          "Traditional crafts earn less",
          "Machines replace craftsmen"
        ],
        "a": 1,
        "e": "Workers only do one task, lose satisfaction of making complete product.",
        "h": "Loss of craftsmanship = workers only do one task, no pride of complete product.",
        "yr": "SS1"
      },
      {
        "q": "Strike stopping entire factory illustrates:",
        "o": [
          "Monotony",
          "Interdependence/vulnerability — one group stopping halts all production",
          "Loss of craftsmanship",
          "Unemployment risk"
        ],
        "a": 1,
        "e": "Interdependence: one group striking halts entire chain.",
        "h": "Strike halts all = interdependence/vulnerability.",
        "yr": "SS1"
      },
      {
        "q": "Advantage of SPECIALISATION:",
        "o": [
          "Overdependence",
          "Vulnerability to demand changes",
          "Maximum efficiency — produce what you're best at",
          "Specialists can't switch"
        ],
        "a": 2,
        "e": "Specialisation = maximum efficiency from focusing on comparative advantage.",
        "h": "Specialisation advantage = maximum efficiency.",
        "yr": "SS1"
      },
      {
        "q": "Exchange is necessary because:",
        "o": [
          "Always leads to barter",
          "Specialists only produce one thing, must trade for everything else",
          "Eliminates money",
          "Only governments exchange"
        ],
        "a": 1,
        "e": "Specialists only produce one thing; must trade for everything else needed.",
        "h": "Specialisation → only one product → must exchange for everything else.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour reduces training time because:",
        "o": [
          "Machines do training",
          "Workers learn ONE task only, not entire process",
          "Training is free",
          "Eliminates training need"
        ],
        "a": 1,
        "e": "Learn one specific task = much faster than learning entire production process.",
        "h": "Learn only ONE task → less training time.",
        "yr": "SS1"
      },
      {
        "q": "Credit exchange differs because:",
        "o": [
          "Credit uses barter",
          "Credit = get goods now, pay money later",
          "Credit for large businesses only",
          "Credit never involves money"
        ],
        "a": 1,
        "e": "Credit exchange: get goods now, pay later.",
        "h": "Credit exchange = get goods now, pay money LATER.",
        "yr": "SS1"
      },
      {
        "q": "City relying entirely on leather faces:",
        "o": [
          "Benefit from diversification",
          "Risk of unemployment if leather declines — over-specialisation",
          "Guaranteed employment",
          "No risk"
        ],
        "a": 1,
        "e": "Over-specialisation: if industry declines, widespread unemployment.",
        "h": "Over-specialisation: industry declines → mass unemployment.",
        "yr": "SS1"
      },
      {
        "q": "Jumia marketplace represents:",
        "o": [
          "Barter",
          "Traditional money exchange",
          "Electronic exchange (e-commerce)",
          "Credit with no payment"
        ],
        "a": 2,
        "e": "Jumia = e-commerce = electronic exchange through digital platform.",
        "h": "Jumia = e-commerce = electronic exchange.",
        "yr": "SS1"
      },
      {
        "q": "Specialisation needs large market because:",
        "o": [
          "Employ more workers",
          "High output needs large market to absorb all goods",
          "Markets decide speciality",
          "Small markets more efficient"
        ],
        "a": 1,
        "e": "Specialisation → high output → needs large market to sell all goods.",
        "h": "Specialisation → high output → needs large market.",
        "yr": "SS1"
      },
      {
        "q": "Worker 'alienation' means:",
        "o": [
          "Workers become foreign",
          "Disconnected from work/product — reduced motivation",
          "Workers hostile to managers",
          "Workers paid in foreign currency"
        ],
        "a": 1,
        "e": "Alienation: workers feel disconnected from work and final product.",
        "h": "Alienation = disconnected from work and product.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour reduces unit cost because:",
        "o": [
          "Workers paid less",
          "More output from same workers spreads fixed costs — lower cost per unit",
          "Machines are free",
          "Raw materials cheaper"
        ],
        "a": 1,
        "e": "Higher output → fixed costs spread over more units → lower unit cost.",
        "h": "Higher output → same fixed costs → lower unit cost.",
        "yr": "SS1"
      },
      {
        "q": "Kaduna textile factory workers doing specific tasks:",
        "o": [
          "International specialisation",
          "Regional specialisation",
          "Division of labour within manufacturing",
          "Barter exchange"
        ],
        "a": 2,
        "e": "Workers each doing specific tasks in cloth production = division of labour.",
        "h": "Factory workers doing specific tasks = division of labour.",
        "yr": "SS1"
      },
      {
        "q": "E-commerce advantages:",
        "o": [
          "Requires no payment",
          "24/7 transactions across distances without physical presence",
          "Eliminates need for products",
          "Only for corporations"
        ],
        "a": 1,
        "e": "E-commerce: 24/7, across distances, no physical presence needed.",
        "h": "E-commerce: 24/7 transactions, across distances.",
        "yr": "SS1"
      },
      {
        "q": "Division of labour 'stimulates invention' because:",
        "o": [
          "Workers become bored and invent games",
          "Workers find improved methods from repeating same task",
          "Managers invent things",
          "Machines auto-improve"
        ],
        "a": 1,
        "e": "Workers repeating same task often find better methods → innovations.",
        "h": "Repeating tasks → discover improvements → invention.",
        "yr": "SS1"
      },
      {
        "q": "Advantage of specialisation for countries:",
        "o": [
          "All goods produced domestically",
          "Increased trade — export speciality, import others'",
          "No need for imports",
          "All become self-sufficient"
        ],
        "a": 1,
        "e": "Specialisation → international trade: export your speciality, import others'.",
        "h": "Specialisation → international trade opportunities.",
        "yr": "SS1"
      },
      {
        "q": "Exchange is necessary in modern economy because:",
        "o": [
          "People are greedy",
          "Specialisation — no one produces everything they need",
          "Government requires it",
          "Money must circulate"
        ],
        "a": 1,
        "e": "Specialised people/firms/countries don't produce everything — must trade.",
        "h": "Specialisation → no one produces everything → exchange necessary.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Trade",
    "topicCode": "SS1-COM-06",
    "module": "Trade",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Trade</span>: Trade = buying/selling goods/services. Types: Home Trade (domestic — wholesale/retail) and Foreign Trade (import/export/entrepôt). Channels: direct, semi-direct, indirect.</div>",
    "questions": [
      {
        "q": "Trade is defined as:",
        "o": [
          "Only buying from foreign countries",
          "Voluntary exchange of goods/services between buyers and sellers",
          "Only selling to consumers",
          "Producing goods in factories"
        ],
        "a": 1,
        "e": "Trade = voluntary exchange of goods/services between buyers and sellers.",
        "h": "Trade = voluntary exchange (buying and selling).",
        "yr": "SS1"
      },
      {
        "q": "A wholesaler:",
        "o": [
          "Sells small quantities to final consumers",
          "Buys large from manufacturers, sells smaller to retailers",
          "Produces goods",
          "Imports from other countries"
        ],
        "a": 1,
        "e": "Wholesaler: buys LARGE from manufacturers → breaks bulk → sells SMALLER to retailers.",
        "h": "Wholesaler: buys large → sells smaller to retailers.",
        "yr": "SS1"
      },
      {
        "q": "A retailer:",
        "o": [
          "Buys in larger quantities",
          "Sells SMALL quantities to FINAL CONSUMERS",
          "Only sells imported goods",
          "Produces goods"
        ],
        "a": 1,
        "e": "Retailer: buys from wholesalers, sells SMALL quantities to FINAL CONSUMERS.",
        "h": "Retailer = sells small quantities to FINAL CONSUMERS.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria exporting crude oil is:",
        "o": [
          "Import trade",
          "Wholesale trade",
          "Export trade",
          "Entrepôt trade"
        ],
        "a": 2,
        "e": "Selling Nigerian goods to other countries = EXPORT TRADE.",
        "h": "Export = selling Nigerian goods to other countries.",
        "yr": "SS1"
      },
      {
        "q": "Entrepôt trade involves:",
        "o": [
          "Producing goods for export",
          "Importing to sell domestically",
          "Importing goods specifically to re-export to other countries",
          "Trading within one region"
        ],
        "a": 2,
        "e": "Entrepôt = import from one country, re-export to others. Trading hub.",
        "h": "Entrepôt = import to re-export.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria importing refined petroleum is:",
        "o": [
          "Export trade",
          "Entrepôt trade",
          "Import trade",
          "Wholesale trade"
        ],
        "a": 2,
        "e": "Nigeria buying from Europe = IMPORT TRADE.",
        "h": "Nigeria importing petroleum = import trade.",
        "yr": "SS1"
      },
      {
        "q": "Home trade is also called:",
        "o": [
          "Foreign or international trade",
          "Internal or domestic trade — within national borders",
          "Export trade",
          "Wholesale trade only"
        ],
        "a": 1,
        "e": "Home trade = internal = domestic trade within Nigeria's borders.",
        "h": "Home trade = internal/domestic trade.",
        "yr": "SS1"
      },
      {
        "q": "'Producer → Wholesaler → Retailer → Consumer' is the:",
        "o": [
          "Direct channel",
          "Short channel",
          "Indirect (long) channel",
          "Agent channel"
        ],
        "a": 2,
        "e": "Multiple intermediaries = INDIRECT (LONG) CHANNEL.",
        "h": "Producer → Wholesaler → Retailer → Consumer = indirect channel.",
        "yr": "SS1"
      },
      {
        "q": "Palm oil producer selling directly to consumers uses:",
        "o": [
          "Indirect channel",
          "Direct channel (Producer → Consumer)",
          "Entrepôt channel",
          "Wholesale"
        ],
        "a": 1,
        "e": "DIRECT CHANNEL: Producer → Consumer. No intermediaries.",
        "h": "Direct channel = Producer → Consumer.",
        "yr": "SS1"
      },
      {
        "q": "Trade creates employment through:",
        "o": [
          "Reducing workers",
          "Millions employed as traders, wholesalers, retailers, importers, exporters",
          "Eliminating agriculture",
          "Only bank jobs"
        ],
        "a": 1,
        "e": "Trade employs millions: traders, wholesalers, retailers, importers, exporters, logistics.",
        "h": "Trade employment: traders, wholesalers, retailers, importers, exporters.",
        "yr": "SS1"
      },
      {
        "q": "Which is foreign trade?",
        "o": [
          "Lagos trader buying from Kano manufacturer",
          "Jos woman buying at local market",
          "Nigerian company exporting sesame to China",
          "Wholesale dealer selling rice to retailers"
        ],
        "a": 2,
        "e": "Sesame to China = crossing international borders = FOREIGN TRADE (export).",
        "h": "Sesame to China = foreign export trade.",
        "yr": "SS1"
      },
      {
        "q": "Trade eliminates surplus/shortage by:",
        "o": [
          "Stopping production",
          "Moving goods from areas of surplus to areas of shortage",
          "Destroying excess goods",
          "Raising prices to reduce demand"
        ],
        "a": 1,
        "e": "Trade moves goods from where plentiful to where scarce.",
        "h": "Trade moves goods from surplus areas to shortage areas.",
        "yr": "SS1"
      },
      {
        "q": "Onitsha Main Market is primarily:",
        "o": [
          "Foreign trade",
          "Domestic wholesale trade",
          "Entrepôt trade",
          "Agricultural production"
        ],
        "a": 1,
        "e": "Onitsha Main Market = primarily domestic wholesale trade.",
        "h": "Onitsha = domestic wholesale trade.",
        "yr": "SS1"
      },
      {
        "q": "Government revenue from foreign trade:",
        "o": [
          "Income tax only",
          "Import duties, export levies (Nigeria Customs)",
          "Trader salaries",
          "Market stall rents"
        ],
        "a": 1,
        "e": "Customs collects import duties and export levies. Non-oil revenue source.",
        "h": "Foreign trade revenue: import duties + export levies (Customs Service).",
        "yr": "SS1"
      },
      {
        "q": "Cocoa from Nigeria sold to European chocolate company is:",
        "o": [
          "Home wholesale trade",
          "Retail trade",
          "Foreign export trade",
          "Entrepôt trade"
        ],
        "a": 2,
        "e": "Nigerian cocoa to Europe = crossing borders = foreign export trade.",
        "h": "Cocoa to Europe = foreign export trade.",
        "yr": "SS1"
      },
      {
        "q": "Manufacturer selling directly to supermarket (no wholesaler) uses:",
        "o": [
          "Indirect channel",
          "Semi-direct channel (Producer → Retailer → Consumer)",
          "Direct channel",
          "Agent channel"
        ],
        "a": 1,
        "e": "No wholesaler: Producer → Retailer → Consumer = SEMI-DIRECT CHANNEL.",
        "h": "No wholesaler = semi-direct channel.",
        "yr": "SS1"
      },
      {
        "q": "Trade promotes international relations because:",
        "o": [
          "Eliminates cultural differences",
          "Economic ties, mutual dependency, cultural exchanges build diplomacy",
          "Allows countries to avoid each other",
          "Replaces diplomacy"
        ],
        "a": 1,
        "e": "Trade builds relationships through economic ties, cultural exchanges, mutual dependency.",
        "h": "Trade builds international relations.",
        "yr": "SS1"
      },
      {
        "q": "Trade promotes specialisation by:",
        "o": [
          "Forcing all to produce same goods",
          "Providing markets so producers can specialise knowing trade will distribute output",
          "Teaching specialised skills",
          "Replacing specialisation"
        ],
        "a": 1,
        "e": "Trade provides markets for specialised output.",
        "h": "Trade enables specialisation by providing markets.",
        "yr": "SS1"
      },
      {
        "q": "Visible trade involves:",
        "o": [
          "Trade visible on TV",
          "Exchange of physical tangible goods across borders",
          "Trade in services",
          "Illegal hidden trade"
        ],
        "a": 1,
        "e": "Visible trade = trade in physical goods. Invisible = services.",
        "h": "Visible trade = physical goods crossing borders.",
        "yr": "SS1"
      },
      {
        "q": "Most common channel for manufactured consumer goods:",
        "o": [
          "Direct",
          "Semi-direct",
          "Indirect (producer→wholesaler→retailer→consumer)",
          "No channel"
        ],
        "a": 2,
        "e": "Most common for manufactured goods = indirect channel.",
        "h": "Most common = indirect channel (producer→wholesaler→retailer→consumer).",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Home Trade",
    "topicCode": "SS1-COM-07",
    "module": "Trade",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Home Trade</span>: Home trade = domestic/internal trade. Wholesale: buys large from manufacturers, sells smaller to retailers. Functions: breaking bulk, warehousing, risk-bearing, financing, transport, information. Retail: sells small to final consumers.</div>",
    "questions": [
      {
        "q": "Home trade is also known as:",
        "o": [
          "Foreign/export trade",
          "Internal/domestic trade — within national borders",
          "Wholesale only",
          "Import trade"
        ],
        "a": 1,
        "e": "Home trade = internal/domestic trade within Nigeria's borders.",
        "h": "Home trade = internal/domestic trade.",
        "yr": "SS1"
      },
      {
        "q": "Wholesaler's primary function:",
        "o": [
          "Sell small to final consumers",
          "Buy large from manufacturers, sell smaller to retailers",
          "Export goods",
          "Produce goods"
        ],
        "a": 1,
        "e": "Wholesaler: buys LARGE from manufacturers → sells SMALLER to retailers.",
        "h": "Wholesaler: large from manufacturers → smaller to retailers.",
        "yr": "SS1"
      },
      {
        "q": "'Breaking bulk' means:",
        "o": [
          "Destroying damaged goods",
          "Buying large quantities and splitting into smaller lots for retailers",
          "Reducing prices",
          "Moving by truck"
        ],
        "a": 1,
        "e": "Breaking bulk: buying huge quantities from manufacturer, splitting into smaller lots for retailers.",
        "h": "Breaking bulk = split large consignments into smaller lots for retailers.",
        "yr": "SS1"
      },
      {
        "q": "Which is a retailer?",
        "o": [
          "Wholesale dealer buying 1000 bags rice",
          "Manufacturer selling to manufacturer",
          "Shoprite selling groceries to household consumers",
          "Shipping company"
        ],
        "a": 2,
        "e": "Shoprite = retailer: sells to final household consumers in small quantities.",
        "h": "Shoprite = retailer = sells to final consumers.",
        "yr": "SS1"
      },
      {
        "q": "Wholesaler warehousing helps manufacturers by:",
        "o": [
          "Providing raw materials",
          "Storing finished goods — relieves manufacturers of storage burden",
          "Transporting to factories",
          "Advertising their products"
        ],
        "a": 1,
        "e": "Warehousing relieves manufacturers: they produce continuously while wholesalers store output.",
        "h": "Wholesaler warehousing relieves manufacturer of storage burden.",
        "yr": "SS1"
      },
      {
        "q": "Retailer passes market information to producers by:",
        "o": [
          "Producing goods for producers",
          "Informing manufacturers about consumer preferences, complaints, demand trends",
          "Advertising for manufacturers",
          "Providing transport"
        ],
        "a": 1,
        "e": "Retailers observe consumer preferences and pass market intelligence to manufacturers.",
        "h": "Retailers pass consumer preferences and complaints to manufacturers.",
        "yr": "SS1"
      },
      {
        "q": "Which retailer has no fixed store?",
        "o": [
          "Supermarket",
          "Department store",
          "Online retailer",
          "Hawker/mobile trader"
        ],
        "a": 3,
        "e": "Hawkers/mobile traders sell from trays/pushcarts while moving. No fixed store.",
        "h": "Hawker = no fixed store, sells while moving.",
        "yr": "SS1"
      },
      {
        "q": "Advantage of home trade over foreign:",
        "o": [
          "Greater variety",
          "No transport needed",
          "No exchange rate complications — all in Nigerian naira",
          "Access to cheaper foreign goods"
        ],
        "a": 2,
        "e": "Home trade: all in NAIRA — no forex complications.",
        "h": "Home trade: all in naira, no exchange rate complications.",
        "yr": "SS1"
      },
      {
        "q": "Jumia selling online to consumers is a:",
        "o": [
          "Wholesale dealer",
          "Manufacturer",
          "Online retailer (e-tailer)",
          "Exporter"
        ],
        "a": 2,
        "e": "Jumia = online retailer: sells to final consumers through website/app.",
        "h": "Jumia = online retailer (e-tailer).",
        "yr": "SS1"
      },
      {
        "q": "Manufacturers prefer wholesalers because:",
        "o": [
          "Retailers earn more",
          "Wholesalers buy large, pay promptly, relieve manufacturer of storage",
          "Retailers charge too much",
          "Manufacturers can't sell directly"
        ],
        "a": 1,
        "e": "Wholesalers: large immediate purchases, relieve manufacturer of storage and marketing.",
        "h": "Manufacturers prefer wholesalers: large purchases + relieve storage and marketing.",
        "yr": "SS1"
      },
      {
        "q": "Limitation of home trade:",
        "o": [
          "All in same currency",
          "Limited to domestically produced goods only",
          "No taxes",
          "Easy dispute resolution"
        ],
        "a": 1,
        "e": "Home trade limitation: confined to goods produced domestically.",
        "h": "Home trade: limited to domestically produced goods.",
        "yr": "SS1"
      },
      {
        "q": "Retailer extending credit means:",
        "o": [
          "Lends money directly",
          "Allows trusted customers to buy now, pay later",
          "Provides bank loans",
          "Gives goods free"
        ],
        "a": 1,
        "e": "Trade credit: trusted customers take goods, pay later (end of month).",
        "h": "Retailer credit: trusted customers buy now, pay later.",
        "yr": "SS1"
      },
      {
        "q": "Balogun Market Lagos is:",
        "o": [
          "Online retailer",
          "Supermarket",
          "Traditional open market",
          "Department store"
        ],
        "a": 2,
        "e": "Balogun Market = traditional open market with many individual stall-based traders.",
        "h": "Balogun Market = traditional open market.",
        "yr": "SS1"
      },
      {
        "q": "Wholesaler paying manufacturer promptly and giving retailers 30-day credit performs:",
        "o": [
          "Advertising and transport",
          "Financing — paying manufacturer + credit to retailers",
          "Breaking bulk only",
          "Risk-bearing only"
        ],
        "a": 1,
        "e": "FINANCING: pays manufacturer immediately AND gives retailers 30-day credit.",
        "h": "Wholesaler financing: pays manufacturer + gives retailers credit.",
        "yr": "SS1"
      },
      {
        "q": "Retailer after-sales service benefits consumers by:",
        "o": [
          "Makes goods expensive",
          "Delivery, installation, repair, exchange of defective goods after purchase",
          "Helps manufacturers",
          "Only for luxury goods"
        ],
        "a": 1,
        "e": "After-sales: delivery, installation, repair, exchange → benefits consumers.",
        "h": "After-sales: delivery, installation, repair, exchange.",
        "yr": "SS1"
      },
      {
        "q": "Why more retailers than wholesalers?",
        "o": [
          "Retailers are better businesspeople",
          "Each retailer serves few consumers; millions of consumers need many retailers",
          "Wholesalers need more capital",
          "Retailers need no qualifications"
        ],
        "a": 1,
        "e": "Each retailer serves small local area. Millions of consumers need many retailers.",
        "h": "More retailers: each serves few consumers; millions of consumers need many.",
        "yr": "SS1"
      },
      {
        "q": "Shoprite and Prince Ebeano are:",
        "o": [
          "Traditional market traders",
          "Online retailers",
          "Supermarkets — large self-service, wide variety, checkout payment",
          "Department stores"
        ],
        "a": 2,
        "e": "Shoprite, Prince Ebeano = supermarkets: large, self-service, checkout.",
        "h": "Shoprite, Prince Ebeano = supermarkets.",
        "yr": "SS1"
      },
      {
        "q": "Provision store buying 100 boxes Peak Milk, selling tins to neighbours is:",
        "o": [
          "Wholesaler — buying in bulk",
          "Retailer — buying moderate amounts, selling small units to consumers",
          "Manufacturer",
          "Importer"
        ],
        "a": 1,
        "e": "Provision store = retailer: buys moderate, sells small units to final consumers.",
        "h": "Provision store = retailer.",
        "yr": "SS1"
      },
      {
        "q": "Wholesaler 'risk-bearing' means:",
        "o": [
          "Physical risks in warehouses",
          "Bearing commercial risks — price changes, spoilage, unsold stock",
          "Risking customer complaints",
          "Taking legal risks"
        ],
        "a": 1,
        "e": "Wholesaler bears commercial risks: prices may fall, goods may spoil, may not sell all stock.",
        "h": "Wholesaler risk-bearing: holds stock bearing price/spoilage/unsold risks.",
        "yr": "SS1"
      },
      {
        "q": "Wholesaler 'stabilising prices' works by:",
        "o": [
          "Setting maximum prices",
          "Buying in bulk during glut, selling during scarcity — smoothing price fluctuations",
          "Negotiating with government",
          "Advertising prices"
        ],
        "a": 1,
        "e": "Buy cheap in glut, store, release gradually → smooths seasonal price fluctuations.",
        "h": "Wholesaler stabilises prices: buys cheap in glut, releases gradually.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Foreign Trade",
    "topicCode": "SS1-COM-08",
    "module": "Trade",
    "term": "First Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Foreign Trade</span>: Foreign trade = trade between countries. Types: Import, Export, Entrepôt. Merits: access to unavailable goods, forex, specialisation, technology transfer. Demerits: dumping, trade deficit, over-dependence, exchange rate risk.</div>",
    "questions": [
      {
        "q": "Foreign trade refers to:",
        "o": [
          "Trade between regions within Nigeria",
          "Trade between companies of same nationality",
          "Buying/selling goods/services between different countries",
          "Trade by foreigners within Nigeria"
        ],
        "a": 2,
        "e": "FOREIGN TRADE = trade crossing national boundaries.",
        "h": "Foreign trade = trade between countries.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria's main export (≈90% of earnings):",
        "o": [
          "Cocoa beans",
          "Sesame seeds",
          "Crude oil",
          "Cassava and yams"
        ],
        "a": 2,
        "e": "Crude oil ≈90% of Nigeria's forex earnings.",
        "h": "Nigeria's main export = crude oil.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria importing rice from Thailand is:",
        "o": [
          "Export trade",
          "Entrepôt trade",
          "Import trade",
          "Wholesale trade"
        ],
        "a": 2,
        "e": "Nigeria buying rice from Thailand = IMPORT TRADE.",
        "h": "Nigeria buying rice from Thailand = import trade.",
        "yr": "SS1"
      },
      {
        "q": "'Dumping' means:",
        "o": [
          "Throwing away excess goods",
          "Cheap foreign goods flooding local market, destroying domestic industries",
          "Illegal waste disposal",
          "Exporting below market price"
        ],
        "a": 1,
        "e": "Dumping: foreign goods sold at artificially low prices, destroying local industries.",
        "h": "Dumping = cheap foreign goods flood local market → destroy domestic industries.",
        "yr": "SS1"
      },
      {
        "q": "NAFDAC's role in foreign trade:",
        "o": [
          "Collects import duties",
          "Ensures imported food/drugs meet Nigerian safety standards",
          "Promotes non-oil exports",
          "Manages seaports"
        ],
        "a": 1,
        "e": "NAFDAC: ensures imported food, drugs, consumer goods meet Nigerian safety standards.",
        "h": "NAFDAC = ensures safety of imported food/drugs.",
        "yr": "SS1"
      },
      {
        "q": "Balance of trade DEFICIT occurs when:",
        "o": [
          "Exports exceed imports",
          "Imports exceed exports — spending more on foreign goods than earning",
          "Exports equal imports",
          "No foreign trade"
        ],
        "a": 1,
        "e": "Deficit = imports > exports. Nigeria faces deficit when oil prices are low.",
        "h": "Trade deficit = imports > exports.",
        "yr": "SS1"
      },
      {
        "q": "NEPC was established to:",
        "o": [
          "Collect import duties",
          "Promote Nigeria's non-oil exports (cocoa, sesame, cashew)",
          "Regulate banking",
          "Control import prices"
        ],
        "a": 1,
        "e": "NEPC = Nigerian Export Promotion Council. Develops non-oil exports.",
        "h": "NEPC = promotes non-oil exports.",
        "yr": "SS1"
      },
      {
        "q": "A MERIT of foreign trade:",
        "o": [
          "Creates trade deficits",
          "Encourages dumping",
          "Provides access to goods not produced domestically",
          "Increases smuggling"
        ],
        "a": 2,
        "e": "Key merit: access to goods not produced efficiently domestically.",
        "h": "Foreign trade merit: access goods not available domestically.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria Customs Service's role:",
        "o": [
          "Produces export goods",
          "Collects import duties, enforces trade laws, prevents smuggling",
          "Manages forex reserves",
          "Advertises Nigerian products"
        ],
        "a": 1,
        "e": "Customs: collects import duties, enforces laws, prevents smuggling.",
        "h": "Customs: import duties + trade laws + prevents smuggling.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria exports crude oil but imports refined petroleum because:",
        "o": [
          "Nigeria chooses not to use its own oil",
          "Nigeria's refineries are non-functional — crude exported, refined products reimported",
          "Refined petroleum cheaper abroad",
          "Other countries need crude more"
        ],
        "a": 1,
        "e": "Nigeria's paradox: produces crude oil but imports refined petroleum (refineries non-functional).",
        "h": "Nigeria crude oil paradox: exports crude, imports refined (refineries broken).",
        "yr": "SS1"
      },
      {
        "q": "Technology transfer from foreign trade means:",
        "o": [
          "Nigerians go abroad to study",
          "Trade brings new technologies, equipment, techniques from advanced countries",
          "Nigeria exports its technology",
          "Technology traded like commodity"
        ],
        "a": 1,
        "e": "Technology transfer: importing advanced machinery, FDI introduces modern techniques.",
        "h": "Technology transfer: new machines, techniques come with imports and FDI.",
        "yr": "SS1"
      },
      {
        "q": "Entrepôt at Nigerian ports:",
        "o": [
          "Nigeria produces all goods for West Africa",
          "Ports are transit hubs for landlocked neighbours (Niger, Chad, Mali)",
          "Traders buy cheaply to keep",
          "No duties at ports"
        ],
        "a": 1,
        "e": "Nigeria's ports re-export to landlocked neighbours: Niger, Chad, Mali.",
        "h": "Nigeria entrepôt: ports re-export to Niger, Chad, Mali.",
        "yr": "SS1"
      },
      {
        "q": "Exchange rate risk means:",
        "o": [
          "No exchange rate in foreign trade",
          "Naira value fluctuations affect import costs and export revenues",
          "Exchange rates always stable",
          "Only oil companies face this"
        ],
        "a": 1,
        "e": "Exchange rate risk: naira depreciation → imports more expensive.",
        "h": "Exchange rate risk: naira changes affect import costs and export revenues.",
        "yr": "SS1"
      },
      {
        "q": "Comparative advantage means:",
        "o": [
          "Stronger armies control trade",
          "Countries specialise where lower opportunity cost, trade for rest",
          "Trade fair only when equal",
          "Large countries always win"
        ],
        "a": 1,
        "e": "Comparative advantage: each country specialises where lower opportunity cost.",
        "h": "Comparative advantage: specialise where lower opportunity cost → trade benefits all.",
        "yr": "SS1"
      },
      {
        "q": "Crude oil sold to foreign countries is:",
        "o": [
          "Nigerian musicians performing abroad",
          "Remote services by Nigerian engineers",
          "Visible export — tangible physical good",
          "Banking services to foreigners"
        ],
        "a": 2,
        "e": "Visible exports = tangible physical goods (crude oil, cocoa). Invisible = services.",
        "h": "Visible export = physical goods crossing borders.",
        "yr": "SS1"
      },
      {
        "q": "Security risk of foreign trade:",
        "o": [
          "Stable exchange rates",
          "Importation of dangerous goods — weapons, drugs — threatening national security",
          "Domestic companies competing",
          "High tariffs"
        ],
        "a": 1,
        "e": "Security risk: illegal weapons, drugs, counterfeits imported through trade channels.",
        "h": "Security risk: illegal weapons/drugs imported through trade channels.",
        "yr": "SS1"
      },
      {
        "q": "NPA supports foreign trade by:",
        "o": [
          "Collecting import duties",
          "Managing seaports (Lagos, Port Harcourt, Warri, Calabar) for cargo",
          "Ensuring food safety",
          "Promoting non-oil exports"
        ],
        "a": 1,
        "e": "NPA manages Nigeria's seaports — cargo loading/unloading infrastructure.",
        "h": "NPA = manages seaports for cargo. Essential foreign trade infrastructure.",
        "yr": "SS1"
      },
      {
        "q": "Over-dependence on imports means:",
        "o": [
          "Makes country richer",
          "Relying heavily on imports for essentials creates vulnerability if supply disrupted",
          "Imports always expensive",
          "Domestic goods always better"
        ],
        "a": 1,
        "e": "Over-dependence: if import supply disrupted, economy severely affected.",
        "h": "Over-dependence on imports = vulnerable if supply disrupted.",
        "yr": "SS1"
      },
      {
        "q": "CBN's role in foreign trade:",
        "o": [
          "Inspects imported goods",
          "Manages forex, regulates banks, oversees payment systems for international trade",
          "Promotes non-oil exports",
          "Manages seaports"
        ],
        "a": 1,
        "e": "CBN: manages Nigeria's forex, regulates banks, oversees international payments.",
        "h": "CBN: manages forex + regulates banks + oversees international payments.",
        "yr": "SS1"
      },
      {
        "q": "Smuggling as foreign trade problem occurs because:",
        "o": [
          "Goods exported legally",
          "High tariffs make it profitable to import illegally — avoiding duties",
          "All traders cheat",
          "Only involves drugs"
        ],
        "a": 1,
        "e": "High import duties → profitable to import illegally → revenue loss + unfair competition.",
        "h": "Smuggling: high tariffs → import illegally → revenue loss + unfair competition.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Commodity Exchange I",
    "topicCode": "SS1-COM-09",
    "module": "Trade",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Commodity Exchange I</span>: Commodity exchange = organised market for primary products. Spot (immediate) vs futures (future delivery). Hedging = reduce price risk. NCE. Nigeria = 4th largest cocoa producer, world's largest sesame exporter.</div>",
    "questions": [
      {
        "q": "A commodity exchange is:",
        "o": [
          "A shop selling consumer goods",
          "An organised market where primary products are bought and sold",
          "A stock exchange for shares",
          "A foreign currency market"
        ],
        "a": 1,
        "e": "Commodity exchange = organised market for primary/raw materials.",
        "h": "Commodity exchange = organised market for buying/selling primary products.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria's commodity exchange:",
        "o": [
          "NGX (stock exchange)",
          "Nigerian Commodity Exchange (NCE)",
          "CBN",
          "NEPC"
        ],
        "a": 1,
        "e": "NCE = Nigerian Commodity Exchange, Abuja.",
        "h": "Nigeria's commodity exchange = NCE.",
        "yr": "SS1"
      },
      {
        "q": "A SPOT market means:",
        "o": [
          "Trading at specific location",
          "Immediate buying/selling with immediate delivery and payment",
          "Trading for future delivery",
          "Trading foreign currencies"
        ],
        "a": 1,
        "e": "SPOT MARKET: goods bought/sold for IMMEDIATE delivery at current price.",
        "h": "Spot market = immediate delivery and payment.",
        "yr": "SS1"
      },
      {
        "q": "A FUTURES market involves:",
        "o": [
          "Immediate delivery",
          "Agreeing on price now for delivery and payment at a future date",
          "Trading only manufactured goods",
          "Daily cash settlement only"
        ],
        "a": 1,
        "e": "FUTURES: agree NOW on price for future delivery.",
        "h": "Futures = agree price now for future delivery.",
        "yr": "SS1"
      },
      {
        "q": "Which is traded on a commodity exchange?",
        "o": [
          "Company shares and bonds",
          "Crude oil, cocoa, sesame seeds — primary products",
          "Foreign currencies only",
          "Government bonds only"
        ],
        "a": 1,
        "e": "Commodities: agricultural (cocoa, sesame) and mineral/energy (crude oil, tin).",
        "h": "Commodities = primary products (cocoa, crude oil, sesame, tin).",
        "yr": "SS1"
      },
      {
        "q": "HEDGING in commodity trading means:",
        "o": [
          "Speculating for large profits",
          "Using futures to reduce/protect against adverse price changes",
          "Growing crops behind hedges",
          "Trading only safe commodities"
        ],
        "a": 1,
        "e": "HEDGING: using futures contracts to reduce price risk.",
        "h": "Hedging = using futures to protect against price changes.",
        "yr": "SS1"
      },
      {
        "q": "A cocoa farmer uses futures to:",
        "o": [
          "Sell farm shares",
          "Lock in a guaranteed price before harvest — protection against price falls",
          "Borrow from bank",
          "Import cocoa"
        ],
        "a": 1,
        "e": "Cocoa futures: farmer locks in price before harvest — protected against price fall.",
        "h": "Cocoa farmer uses futures to lock in price before harvest.",
        "yr": "SS1"
      },
      {
        "q": "Commodity exchanges benefit producers by:",
        "o": [
          "Eliminating need to produce",
          "Providing transparent pricing, reducing exploitation by middlemen",
          "Making production expensive",
          "Requiring government sales only"
        ],
        "a": 1,
        "e": "Exchanges: transparent prices, reduced middlemen exploitation.",
        "h": "Commodity exchange: transparent prices, reduces middlemen exploitation.",
        "yr": "SS1"
      },
      {
        "q": "World's largest commodity exchange:",
        "o": [
          "Nigeria",
          "United Kingdom",
          "USA — Chicago Mercantile Exchange (CME)",
          "China"
        ],
        "a": 2,
        "e": "CME (Chicago Mercantile Exchange) = world's largest.",
        "h": "World's largest commodity exchange = CME, USA.",
        "yr": "SS1"
      },
      {
        "q": "Agricultural commodities at NCE include:",
        "o": [
          "Cars and electronics",
          "Cocoa, palm oil, sesame seeds, groundnuts, maize",
          "Government bonds",
          "Foreign currencies"
        ],
        "a": 1,
        "e": "NCE trades: cocoa, palm oil, sesame, groundnuts, soya, maize.",
        "h": "NCE trades: cocoa, palm oil, sesame, groundnuts.",
        "yr": "SS1"
      },
      {
        "q": "Price SPECULATION means:",
        "o": [
          "Setting minimum prices",
          "Buying expecting price rise (or selling expecting fall) to profit from price changes",
          "Ensuring stable prices",
          "Government price control"
        ],
        "a": 1,
        "e": "SPECULATION: trade on expected price movements for profit.",
        "h": "Speculation = trade on expected price movements for profit.",
        "yr": "SS1"
      },
      {
        "q": "Quality grading is important because:",
        "o": [
          "Makes commodities expensive",
          "Standardises quality so buyers know what they get without physical inspection",
          "Limits who can sell",
          "Prevents foreign buyers"
        ],
        "a": 1,
        "e": "Quality grading: standard grades so buyers know quality without inspection.",
        "h": "Quality grading: buyers know quality without physical inspection.",
        "yr": "SS1"
      },
      {
        "q": "Which is a MINERAL commodity?",
        "o": [
          "Cocoa beans",
          "Palm oil",
          "Crude oil and tin",
          "Sesame seeds"
        ],
        "a": 2,
        "e": "Mineral/energy commodities: crude oil, natural gas, gold, tin.",
        "h": "Mineral commodities: crude oil, tin, gold.",
        "yr": "SS1"
      },
      {
        "q": "Disadvantage for small Nigerian farmers:",
        "o": [
          "Prices too high",
          "May lack access, knowledge, or capital to participate in formal exchanges",
          "Exchanges reduce prices",
          "Only for foreign goods"
        ],
        "a": 1,
        "e": "Small farmers: minimum lots too large, strict quality grades, poor logistics.",
        "h": "Small farmers: lack access, knowledge, capital for formal exchanges.",
        "yr": "SS1"
      },
      {
        "q": "Commodity exchanges stabilise prices by:",
        "o": [
          "Setting fixed government prices",
          "Providing transparent marketplace where supply/demand determines prices",
          "Subsidising producers",
          "Importing cheaper goods"
        ],
        "a": 1,
        "e": "Price stability through transparency: exchange prices reflect actual supply/demand.",
        "h": "Commodity exchange stabilises prices through transparent price discovery.",
        "yr": "SS1"
      },
      {
        "q": "'Open outcry' trading refers to:",
        "o": [
          "Shouting at customers",
          "Traditional floor trading — traders shout bids/offers (now largely electronic)",
          "Government price announcements",
          "Producer protests"
        ],
        "a": 1,
        "e": "Open outcry: traditional method where traders shout/signal bids on floor.",
        "h": "Open outcry = traditional floor trading method.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria's role in cocoa markets:",
        "o": [
          "Largest cocoa producer",
          "4th largest cocoa producer — major non-oil agricultural export",
          "All cocoa processed domestically",
          "Imports cocoa"
        ],
        "a": 1,
        "e": "Nigeria = 4th largest cocoa producer. Ondo, Oyo, Ekiti, Osun, Cross River States.",
        "h": "Nigeria = 4th largest cocoa producer.",
        "yr": "SS1"
      },
      {
        "q": "Futures price vs spot price:",
        "o": [
          "Always the same",
          "They differ — futures reflects storage costs, interest, and future supply/demand",
          "Futures always higher",
          "Spot always higher"
        ],
        "a": 1,
        "e": "Futures ≠ spot. Reflects storage costs, interest, future expectations.",
        "h": "Futures ≠ spot. Reflects future expectations and storage costs.",
        "yr": "SS1"
      },
      {
        "q": "Commodity broker earns:",
        "o": [
          "Profit from speculation only",
          "Commission on transactions for clients — buying/selling on their behalf",
          "Salary from government",
          "Profit from warehousing"
        ],
        "a": 1,
        "e": "Commodity broker = agent earning COMMISSION per transaction.",
        "h": "Commodity broker = earns commission for facilitating transactions.",
        "yr": "SS1"
      },
      {
        "q": "If global cocoa prices fall, Nigeria's revenue:",
        "o": [
          "Increases",
          "Decreases — less earned per tonne exported",
          "Farmers stop farming",
          "Nigeria stops exporting immediately"
        ],
        "a": 1,
        "e": "Falling cocoa prices → less revenue per tonne → total revenue falls.",
        "h": "Falling cocoa prices → less revenue per tonne.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Commodity Exchange II",
    "topicCode": "SS1-COM-10",
    "module": "Trade",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Commodity Exchange II</span>: Regulation: SEC. Participants: producers, buyers, brokers, speculators, hedgers. Backwardation (futures<spot) vs contango (futures>spot). Nigeria = world's largest sesame exporter. Smallholder access challenges.</div>",
    "questions": [
      {
        "q": "Which body regulates Nigerian commodity and financial markets?",
        "o": [
          "CBN",
          "Securities and Exchange Commission (SEC)",
          "Nigeria Customs",
          "NAICOM"
        ],
        "a": 1,
        "e": "SEC regulates Nigeria's capital and commodity markets.",
        "h": "SEC = regulates Nigeria's capital and commodity markets.",
        "yr": "SS1"
      },
      {
        "q": "Main commodity exchange participants include:",
        "o": [
          "Only farmers and consumers",
          "Producers, buyers, brokers, speculators, and hedgers",
          "Only government officials",
          "Only large corporations"
        ],
        "a": 1,
        "e": "Participants: producers, buyers, brokers (agents), speculators, hedgers.",
        "h": "Participants: producers, buyers, brokers, speculators, hedgers.",
        "yr": "SS1"
      },
      {
        "q": "Electronic trading advantages include:",
        "o": [
          "More paper documentation",
          "Faster transactions, lower costs, wider access, 24-hour, greater transparency",
          "Requires physical presence",
          "Less trading volume"
        ],
        "a": 1,
        "e": "Electronic: speed, lower costs, wider access, near-24-hour, audit trails.",
        "h": "Electronic trading: faster, cheaper, wider access, 24-hour, transparent.",
        "yr": "SS1"
      },
      {
        "q": "'Price discovery' in commodity exchanges means:",
        "o": [
          "Discovering hidden prices",
          "Supply/demand interaction determines the fair market price",
          "Setting government minimum prices",
          "Hiding prices from participants"
        ],
        "a": 1,
        "e": "PRICE DISCOVERY: exchange activity establishes fair market price.",
        "h": "Price discovery = supply/demand determines fair market price.",
        "yr": "SS1"
      },
      {
        "q": "Warehouse receipts system helps because:",
        "o": [
          "Replaces commodity exchanges",
          "Sellers deposit goods in certified warehouses, receive tradeable receipts — no physical movement needed",
          "Stores only government goods",
          "Eliminates quality grading"
        ],
        "a": 1,
        "e": "Warehouse receipts: deposit goods, get tradeable receipt. Trade without moving goods.",
        "h": "Warehouse receipts: deposit goods, get receipt, trade without moving goods.",
        "yr": "SS1"
      },
      {
        "q": "Problem for smallholder farmers with exchanges:",
        "o": [
          "Prices too transparent",
          "Lack scale, quality standards compliance, finance, and logistics to meet exchange requirements",
          "Too cheap",
          "Large companies excluded"
        ],
        "a": 1,
        "e": "Small farmers: minimum lots too large, strict quality grades, poor infrastructure.",
        "h": "Smallholders: lack scale, quality standards, finance, poor infrastructure.",
        "yr": "SS1"
      },
      {
        "q": "Government's role in commodity markets:",
        "o": [
          "Setting all prices",
          "Inspection/grading, strategic reserves, regulating market operators, building infrastructure",
          "Trading for profit",
          "Owning all warehouses"
        ],
        "a": 1,
        "e": "Government: inspection/grading, strategic reserves, regulation, infrastructure.",
        "h": "Government: inspection/grading + strategic reserves + regulation + infrastructure.",
        "yr": "SS1"
      },
      {
        "q": "'Backwardation' in futures means:",
        "o": [
          "Futures higher than spot",
          "Futures price LOWER than spot — market expects future prices to fall",
          "Trading in reverse",
          "A type of broker"
        ],
        "a": 1,
        "e": "BACKWARDATION: futures < spot. Market expects future supply to increase.",
        "h": "Backwardation = futures price LOWER than spot.",
        "yr": "SS1"
      },
      {
        "q": "Speculators participate to:",
        "o": [
          "Help farmers get better prices",
          "Profit from predicting and trading on price movements",
          "Stabilise prices for consumers",
          "Avoid paying taxes"
        ],
        "a": 1,
        "e": "SPECULATORS: profit from price movements. Add liquidity but can increase volatility.",
        "h": "Speculators profit from price movements.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria is world's LARGEST exporter of:",
        "o": [
          "Crude oil",
          "Sesame seeds",
          "Cocoa",
          "Palm oil"
        ],
        "a": 1,
        "e": "Nigeria = world's LARGEST exporter of sesame seeds. Major destination: China.",
        "h": "Nigeria = world's largest exporter of SESAME SEEDS.",
        "yr": "SS1"
      },
      {
        "q": "Commodity exchange improves market efficiency by:",
        "o": [
          "Reducing number of buyers",
          "Aggregating supply/demand for quick price adjustments and optimal resource allocation",
          "Eliminating all traders",
          "Setting maximum supply"
        ],
        "a": 1,
        "e": "Efficiency: exchanges aggregate information → prices reflect reality → better allocation.",
        "h": "Exchange efficiency: aggregates info → prices reflect reality.",
        "yr": "SS1"
      },
      {
        "q": "A certified warehouse must:",
        "o": [
          "Be government-owned only",
          "Meet exchange standards for security, storage conditions, and issue standardised receipts",
          "Be located only in Lagos",
          "Accept all goods regardless of quality"
        ],
        "a": 1,
        "e": "Certified warehouses: meet exchange quality/security standards, issue accepted receipts.",
        "h": "Certified warehouse: meets exchange standards, issues receipts.",
        "yr": "SS1"
      },
      {
        "q": "'Contango' in futures means:",
        "o": [
          "Futures lower than spot",
          "Futures price HIGHER than spot — storage costs and interest justify premium",
          "Trading in foreign currencies",
          "A type of commodity broker"
        ],
        "a": 1,
        "e": "CONTANGO: futures > spot. Storage costs + interest make future delivery worth more.",
        "h": "Contango = futures price HIGHER than spot.",
        "yr": "SS1"
      },
      {
        "q": "NCE aims to:",
        "o": [
          "Export only crude oil",
          "Develop organised agricultural markets, reduce post-harvest losses, improve farmer income",
          "Replace all traditional markets",
          "Control all food prices"
        ],
        "a": 1,
        "e": "NCE: organised markets → transparent pricing → reduced losses → improved income.",
        "h": "NCE: organised markets, transparent prices, reduced losses, better income.",
        "yr": "SS1"
      },
      {
        "q": "Commodity price VOLATILITY is a disadvantage because:",
        "o": [
          "High prices always bad for exporters",
          "Unpredictable swings make planning and income forecasting difficult for producers",
          "Volatility always means higher prices",
          "Volatility reduces quality"
        ],
        "a": 1,
        "e": "Volatility: unpredictable price swings make planning impossible.",
        "h": "Commodity price volatility: planning impossible, discourages investment.",
        "yr": "SS1"
      },
      {
        "q": "Quality grading helps exchange buyers because:",
        "o": [
          "Buyers pay more",
          "Know exact quality without physical inspection — enables large-scale remote trading",
          "Only for government buyers",
          "Eliminates need for contracts"
        ],
        "a": 1,
        "e": "Grading: buy 'Grade 1 cocoa' knowing exact quality without inspection.",
        "h": "Grading: know quality without inspection. Enables remote trading.",
        "yr": "SS1"
      },
      {
        "q": "Infrastructure required for effective commodity exchange:",
        "o": [
          "Only computers and internet",
          "Warehouses, transportation, telecoms, testing labs, financial services",
          "Only market buildings",
          "Only government offices"
        ],
        "a": 1,
        "e": "Needs: warehouses, roads/ports, telecoms, quality labs, banks/insurance.",
        "h": "Infrastructure: warehouses + transport + telecoms + labs + financial services.",
        "yr": "SS1"
      },
      {
        "q": "Why commodity trading matters for food security:",
        "o": [
          "Replaces local production",
          "Improves storage, reduces post-harvest losses, encourages production, stabilises prices",
          "Only imports food",
          "Only helps exporters"
        ],
        "a": 1,
        "e": "Food security: exchanges encourage production, improve storage, stabilise prices.",
        "h": "Commodity exchange: encourage production, reduce losses, stabilise prices.",
        "yr": "SS1"
      },
      {
        "q": "Who bears greatest risk from commodity price crashes?",
        "o": [
          "Large diversified corporations",
          "Small-scale farmers — dependent on one crop, can't hedge, no savings buffer",
          "Urban consumers",
          "Government officials"
        ],
        "a": 1,
        "e": "Small farmers: one crop, can't hedge, no savings, no insurance.",
        "h": "Small-scale farmers bear greatest price risk: one crop, can't hedge.",
        "yr": "SS1"
      },
      {
        "q": "Forward contract vs futures contract:",
        "o": [
          "They are identical",
          "Forward = private/customised between two parties; futures = standardised, exchange-traded",
          "Futures always riskier",
          "Forwards only for minerals"
        ],
        "a": 1,
        "e": "FORWARD: private customised agreement. FUTURES: standardised, exchange-traded.",
        "h": "Forward = private customised. Futures = standardised, exchange-traded.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Sole Proprietorship",
    "topicCode": "SS1-COM-11",
    "module": "Forms of Business Ownership",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Sole Proprietorship</span>: One owner, manages and controls. Merits: easy to establish, full control, direct incentive, flexibility, secrecy. Demerits: unlimited liability, limited capital, continuity problem. Most common in Nigeria's informal sector.</div>",
    "questions": [
      {
        "q": "A sole proprietorship is owned by:",
        "o": [
          "Two or more partners",
          "One person (sole trader) who manages and controls it",
          "A group of shareholders",
          "The government"
        ],
        "a": 1,
        "e": "Sole proprietorship = owned, financed, managed by ONE person.",
        "h": "Sole proprietorship = ONE person owns, manages, controls.",
        "yr": "SS1"
      },
      {
        "q": "'Unlimited liability' in sole proprietorship means:",
        "o": [
          "Owner has unlimited borrowing power",
          "Owner's personal assets can be seized to pay business debts — no separation between owner and business",
          "Owner can never be sued",
          "Liability shared among many owners"
        ],
        "a": 1,
        "e": "Unlimited liability: personal assets (house, car) at risk for business debts.",
        "h": "Unlimited liability: personal assets pay business debts.",
        "yr": "SS1"
      },
      {
        "q": "Which is a MERIT of sole proprietorship?",
        "o": [
          "Unlimited liability",
          "Limited capital base",
          "Easy to establish with minimal legal requirements",
          "Business ends when owner dies"
        ],
        "a": 2,
        "e": "Easy establishment: minimal or no legal formalities needed.",
        "h": "Sole proprietorship merit: easy to establish.",
        "yr": "SS1"
      },
      {
        "q": "A local barbershop in Lagos is an example of:",
        "o": [
          "Partnership",
          "Limited liability company",
          "Sole proprietorship",
          "Cooperative society"
        ],
        "a": 2,
        "e": "Local barbershop owned and operated by one person = sole proprietorship.",
        "h": "Local barbershop = sole proprietorship.",
        "yr": "SS1"
      },
      {
        "q": "The 'direct incentive' advantage means:",
        "o": [
          "Owner always earns more than employees",
          "All profits go entirely to the owner — providing strong motivation to work hard",
          "Government gives incentives to the owner",
          "Banks provide special incentives to sole traders"
        ],
        "a": 1,
        "e": "Direct incentive: ALL profits to one owner → maximum motivation.",
        "h": "Direct incentive: ALL profits to owner → maximum motivation.",
        "yr": "SS1"
      },
      {
        "q": "A DEMERIT of sole proprietorship is:",
        "o": [
          "Owner gets all profits",
          "Easy to establish",
          "Continuity problem — business may cease if owner dies or is incapacitated",
          "Owner has full control"
        ],
        "a": 2,
        "e": "Continuity: depends on ONE person. May cease with owner.",
        "h": "Continuity problem: may cease if owner dies.",
        "yr": "SS1"
      },
      {
        "q": "A sole proprietor typically raises capital from:",
        "o": [
          "Issuing shares on the stock exchange",
          "Personal savings, family loans, bank loans, and informal money lenders",
          "Selling bonds to the public",
          "Government grants only"
        ],
        "a": 1,
        "e": "Capital: personal savings, family loans, bank loans, trade credit. Cannot issue shares.",
        "h": "Sole proprietor capital: personal savings + family loans + bank loans.",
        "yr": "SS1"
      },
      {
        "q": "'Knows customers personally' is advantageous because:",
        "o": [
          "Owner spends less time working",
          "Personal knowledge allows tailored service, building loyalty and repeat business",
          "Customers pay less for goods",
          "Owner can avoid paying taxes"
        ],
        "a": 1,
        "e": "Personal customer knowledge → tailored service → customer loyalty.",
        "h": "Personal knowledge → tailored service → loyalty.",
        "yr": "SS1"
      },
      {
        "q": "The 'flexibility' advantage of sole proprietorship means:",
        "o": [
          "Owner can change location at will",
          "Owner makes decisions alone — quickly adapts to market changes without consulting others",
          "Owner is exempt from all regulations",
          "Business has flexible working hours only"
        ],
        "a": 1,
        "e": "Flexibility: sole proprietor is ONLY decision-maker. Adapts immediately.",
        "h": "Flexibility: sole owner decides alone, instantly adapts.",
        "yr": "SS1"
      },
      {
        "q": "'Limited capital' as a demerit means:",
        "o": [
          "Owner is prohibited from investing much money",
          "One person's financial resources limit business expansion — cannot issue shares",
          "Government limits how much sole traders can earn",
          "Must keep capital in cash"
        ],
        "a": 1,
        "e": "Limited capital: can't issue shares. Limited to one person's resources.",
        "h": "Limited capital: can't issue shares, limited to one person.",
        "yr": "SS1"
      },
      {
        "q": "Sole proprietorships are most common in Nigeria's:",
        "o": [
          "Banking sector",
          "Oil and gas sector",
          "Informal economy — market traders, artisans, small retailers, service providers",
          "Manufacturing of heavy goods"
        ],
        "a": 2,
        "e": "Sole proprietorships dominate Nigeria's informal sector — 80%+ of businesses.",
        "h": "Most common: Nigeria's informal sector.",
        "yr": "SS1"
      },
      {
        "q": "Which is an example of a sole proprietorship?",
        "o": [
          "Dangote Group (public limited company)",
          "Zenith Bank (Plc)",
          "A local provision store owner in Surulere",
          "Lagos State government"
        ],
        "a": 2,
        "e": "Local provision store owner = sole proprietorship.",
        "h": "Local provision store = sole proprietorship.",
        "yr": "SS1"
      },
      {
        "q": "When business debts exceed assets, creditors can:",
        "o": [
          "Only claim business assets",
          "Claim both business AND personal assets (unlimited liability)",
          "Do nothing — owner is protected",
          "Only sue the business name"
        ],
        "a": 1,
        "e": "Unlimited liability: creditors pursue personal assets (house, car, savings).",
        "h": "Unlimited liability: creditors claim business AND personal assets.",
        "yr": "SS1"
      },
      {
        "q": "'Secrecy of business information' advantage means:",
        "o": [
          "Owner can hide financial crimes",
          "Owner need not publish accounts or disclose business information publicly",
          "Information is never recorded",
          "Tax authorities cannot access records"
        ],
        "a": 1,
        "e": "Secrecy: sole proprietors not required to publish annual accounts.",
        "h": "Secrecy: sole traders need not publish accounts.",
        "yr": "SS1"
      },
      {
        "q": "Rapid growth would MOST LIKELY cause which problem?",
        "o": [
          "Too much profit",
          "Need for more capital than one person can provide — pressure to bring partners or incorporate",
          "Government interference",
          "Too many customers to serve"
        ],
        "a": 1,
        "e": "Growth: needs more capital → bring partners or incorporate.",
        "h": "Rapid growth: needs more capital than one person can provide.",
        "yr": "SS1"
      },
      {
        "q": "What happens when a sole proprietor dies?",
        "o": [
          "Government administrator takes over",
          "Business continues automatically for one year",
          "Business typically ceases — no legal continuity beyond the owner",
          "Partners take over management"
        ],
        "a": 2,
        "e": "Death: sole proprietorship has no legal existence beyond the owner.",
        "h": "Owner death: business typically ceases. No legal continuity.",
        "yr": "SS1"
      },
      {
        "q": "Registration requirements for a sole proprietorship in Nigeria:",
        "o": [
          "Must register with CAC like a company",
          "Minimal — business name registration only (optional), no MOA/AOA needed",
          "Cannot operate legally without company registration",
          "Must have minimum capital of ₦1 million"
        ],
        "a": 1,
        "e": "Minimal requirements: optional business name registration with CAC.",
        "h": "Sole proprietorship: minimal registration (optional business name).",
        "yr": "SS1"
      },
      {
        "q": "The phrase 'one-man business' best describes:",
        "o": [
          "Partnership",
          "Cooperative society",
          "Sole proprietorship",
          "Private limited company"
        ],
        "a": 2,
        "e": "'One-man business' = sole proprietorship.",
        "h": "'One-man business' = sole proprietorship.",
        "yr": "SS1"
      },
      {
        "q": "Sole proprietorship remains popular in Nigeria because:",
        "o": [
          "Government forces people to use this structure",
          "Easy to set up, little capital needed, full control, suits small local markets",
          "Banks only lend to sole proprietors",
          "All other structures are illegal in Nigeria"
        ],
        "a": 1,
        "e": "Popular: easy to start, low capital, full control, suits small local markets.",
        "h": "Popular: easy, low capital, full control, suits local markets.",
        "yr": "SS1"
      },
      {
        "q": "A sole proprietor is best described as:",
        "o": [
          "A shareholder in a large company",
          "A government employee",
          "Owner, manager, and decision-maker all in one person — bears all risks and rewards",
          "A cooperative member"
        ],
        "a": 2,
        "e": "Sole proprietor: one person is owner + manager + decision-maker + risk-bearer.",
        "h": "Sole proprietor = owner + manager + decision-maker + all risks borne by one person.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Partnership I",
    "topicCode": "SS1-COM-12",
    "module": "Forms of Business Ownership",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Partnership I</span>: Partnership = 2-20 persons (max 10 for banks). General partner: manages + unlimited liability. Limited/sleeping partner: capital only + limited liability. Governed by partnership deed. Partnership Act provides defaults.</div>",
    "questions": [
      {
        "q": "A partnership is defined as:",
        "o": [
          "A business owned by one person",
          "A business owned by 2-20 persons who share profits, losses, and management",
          "A company with shareholders",
          "A government enterprise"
        ],
        "a": 1,
        "e": "Partnership: minimum 2, maximum 20 persons sharing capital, management, profits, losses.",
        "h": "Partnership = 2-20 persons sharing capital, management, profits, losses.",
        "yr": "SS1"
      },
      {
        "q": "The MINIMUM number of partners in a partnership is:",
        "o": [
          "1",
          "2",
          "10",
          "20"
        ],
        "a": 1,
        "e": "MINIMUM: 2 partners. One person alone = sole proprietorship.",
        "h": "Partnership minimum = 2 partners.",
        "yr": "SS1"
      },
      {
        "q": "A GENERAL partner:",
        "o": [
          "Has limited liability only",
          "Participates in management and has unlimited liability for all partnership debts",
          "Only provides capital and has no liability",
          "Is always a sleeping partner"
        ],
        "a": 1,
        "e": "GENERAL PARTNER: actively manages AND has unlimited liability.",
        "h": "General partner: manages + unlimited liability.",
        "yr": "SS1"
      },
      {
        "q": "A LIMITED (sleeping) partner:",
        "o": [
          "Has unlimited liability",
          "Actively manages the business",
          "Provides capital only — liability limited to investment, does not manage",
          "Is always the senior partner"
        ],
        "a": 2,
        "e": "LIMITED PARTNER: contributes capital, does NOT manage, liability LIMITED to investment.",
        "h": "Limited partner: capital only + limited liability. Cannot manage.",
        "yr": "SS1"
      },
      {
        "q": "A partnership deed specifies:",
        "o": [
          "Only the names of partners",
          "All terms: profit-sharing ratio, capital contributions, duties, dissolution procedures",
          "Only the business address",
          "Only the capital amount"
        ],
        "a": 1,
        "e": "Partnership deed: names, capitals, profit/loss ratio, duties, dissolution.",
        "h": "Partnership deed: all terms — capitals, profit ratios, duties, dissolution.",
        "yr": "SS1"
      },
      {
        "q": "A MERIT of partnership over sole proprietorship:",
        "o": [
          "Fewer owners means simpler decisions",
          "Greater capital base — multiple partners contribute, enabling larger operations",
          "No unlimited liability",
          "Less paperwork than sole proprietorship"
        ],
        "a": 1,
        "e": "Greater capital: multiple partners combining resources provide larger base.",
        "h": "Partnership merit: greater combined capital from multiple partners.",
        "yr": "SS1"
      },
      {
        "q": "'Sleeping partner' is another name for:",
        "o": [
          "A partner who works night shifts",
          "A limited partner — contributes capital but does not participate in management",
          "A retired partner",
          "A new partner not yet active"
        ],
        "a": 1,
        "e": "Sleeping partner = limited partner = invests capital but NOT active in management.",
        "h": "Sleeping partner = limited partner = invests but doesn't manage.",
        "yr": "SS1"
      },
      {
        "q": "In a partnership, profits are shared:",
        "o": [
          "Always equally by law",
          "According to the partnership deed (agreed ratio), or equally if no agreement exists",
          "Based on how much work each partner does",
          "According to government instructions"
        ],
        "a": 1,
        "e": "Profit sharing: per PARTNERSHIP DEED. If no deed: equally by default.",
        "h": "Profits: per deed ratio. If no deed: equally (default).",
        "yr": "SS1"
      },
      {
        "q": "What is the maximum number of partners in an ordinary partnership?",
        "o": [
          "5",
          "10",
          "20",
          "50"
        ],
        "a": 2,
        "e": "Maximum: 20 partners (ordinary); 10 (banking). Exceeding = must incorporate.",
        "h": "Partnership maximum = 20 (ordinary), 10 (banking).",
        "yr": "SS1"
      },
      {
        "q": "'Doctrine of mutual agency' means:",
        "o": [
          "Partners must be insurance agents",
          "Each partner can act as agent for the firm — binding all other partners by their actions",
          "Partners must use the same bank",
          "All partners must sign every document"
        ],
        "a": 1,
        "e": "Mutual agency: one partner's actions in normal business bind ALL partners.",
        "h": "Mutual agency: each partner's actions bind ALL partners.",
        "yr": "SS1"
      },
      {
        "q": "Which is a DEMERIT of general partnership?",
        "o": [
          "Too many owners",
          "Unlimited liability — each partner's personal assets at risk for all partnership debts",
          "Too much capital raised",
          "Partners disagree productively"
        ],
        "a": 1,
        "e": "Unlimited liability: each general partner liable for ALL debts including others'.",
        "h": "General partnership demerit: unlimited liability for ALL debts.",
        "yr": "SS1"
      },
      {
        "q": "Partnership allows SPECIALISATION because:",
        "o": [
          "All partners must do the same job",
          "Different partners bring different expertise — one handles finance, another marketing, another operations",
          "Partners compete against each other",
          "Only senior partners make decisions"
        ],
        "a": 1,
        "e": "Specialisation: partners contribute different expertise.",
        "h": "Partnership specialisation: different partners bring different expertise.",
        "yr": "SS1"
      },
      {
        "q": "Registration of a partnership in Nigeria is done with:",
        "o": [
          "CBN",
          "Corporate Affairs Commission (CAC)",
          "Securities and Exchange Commission (SEC)",
          "FIRS"
        ],
        "a": 1,
        "e": "Partnership registers with CAC under Partnership Law.",
        "h": "Partnership registers with CAC.",
        "yr": "SS1"
      },
      {
        "q": "A law firm in Lagos with 5 partners is an example of:",
        "o": [
          "Sole proprietorship",
          "Partnership",
          "Limited liability company",
          "Cooperative"
        ],
        "a": 1,
        "e": "5-partner law firm = PARTNERSHIP.",
        "h": "5-partner law firm = partnership.",
        "yr": "SS1"
      },
      {
        "q": "What happens to a partnership if one partner dies?",
        "o": [
          "Nothing — business continues automatically",
          "Partnership is typically dissolved unless the deed provides otherwise",
          "The government takes over",
          "Surviving partners inherit the deceased's share automatically"
        ],
        "a": 1,
        "e": "Dissolution on death: typically dissolves unless deed says otherwise.",
        "h": "Partner death: partnership typically dissolved.",
        "yr": "SS1"
      },
      {
        "q": "'Sharing of risk' is a partnership advantage because:",
        "o": [
          "Risk is transferred to insurance companies",
          "Business losses are distributed among multiple partners rather than borne by one person",
          "Partners take no risk at all",
          "Risk is shared with customers"
        ],
        "a": 1,
        "e": "Risk sharing: losses divided among all partners, reducing impact on each.",
        "h": "Risk sharing: losses divided among multiple partners.",
        "yr": "SS1"
      },
      {
        "q": "Which type of partner is liable for ALL debts of the partnership?",
        "o": [
          "Sleeping partner (limited)",
          "General partner (active)",
          "Nominal partner",
          "Partner's family members"
        ],
        "a": 1,
        "e": "GENERAL PARTNER: UNLIMITED liability for ALL partnership debts.",
        "h": "General partner = unlimited liability for ALL debts.",
        "yr": "SS1"
      },
      {
        "q": "If no partnership deed exists, the Partnership Act provides that partners:",
        "o": [
          "Cannot share profits",
          "Share profits and losses equally and all have equal say in management",
          "The first partner gets more profit",
          "Profits go to the government"
        ],
        "a": 1,
        "e": "Default (no deed): equal profit/loss sharing, equal management rights.",
        "h": "No deed: equal profit/loss sharing (Partnership Act default).",
        "yr": "SS1"
      },
      {
        "q": "A NOMINAL partner is one who:",
        "o": [
          "Lends their name and reputation to the business but has no real financial stake",
          "Actively manages the business",
          "Has unlimited liability only",
          "Provides the most capital"
        ],
        "a": 0,
        "e": "NOMINAL PARTNER: lends name/reputation only. No capital, no management role.",
        "h": "Nominal partner: lends name only. No financial stake or management role.",
        "yr": "SS1"
      },
      {
        "q": "What would be the consequence if one partner makes a disastrous business decision?",
        "o": [
          "Only that partner is affected",
          "ALL partners are equally liable — the doctrine of mutual agency means the firm and all partners are bound",
          "Only the sleeping partners are affected",
          "Only the nominal partner is affected"
        ],
        "a": 1,
        "e": "Mutual agency + unlimited liability: disastrous decisions by one partner bind ALL.",
        "h": "Mutual agency: one partner's bad decisions affect ALL partners.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Partnership II",
    "topicCode": "SS1-COM-13",
    "module": "Forms of Business Ownership",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Partnership II</span>: Partnership dissolution: fixed term, agreement, death, bankruptcy, court order. Goodwill = reputation value. Merits: combined capital, specialisation, mutual oversight, better credit. Demerits: disputes, profit dilution, dissolution risk.</div>",
    "questions": [
      {
        "q": "Partnership can be dissolved by:",
        "o": [
          "Only a court order",
          "Expiry of fixed term, mutual agreement, death/bankruptcy of a partner, or court order",
          "Only when the business goes bankrupt",
          "Only when profits fall below minimum"
        ],
        "a": 1,
        "e": "Dissolution: fixed period expiry, mutual agreement, death, bankruptcy, court order.",
        "h": "Dissolved by: fixed term expiry, agreement, death, bankruptcy, court order.",
        "yr": "SS1"
      },
      {
        "q": "'Goodwill' in a partnership context refers to:",
        "o": [
          "Partners being friendly to each other",
          "The monetary value of the business's reputation, customer relationships, and established customer base",
          "Free gifts to customers",
          "Partners donating to charity"
        ],
        "a": 1,
        "e": "GOODWILL: intangible asset = reputation, customer relationships, brand name value.",
        "h": "Goodwill = value of business reputation and customer relationships.",
        "yr": "SS1"
      },
      {
        "q": "An advantage of partnership over sole proprietorship is:",
        "o": [
          "Partnership has unlimited liability (both have this)",
          "More capital available from multiple partners enabling larger operations",
          "Partnership is simpler to manage",
          "Partnership has no legal requirements"
        ],
        "a": 1,
        "e": "Greater capital: multiple partners combining resources provide a larger base.",
        "h": "Partnership advantage: more combined capital.",
        "yr": "SS1"
      },
      {
        "q": "'Division of labour and specialisation' in partnership means:",
        "o": [
          "Partners share physical labour equally",
          "Partners with different skills handle different business functions — finance, marketing, operations",
          "All partners do the same job",
          "Partners outsource all work"
        ],
        "a": 1,
        "e": "Specialisation: one handles finance, another marketing, another operations.",
        "h": "Partnership: different partners handle different functions based on expertise.",
        "yr": "SS1"
      },
      {
        "q": "A key difference between partnership and sole proprietorship:",
        "o": [
          "Both have unlimited liability",
          "Sole = 1 owner; Partnership = 2-20 owners who share management and profits",
          "Both require company registration",
          "Both have limited liability"
        ],
        "a": 1,
        "e": "Ownership: sole = 1; partnership = 2-20; shared management and profits.",
        "h": "Sole prop: 1 owner. Partnership: 2-20 owners, shared management.",
        "yr": "SS1"
      },
      {
        "q": "'Partners check each other's actions' is advantageous because:",
        "o": [
          "Partners spy on each other",
          "Multiple partners reviewing decisions reduce errors, fraud, and poor judgment",
          "Partners argue constantly",
          "Only the senior partner checks others"
        ],
        "a": 1,
        "e": "Mutual oversight: partners catch mistakes, detect fraud, question poor decisions.",
        "h": "Partners check each other: reduces errors, fraud, poor decisions.",
        "yr": "SS1"
      },
      {
        "q": "A major PROBLEM of partnership is:",
        "o": [
          "Too much profit to share",
          "Disagreements and disputes between partners can paralyse decision-making and destroy the business",
          "Partners must be family members",
          "Partnership has too much capital"
        ],
        "a": 1,
        "e": "DISPUTES: disagreements can paralyse operations and destroy the business.",
        "h": "Major problem: disputes between partners can destroy business.",
        "yr": "SS1"
      },
      {
        "q": "When a new partner joins a partnership, they typically:",
        "o": [
          "Automatically receive equal share of all past profits",
          "Must contribute capital, may pay goodwill, with profit share per new partnership deed",
          "Get immediate full control",
          "Have unlimited profit rights immediately"
        ],
        "a": 1,
        "e": "New partner: contributes capital, may pay goodwill, revised deed with new profit ratios.",
        "h": "New partner: contributes capital + goodwill + new profit sharing in revised deed.",
        "yr": "SS1"
      },
      {
        "q": "The Partnership Act in Nigeria:",
        "o": [
          "Only applies to banking partnerships",
          "Provides the legal framework governing partnerships — default rules apply when no deed exists",
          "Requires all partnerships to register as companies",
          "Prohibits limited partnerships"
        ],
        "a": 1,
        "e": "Partnership Act: legal rules. Default rules when deed is absent or silent.",
        "h": "Partnership Act: default rules when no deed or deed is silent.",
        "yr": "SS1"
      },
      {
        "q": "'Profit dilution' as a partnership demerit means:",
        "o": [
          "Profits reduced by taxes only",
          "As more partners share profits, each individual partner receives a smaller share",
          "Profits become illegal above a threshold",
          "Partners always dispute profit calculations"
        ],
        "a": 1,
        "e": "Profit dilution: 4 equal partners means each gets only 25% of total profit.",
        "h": "Profit dilution: profits shared among partners → each gets less than sole trader.",
        "yr": "SS1"
      },
      {
        "q": "A business with 3 doctors sharing a clinic in Lagos is:",
        "o": [
          "Sole proprietorship",
          "Partnership",
          "Public limited company",
          "Cooperative"
        ],
        "a": 1,
        "e": "3 doctors sharing clinic = PARTNERSHIP. Professional practices often structured as partnerships.",
        "h": "3 doctors sharing clinic = partnership.",
        "yr": "SS1"
      },
      {
        "q": "How does partnership improve ACCESS TO CREDIT from banks?",
        "o": [
          "Banks prefer sole traders",
          "Combined assets and reputation of multiple partners provide better security and creditworthiness",
          "Banks charge more to partnerships",
          "Banks cannot lend to partnerships"
        ],
        "a": 1,
        "e": "Better credit: multiple partners' combined assets as security better than one person's.",
        "h": "Combined partner assets + creditworthiness → better bank credit access.",
        "yr": "SS1"
      },
      {
        "q": "'Partners are jointly and severally liable' means:",
        "o": [
          "Partners share liability only for their portion",
          "Each partner is INDIVIDUALLY responsible for ALL partnership debts — creditors can sue any partner for the full amount",
          "Partners cannot be individually sued",
          "Liability limited to capital contributed"
        ],
        "a": 1,
        "e": "Joint and several: creditors can sue ANY partner for FULL debt amount.",
        "h": "Joint and several: each partner individually liable for ALL debts.",
        "yr": "SS1"
      },
      {
        "q": "Which would convert a partnership into a company?",
        "o": [
          "Adding more than 5 partners",
          "Partners formally incorporating under CAMA — receiving a Certificate of Incorporation from CAC",
          "The business earning more than ₦10 million",
          "Government converting it automatically"
        ],
        "a": 1,
        "e": "Incorporation: apply to CAC under CAMA → Certificate of Incorporation.",
        "h": "Partnership → company: incorporate under CAMA with CAC.",
        "yr": "SS1"
      },
      {
        "q": "'Continuity of business' is a weakness of partnership because:",
        "o": [
          "Partnerships are permanent by nature",
          "Certain events (partner death, bankruptcy, retirement) can trigger dissolution, causing business disruption",
          "Companies cannot be dissolved",
          "Sole proprietorships are more permanent"
        ],
        "a": 1,
        "e": "Continuity weakness: death/bankruptcy may dissolve partnership unlike perpetual companies.",
        "h": "Continuity weakness: dissolution triggered by death/bankruptcy/retirement.",
        "yr": "SS1"
      },
      {
        "q": "A 'dormant partner' is one who:",
        "o": [
          "Sleeps at the office",
          "Has contributed capital but is not currently active in management",
          "Is being recruited as a new partner",
          "Manages only during nighttime"
        ],
        "a": 1,
        "e": "DORMANT PARTNER: invested capital but not currently active in management.",
        "h": "Dormant partner: invested capital, not currently active in management.",
        "yr": "SS1"
      },
      {
        "q": "Compared to a company, a partnership's main disadvantage is:",
        "o": [
          "Partnership earns more profit",
          "No continuity beyond partners (unlike perpetual company), unlimited liability, limited capital raising",
          "Partnerships pay more tax",
          "Companies are harder to establish"
        ],
        "a": 1,
        "e": "Partnership: no perpetual succession, unlimited liability, limited capital raising vs company.",
        "h": "Partnership vs company: no perpetual succession + unlimited liability.",
        "yr": "SS1"
      },
      {
        "q": "'Sharing of ideas and expertise' as a merit means:",
        "o": [
          "Partners steal each other's ideas",
          "Multiple partners contribute different knowledge and skills — better, more informed decisions",
          "Partners must share all trade secrets",
          "Only one partner's ideas are used"
        ],
        "a": 1,
        "e": "Combined expertise: engineer + marketer + accountant together make better decisions.",
        "h": "Shared expertise: multiple partners contribute different knowledge.",
        "yr": "SS1"
      },
      {
        "q": "A partnership with a fixed term of 3 years:",
        "o": [
          "Can never be dissolved before 3 years",
          "Dissolves automatically at the end of 3 years unless partners agree to continue",
          "Must convert to a company at 3 years",
          "Is automatically renewed for another 3 years"
        ],
        "a": 1,
        "e": "Fixed term: dissolves at end of agreed period unless partners decide to continue.",
        "h": "Fixed term partnership: dissolves automatically at end of period.",
        "yr": "SS1"
      },
      {
        "q": "The main legal document governing a partnership's operation is:",
        "o": [
          "Memorandum of Association",
          "Partnership deed (partnership agreement)",
          "Certificate of Incorporation",
          "Articles of Association"
        ],
        "a": 1,
        "e": "PARTNERSHIP DEED = primary governance document. MOA/Articles = for companies.",
        "h": "Partnership governed by: Partnership Deed.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Money",
    "topicCode": "SS1-COM-14",
    "module": "Money and Banking",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Money</span>: Money = anything generally accepted as medium of exchange. Functions: medium of exchange, measure of value, store of value, standard for deferred payment. Characteristics: general acceptability, durability, portability, divisibility, scarcity, homogeneity. Types: commodity, metallic, paper, bank, electronic.</div>",
    "questions": [
      {
        "q": "Money is best defined as:",
        "o": [
          "Only paper notes and coins",
          "Anything generally accepted as a medium of exchange for goods and services",
          "Only gold and silver",
          "Any government document"
        ],
        "a": 1,
        "e": "Money = anything generally accepted as medium of exchange.",
        "h": "Money = anything generally accepted as medium of exchange.",
        "yr": "SS1"
      },
      {
        "q": "The PRIMARY function of money is:",
        "o": [
          "Store of value",
          "Standard for deferred payment",
          "Medium of exchange — facilitating the buying and selling of goods and services",
          "Measure of value only"
        ],
        "a": 2,
        "e": "MEDIUM OF EXCHANGE = primary function. Eliminates double coincidence of wants.",
        "h": "Primary function = medium of exchange.",
        "yr": "SS1"
      },
      {
        "q": "Money as a 'measure of value' means:",
        "o": [
          "Money has intrinsic value in itself",
          "Money provides a common unit (naira) by which the values of all goods can be expressed and compared",
          "Money measures physical quantities",
          "Money determines the weight of goods"
        ],
        "a": 1,
        "e": "MEASURE OF VALUE: naira gives common unit to price and compare all goods.",
        "h": "Measure of value: common unit (naira) to express and compare all values.",
        "yr": "SS1"
      },
      {
        "q": "'Store of value' as a function means:",
        "o": [
          "Money is stored in banks only",
          "Money retains purchasing power over time — savings today can be used to buy goods in the future",
          "Money increases in value automatically",
          "Money must be spent immediately"
        ],
        "a": 1,
        "e": "STORE OF VALUE: money can be saved and used later.",
        "h": "Store of value: save money now, spend later.",
        "yr": "SS1"
      },
      {
        "q": "'Standard for deferred payment' means:",
        "o": [
          "Money sets standards for bank loans",
          "Money provides a unit for agreeing on future payment terms — loans, credit, contracts payable later",
          "Money is always paid in advance",
          "Deferred means money is never paid"
        ],
        "a": 1,
        "e": "DEFERRED PAYMENT: borrow ₦100,000 now, repay in money later.",
        "h": "Standard for deferred payment: enables loan/credit contracts.",
        "yr": "SS1"
      },
      {
        "q": "'General acceptability' as a money characteristic means:",
        "o": [
          "Money must be accepted by all governments worldwide",
          "Everyone in society is willing to accept money as payment — confidence that others will also accept it",
          "Only banks accept money",
          "Money is accepted only in cities"
        ],
        "a": 1,
        "e": "GENERAL ACCEPTABILITY: people accept money knowing others will too.",
        "h": "General acceptability: everyone accepts because others will too.",
        "yr": "SS1"
      },
      {
        "q": "'Divisibility' as a money characteristic means:",
        "o": [
          "Money can be divided into countries",
          "Money can be broken into smaller units for making change (₦1,000 → ten ₦100 notes)",
          "Money divides traders",
          "Only coins are divisible"
        ],
        "a": 1,
        "e": "DIVISIBILITY: broken into smaller denominations for change.",
        "h": "Divisibility: broken into smaller units for making change.",
        "yr": "SS1"
      },
      {
        "q": "Which is NOT a characteristic of good money?",
        "o": [
          "Durability",
          "Portability",
          "Perishability",
          "Scarcity"
        ],
        "a": 2,
        "e": "Perishability = NOT good. Money must be DURABLE. Opposite of what's desired.",
        "h": "Perishability is NOT good — money must be DURABLE.",
        "yr": "SS1"
      },
      {
        "q": "Cowrie shells used in pre-colonial Nigeria were:",
        "o": [
          "Paper money",
          "Bank money (cheques)",
          "Commodity money — natural objects used as currency",
          "Electronic money"
        ],
        "a": 2,
        "e": "Cowrie shells = COMMODITY MONEY. Natural objects used as currency.",
        "h": "Cowrie shells = commodity money.",
        "yr": "SS1"
      },
      {
        "q": "A ₦1,000 naira note is an example of:",
        "o": [
          "Commodity money",
          "Metallic money (coin)",
          "Paper money (fiat money issued by CBN as legal tender)",
          "Bank money (cheque)"
        ],
        "a": 2,
        "e": "₦1,000 = PAPER MONEY. Issued by CBN as legal tender (fiat money).",
        "h": "₦1,000 = paper money (fiat money).",
        "yr": "SS1"
      },
      {
        "q": "'Bank money' (credit money) includes:",
        "o": [
          "Physical cash only",
          "Cheques, bank transfers, mobile payments — forms of payment backed by bank deposits",
          "Only central bank notes",
          "Only gold-backed instruments"
        ],
        "a": 1,
        "e": "BANK MONEY: cheques, transfers, debit cards, mobile payments.",
        "h": "Bank money: cheques, bank transfers, mobile payments.",
        "yr": "SS1"
      },
      {
        "q": "Inflation as it relates to money means:",
        "o": [
          "Too little money in circulation",
          "Rising general price levels that reduce money's purchasing power — store of value eroded",
          "Money becomes more valuable over time",
          "Banks having too much money"
        ],
        "a": 1,
        "e": "INFLATION: rising prices erode store of value — same naira buys less.",
        "h": "Inflation erodes store of value: rising prices → naira buys less.",
        "yr": "SS1"
      },
      {
        "q": "'Homogeneity' as a money characteristic means:",
        "o": [
          "Money comes in many different shapes",
          "All notes/coins of the same denomination are identical and interchangeable",
          "Money homogenises trade",
          "Money looks like the goods it buys"
        ],
        "a": 1,
        "e": "HOMOGENEITY: all ₦1,000 notes are identical. ₦1,000 Lagos = ₦1,000 Kano.",
        "h": "Homogeneity: all same-denomination units are identical.",
        "yr": "SS1"
      },
      {
        "q": "Electronic/digital money in Nigeria includes:",
        "o": [
          "Only naira notes",
          "Mobile transfers (OPay, Paga), internet banking, USSD payments, POS transactions",
          "Only foreign currencies",
          "CBN-printed notes in electronic form"
        ],
        "a": 1,
        "e": "Digital money: OPay, Paga, internet banking, USSD (*966#), POS, e-Naira.",
        "h": "Digital money Nigeria: OPay, Paga, internet banking, USSD, POS.",
        "yr": "SS1"
      },
      {
        "q": "The CBN controls money supply through:",
        "o": [
          "Printing unlimited naira notes",
          "Monetary policy tools: interest rates (MPR), reserve requirements, open market operations",
          "Setting prices for all goods",
          "Controlling all Nigerian banks"
        ],
        "a": 1,
        "e": "CBN: Monetary Policy Rate, reserve requirements, open market operations.",
        "h": "CBN controls money supply: MPR + reserve requirements + open market operations.",
        "yr": "SS1"
      },
      {
        "q": "'Scarcity' as a money characteristic means:",
        "o": [
          "Money must be extremely rare",
          "Money supply must be limited/controlled — unlimited printing causes inflation and devalues money",
          "Money must be physically heavy",
          "Scarcity makes money useless"
        ],
        "a": 1,
        "e": "SCARCITY: limited supply maintains value. Unlimited printing → inflation.",
        "h": "Scarcity: limited supply maintains value. Unlimited printing → worthless.",
        "yr": "SS1"
      },
      {
        "q": "Paper money is better than commodity money (cowries) because:",
        "o": [
          "Paper money has intrinsic value",
          "Paper money is more portable, divisible, and can represent large values compactly",
          "Commodity money is not accepted anywhere",
          "Paper is more durable than cowries"
        ],
        "a": 1,
        "e": "Paper money: portable, divisible, scalable, standardised.",
        "h": "Paper money: portable, divisible, scalable. Better than commodity money.",
        "yr": "SS1"
      },
      {
        "q": "Saving ₦1,000,000 under a mattress for 5 years with 25% annual inflation means:",
        "o": [
          "Your savings grow to ₦5,000,000",
          "The amount stays at ₦1,000,000",
          "The real purchasing power significantly decreases — inflation erodes what your money can buy",
          "Your savings double automatically"
        ],
        "a": 2,
        "e": "Nominal stays ₦1M but REAL purchasing power (what you can actually buy) falls sharply.",
        "h": "Inflation erodes savings: same naira buys much less after 5 years.",
        "yr": "SS1"
      },
      {
        "q": "Money's 'portability' characteristic means:",
        "o": [
          "Money can be transported internationally only",
          "Money is easy to carry — small amounts represent large values, enabling distant transactions",
          "Money cannot be moved from one place to another",
          "Portability is not important for money"
        ],
        "a": 1,
        "e": "PORTABILITY: ₦100,000 in notes fits in wallet. Equivalent in cowries = truck.",
        "h": "Portability: money easy to carry. ₦100,000 fits in pocket.",
        "yr": "SS1"
      },
      {
        "q": "A bank loan best demonstrates money as 'standard of deferred payment' because:",
        "o": [
          "A market trader selling for immediate cash",
          "A bank giving a 2-year loan to be repaid monthly in naira — borrow now, repay in money later",
          "A trader bartering cloth for fish",
          "A company paying salaries in gold"
        ],
        "a": 1,
        "e": "Bank loan = deferred payment: borrow money now, agree to repay in naira over future periods.",
        "h": "Bank loan = deferred payment: borrow now, repay in money later.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Career Opportunities in Commerce",
    "topicCode": "SS1-COM-15",
    "module": "Career and Vocational Guidance",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Career Opportunities in Commerce</span>: Commerce careers: accounting (ICAN), banking (CIBN), insurance (CIIN), marketing, logistics, customs brokerage, stockbroking, entrepreneurship, real estate, advertising, e-commerce, supply chain management.</div>",
    "questions": [
      {
        "q": "ICAN stands for:",
        "o": [
          "Institute of Commerce and Administration Nigeria",
          "Institute of Chartered Accountants of Nigeria",
          "International Commerce and Accounting Network",
          "Institute of Corporate Affairs Nigeria"
        ],
        "a": 1,
        "e": "ICAN = Institute of Chartered Accountants of Nigeria. Regulates accounting profession.",
        "h": "ICAN = Institute of Chartered Accountants of Nigeria.",
        "yr": "SS1"
      },
      {
        "q": "The CIBN (Chartered Institute of Bankers of Nigeria) regulates:",
        "o": [
          "Accounting profession",
          "Banking profession in Nigeria",
          "Insurance profession",
          "Customs and excise"
        ],
        "a": 1,
        "e": "CIBN = Chartered Institute of Bankers of Nigeria. Banking profession body.",
        "h": "CIBN = banking profession regulator.",
        "yr": "SS1"
      },
      {
        "q": "A MARKETING professional in commerce is concerned with:",
        "o": [
          "Producing goods in factories",
          "Identifying customer needs, promoting goods/services, developing pricing and distribution strategies",
          "Recording financial transactions",
          "Transporting goods internationally"
        ],
        "a": 1,
        "e": "MARKETING: market research, product development, pricing, promotion, distribution.",
        "h": "Marketing: identify customer needs, promote, pricing, distribution.",
        "yr": "SS1"
      },
      {
        "q": "An INSURANCE professional's work involves:",
        "o": [
          "Granting loans to businesses",
          "Assessing risks, selling insurance policies, and processing claims to compensate for losses",
          "Marketing consumer goods",
          "Preparing financial accounts"
        ],
        "a": 1,
        "e": "INSURANCE: risk assessment, selling policies, claims processing. CIIN body.",
        "h": "Insurance: risk assessment, policies, claims processing.",
        "yr": "SS1"
      },
      {
        "q": "A CUSTOMS BROKER (customs agent) career involves:",
        "o": [
          "Working for Nigeria Customs Service only",
          "Helping importers/exporters navigate customs regulations, prepare documentation, and clear goods at ports",
          "Manufacturing goods for export",
          "Banking and financial services"
        ],
        "a": 1,
        "e": "CUSTOMS BROKER: prepares documentation, calculates duties, clears goods at ports.",
        "h": "Customs broker: customs documentation and port clearance.",
        "yr": "SS1"
      },
      {
        "q": "ENTREPRENEURSHIP as a career in commerce means:",
        "o": [
          "Working as an employee in a large company",
          "Starting and running one's own business — creating a new enterprise, taking risks, and innovating",
          "Working in government only",
          "Managing someone else's business"
        ],
        "a": 1,
        "e": "ENTREPRENEURSHIP: identify opportunities, start business, innovate, take risks.",
        "h": "Entrepreneurship: start/run own business, innovate, take risks.",
        "yr": "SS1"
      },
      {
        "q": "A STOCKBROKER works on:",
        "o": [
          "The commodity exchange only",
          "The stock exchange — buying and selling shares/securities on behalf of clients for a commission",
          "In a commercial bank",
          "In a government ministry"
        ],
        "a": 1,
        "e": "STOCKBROKER: licensed by SEC to buy/sell shares on NGX for clients.",
        "h": "Stockbroker: buys/sells shares on NGX for clients.",
        "yr": "SS1"
      },
      {
        "q": "Commerce education creates career opportunities in all EXCEPT:",
        "o": [
          "Banking and finance",
          "Insurance and risk management",
          "Surgery and clinical medicine",
          "Retail and wholesale trade management"
        ],
        "a": 2,
        "e": "Commerce prepares for business careers. Surgery = science/medical qualifications.",
        "h": "Commerce doesn't prepare for surgery.",
        "yr": "SS1"
      },
      {
        "q": "A LOGISTICS MANAGER in commerce is responsible for:",
        "o": [
          "Designing advertising campaigns",
          "Managing the movement, storage, and flow of goods from suppliers through to customers efficiently",
          "Providing insurance coverage",
          "Preparing financial accounts"
        ],
        "a": 1,
        "e": "LOGISTICS: supply chain management, warehouse management, transport coordination.",
        "h": "Logistics manager: movement and storage of goods, supply chain.",
        "yr": "SS1"
      },
      {
        "q": "The PURCHASING OFFICER in a company:",
        "o": [
          "Sells company products to customers",
          "Procures (buys) raw materials, supplies, and equipment for the organisation at best prices and quality",
          "Manages human resources",
          "Manages company accounts"
        ],
        "a": 1,
        "e": "PURCHASING: sourcing suppliers, negotiating prices, ordering materials/equipment.",
        "h": "Purchasing officer: buys raw materials and supplies for the organisation.",
        "yr": "SS1"
      },
      {
        "q": "A career in REAL ESTATE involves:",
        "o": [
          "Growing agricultural crops",
          "Buying, selling, leasing, and managing property — land and buildings for commercial or residential use",
          "Manufacturing construction materials",
          "Providing banking services"
        ],
        "a": 1,
        "e": "REAL ESTATE: property valuation, buying/selling/managing land and buildings.",
        "h": "Real estate: property valuation, buying/selling/managing buildings.",
        "yr": "SS1"
      },
      {
        "q": "Which organisation supports small business development in Nigeria?",
        "o": [
          "SMEDAN (Small and Medium Enterprises Development Agency of Nigeria)",
          "Nigeria Customs Service",
          "Securities and Exchange Commission",
          "National Insurance Commission"
        ],
        "a": 0,
        "e": "SMEDAN = Small and Medium Enterprises Development Agency of Nigeria.",
        "h": "SMEDAN = supports small/medium enterprises.",
        "yr": "SS1"
      },
      {
        "q": "An ADVERTISING executive creates:",
        "o": [
          "Financial accounts for companies",
          "Promotional campaigns — advertisements for TV, radio, social media, and print",
          "Insurance policies",
          "Transport routes for goods"
        ],
        "a": 1,
        "e": "ADVERTISING: creates promotional campaigns, manages media placements.",
        "h": "Advertising: creates promotional campaigns for various media.",
        "yr": "SS1"
      },
      {
        "q": "The qualifications needed for banking in Nigeria include:",
        "o": [
          "Only SSCE/WAEC",
          "University degree (any discipline) plus professional banking qualification (CIBN)",
          "Only medical qualifications",
          "Only engineering degree"
        ],
        "a": 1,
        "e": "Banking: university degree + CIBN professional qualification.",
        "h": "Banking qualifications: university degree + CIBN.",
        "yr": "SS1"
      },
      {
        "q": "E-commerce careers in Nigeria involve:",
        "o": [
          "Only coding and software development",
          "Digital marketing, online store management, logistics for internet purchases, payment processing",
          "Only banking transactions",
          "Only traditional retail"
        ],
        "a": 1,
        "e": "E-COMMERCE: digital marketing, online store management, delivery logistics, payments.",
        "h": "E-commerce: digital marketing, online store, delivery, payments.",
        "yr": "SS1"
      },
      {
        "q": "Supply chain management involves:",
        "o": [
          "Only managing a single warehouse",
          "Coordinating the entire flow — from raw material sourcing through production to delivery to final customer",
          "Only accounting for inventory",
          "Only transport planning"
        ],
        "a": 1,
        "e": "SUPPLY CHAIN: comprehensive coordination from sourcing to end customer.",
        "h": "Supply chain management: entire goods flow from raw materials to final customer.",
        "yr": "SS1"
      },
      {
        "q": "The FIRS (Federal Inland Revenue Service) collects:",
        "o": [
          "Managing Nigeria's seaports",
          "Federal taxes: VAT, corporate income tax, petroleum profit tax, withholding tax",
          "Regulating the stock exchange",
          "Managing Nigeria's foreign exchange"
        ],
        "a": 1,
        "e": "FIRS: federal tax collection — VAT, corporate income tax, petroleum profit tax.",
        "h": "FIRS: collects federal taxes (VAT, corporate income tax, etc.).",
        "yr": "SS1"
      },
      {
        "q": "Which professional body regulates accounting in Nigeria?",
        "o": [
          "CIBN (banking)",
          "ICAN (accounting)",
          "CIIN (insurance)",
          "NCC (telecoms)"
        ],
        "a": 1,
        "e": "ICAN = accounting regulator. CIBN = banking. CIIN = insurance.",
        "h": "ICAN = accounting. CIBN = banking. CIIN = insurance.",
        "yr": "SS1"
      },
      {
        "q": "Commerce graduates can work in all of the following EXCEPT:",
        "o": [
          "FIRS and CBN",
          "SEC and NCC",
          "NAFDAC and Nigeria Customs",
          "Medical hospitals as surgeons"
        ],
        "a": 3,
        "e": "Commerce graduates: FIRS, CBN, SEC, NCC, Customs, NAFDAC, NEPC, and more. Not surgeons.",
        "h": "Commerce graduates: FIRS, CBN, SEC, NCC, Customs, NAFDAC. Not surgeons.",
        "yr": "SS1"
      },
      {
        "q": "A career in supply chain management is high-demand because:",
        "o": [
          "It is a government-mandated career",
          "Modern businesses need efficient movement of goods from raw materials to consumers — critical in manufacturing and FMCG companies",
          "Only large companies need supply chains",
          "Supply chains are simple and require no expertise"
        ],
        "a": 1,
        "e": "SCM is critical: efficient goods movement from raw materials to end customer drives business success.",
        "h": "SCM is high-demand: critical for manufacturing and FMCG company success.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Cooperative Society",
    "topicCode": "SS1-COM-16",
    "module": "Forms of Business Ownership",
    "term": "Second Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Cooperative Society</span>: Cooperative = voluntary, democratic (1 member 1 vote), equitable distribution. Types: consumer, credit/savings, marketing, housing, worker. Nigeria: esusu/ajo. Rochdale principles. Problems: poor management, misappropriation.</div>",
    "questions": [
      {
        "q": "A cooperative society is best defined as:",
        "o": [
          "A government-owned enterprise",
          "Voluntary association of people with common interests who pool resources to achieve mutual economic benefit",
          "A private limited company",
          "A partnership between two businesses"
        ],
        "a": 1,
        "e": "COOPERATIVE: voluntary association, democratic management, equitable benefit sharing.",
        "h": "Cooperative = voluntary association pooling resources for mutual benefit.",
        "yr": "SS1"
      },
      {
        "q": "The Rochdale Pioneers are significant because:",
        "o": [
          "They founded the first bank in England",
          "They established the first successful consumer cooperative in Rochdale, England (1844) — setting cooperative principles",
          "They discovered cooperatives in Africa",
          "They introduced cooperatives to Nigeria"
        ],
        "a": 1,
        "e": "ROCHDALE PIONEERS (1844): 28 weavers founded first successful consumer cooperative.",
        "h": "Rochdale Pioneers (1844): first successful cooperative, set cooperative principles.",
        "yr": "SS1"
      },
      {
        "q": "Which of the following is a cooperative PRINCIPLE?",
        "o": [
          "Maximum profit for founders",
          "One member, one vote (democratic control regardless of capital contributed)",
          "Members have unlimited liability",
          "Only wealthy people can join"
        ],
        "a": 1,
        "e": "COOPERATIVE PRINCIPLES: 1 member = 1 vote (democratic), voluntary, equitable distribution.",
        "h": "Cooperative: 1 member = 1 vote (democratic control).",
        "yr": "SS1"
      },
      {
        "q": "A CONSUMER cooperative is formed to:",
        "o": [
          "Produce goods for export",
          "Buy goods in bulk at wholesale prices and sell to members at reduced retail prices",
          "Provide housing for members",
          "Give loans to members"
        ],
        "a": 1,
        "e": "CONSUMER COOPERATIVE: pools resources to buy bulk, distributes cheaper to members.",
        "h": "Consumer cooperative: buys bulk, sells to members at lower prices.",
        "yr": "SS1"
      },
      {
        "q": "A CREDIT/SAVINGS cooperative (thrift society) provides:",
        "o": [
          "Jobs in manufacturing for members",
          "Savings and loan services — members save together and borrow at lower interest than commercial banks",
          "Free goods to members",
          "Marketing services for products"
        ],
        "a": 1,
        "e": "CREDIT COOPERATIVE: members save together, borrow at lower interest than banks.",
        "h": "Credit cooperative: save together, borrow at low rates.",
        "yr": "SS1"
      },
      {
        "q": "The Nigerian informal savings practice Esusu/Ajo is similar to a cooperative because:",
        "o": [
          "They are identical",
          "Both involve collective saving and mutual assistance — rotating contributions among members",
          "Only esusu involves money",
          "Cooperatives are always more modern"
        ],
        "a": 1,
        "e": "ESUSU/AJO: rotating savings group. Collective saving, interest-free lump sum each turn.",
        "h": "Esusu/Ajo = rotating savings group. Similar cooperative principle.",
        "yr": "SS1"
      },
      {
        "q": "A MARKETING cooperative helps members by:",
        "o": [
          "Providing housing",
          "Collectively marketing members' products — negotiating better prices and accessing wider markets",
          "Giving credit to members",
          "Producing goods for members"
        ],
        "a": 1,
        "e": "MARKETING COOPERATIVE: collective selling → better bargaining power, wider markets.",
        "h": "Marketing cooperative: collectively sells members' products for better prices.",
        "yr": "SS1"
      },
      {
        "q": "How does a cooperative differ from a private limited company?",
        "o": [
          "No differences between them",
          "Cooperative: member-based, 1 member 1 vote (democratic); Company: investor-owned, votes proportional to shares",
          "Cooperatives earn more profit",
          "Companies are more democratic"
        ],
        "a": 1,
        "e": "Key: cooperative = 1 member 1 vote; company = votes by shares held.",
        "h": "Cooperative: 1 member 1 vote vs company: votes proportional to shares.",
        "yr": "SS1"
      },
      {
        "q": "Cooperative societies in Nigeria register with:",
        "o": [
          "Corporate Affairs Commission (CAC) as companies",
          "State and Federal Cooperative registries under the Cooperative Societies Law",
          "Securities and Exchange Commission",
          "CBN"
        ],
        "a": 1,
        "e": "Cooperatives: state/federal cooperative registry, not CAC.",
        "h": "Cooperatives register with State/Federal cooperative registry.",
        "yr": "SS1"
      },
      {
        "q": "'Dividend on purchase' (divi) in cooperatives means:",
        "o": [
          "Dividends paid based on shares held",
          "Surplus distributed in proportion to how much members purchased from the cooperative — not based on capital",
          "Only the founders receive dividends",
          "No dividends are ever paid"
        ],
        "a": 1,
        "e": "DIVIDEND ON PURCHASE: surplus shared by transactions (purchases), not capital.",
        "h": "Dividend on purchase: surplus based on how much you bought, not capital.",
        "yr": "SS1"
      },
      {
        "q": "An agricultural cooperative in Benue State benefits farmers by:",
        "o": [
          "Eliminating individual farming",
          "Pooling resources to buy inputs cheaply, collectively marketing produce for better prices, sharing equipment",
          "Paying farmers government salaries",
          "Replacing all traditional farming"
        ],
        "a": 1,
        "e": "Agricultural cooperative: bulk inputs (cheaper), collective marketing, equipment sharing.",
        "h": "Agricultural cooperative: cheap inputs + collective marketing + equipment sharing.",
        "yr": "SS1"
      },
      {
        "q": "A HOUSING cooperative aims to:",
        "o": [
          "Build commercial real estate for profit",
          "Help members collectively finance and build affordable housing — members contribute to fund housing",
          "Provide mortgage loans only",
          "Manage government housing projects"
        ],
        "a": 1,
        "e": "HOUSING COOPERATIVE: members collectively finance housing at lower cost.",
        "h": "Housing cooperative: members pool funds for affordable housing.",
        "yr": "SS1"
      },
      {
        "q": "The 'voluntary open membership' principle means:",
        "o": [
          "Anyone can join without contributing",
          "Membership is open to all who share the cooperative's purpose — no discrimination based on ethnicity, religion, or gender",
          "Government decides who can join",
          "Only founding members can join"
        ],
        "a": 1,
        "e": "VOLUNTARY OPEN MEMBERSHIP: open to anyone meeting requirements. No discrimination.",
        "h": "Voluntary open membership: open to all sharing purpose, no discrimination.",
        "yr": "SS1"
      },
      {
        "q": "A major PROBLEM of cooperatives in Nigeria is:",
        "o": [
          "Too many members wanting to join",
          "Management challenges — poor management, fund misappropriation, political interference, low member commitment",
          "Too much profit generated",
          "Too little need for cooperatives"
        ],
        "a": 1,
        "e": "Nigerian cooperative problems: poor management, corruption, political interference, low participation.",
        "h": "Nigerian cooperative problems: poor management, misappropriation, political interference.",
        "yr": "SS1"
      },
      {
        "q": "A WORKER cooperative is one where:",
        "o": [
          "The government employs all workers",
          "The workers themselves own and manage the enterprise democratically — each worker is an equal owner",
          "Managers own and control the business",
          "Investors own but workers manage"
        ],
        "a": 1,
        "e": "WORKER COOPERATIVE: workers OWN the enterprise. Equal member-owners.",
        "h": "Worker cooperative: workers own and manage democratically.",
        "yr": "SS1"
      },
      {
        "q": "Cooperative societies contribute to national development by:",
        "o": [
          "Replacing all private businesses",
          "Providing financial services to the unbanked, supporting agricultural production, creating employment, fostering self-reliance",
          "Making people dependent on government",
          "Concentrating wealth in few hands"
        ],
        "a": 1,
        "e": "Cooperative development: financial inclusion, agricultural productivity, employment, self-help culture.",
        "h": "Cooperatives: financial inclusion + agricultural development + employment + self-reliance.",
        "yr": "SS1"
      },
      {
        "q": "'Interest on capital' in a cooperative differs from company dividends because:",
        "o": [
          "They are identical concepts",
          "Interest on capital in cooperatives is limited/capped — cooperative is not primarily profit-seeking",
          "Companies pay no dividends",
          "Cooperatives always pay more than companies"
        ],
        "a": 1,
        "e": "Cooperative: interest on capital is LIMITED. Surplus goes to member services not profit.",
        "h": "Cooperative: interest on capital is limited/capped. Not primarily profit-seeking.",
        "yr": "SS1"
      },
      {
        "q": "Which government agency supports cooperative development in Nigeria?",
        "o": [
          "EFCC (anti-corruption)",
          "Federal Cooperative College (Ibadan) and Cooperative Development Department",
          "Nigeria Customs Service",
          "NAFDAC"
        ],
        "a": 1,
        "e": "Federal Cooperative College (Ibadan) trains cooperative officials; Cooperative Development Dept supports.",
        "h": "Federal Cooperative College + Cooperative Development Dept = support cooperatives.",
        "yr": "SS1"
      },
      {
        "q": "The main difference between esusu/ajo and a formal cooperative society:",
        "o": [
          "They are identical",
          "Esusu/ajo is informal, unregistered, trust-based; Formal cooperative is registered, has legal protection and governance",
          "Cooperatives are illegal in Nigeria",
          "Esusu always involves more members"
        ],
        "a": 1,
        "e": "ESUSU = informal, unregistered, trust. COOPERATIVE = registered, legal, structured/regulated.",
        "h": "Esusu = informal/trust. Cooperative = registered/legal/structured.",
        "yr": "SS1"
      },
      {
        "q": "Rochdale cooperative principles included:",
        "o": [
          "Profit maximisation for founders",
          "Voluntary open membership, democratic control (1 member 1 vote), equitable distribution, cooperative education",
          "Mandatory membership for all residents",
          "Unlimited liability for all members"
        ],
        "a": 1,
        "e": "Rochdale: voluntary open membership, democratic control, equitable distribution, cooperative education.",
        "h": "Rochdale: voluntary, democratic, equitable distribution, education.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Public Enterprises",
    "topicCode": "SS1-COM-17",
    "module": "Forms of Business Ownership",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Public Enterprises</span>: Public enterprise = government-owned. Types: departmental undertakings, public corporations, joint enterprises. Examples: NNPCL, NPA, NTA, CBN, FAAN, NIPOST. Merits: essential services. Demerits: inefficiency, corruption, political interference.</div>",
    "questions": [
      {
        "q": "A public enterprise is one:",
        "o": [
          "Owned by members of the public through share purchase",
          "Owned and operated by government (federal, state, or local) for public benefit",
          "Owned by a private individual",
          "Run by a cooperative society"
        ],
        "a": 1,
        "e": "PUBLIC ENTERPRISE: owned, financed, managed by government.",
        "h": "Public enterprise = owned/operated by government for public benefit.",
        "yr": "SS1"
      },
      {
        "q": "Which is a Nigerian public enterprise (parastatal)?",
        "o": [
          "Dangote Group",
          "Zenith Bank",
          "Nigerian National Petroleum Company Limited (NNPCL)",
          "Shoprite Nigeria"
        ],
        "a": 2,
        "e": "NNPCL = public enterprise owned by Federal Government. NPA, NIPOST, CBN, NTA also public enterprises.",
        "h": "NNPCL = public enterprise (government-owned). Dangote, Zenith, Shoprite = private.",
        "yr": "SS1"
      },
      {
        "q": "A DEPARTMENTAL UNDERTAKING as a public enterprise is:",
        "o": [
          "A government department directly operating a commercial/service activity (e.g., government printing press)",
          "A private department within a public company",
          "An NGO run by government officials",
          "A cooperative managed by government"
        ],
        "a": 0,
        "e": "DEPARTMENTAL UNDERTAKING: ministry directly operates commercial/service activity. Budget-funded.",
        "h": "Departmental undertaking: government ministry directly operates commercial activity.",
        "yr": "SS1"
      },
      {
        "q": "A PUBLIC CORPORATION differs from a departmental undertaking because:",
        "o": [
          "Public corporations are private companies",
          "Public corporations have separate legal identity (by statute), professional management, commercial orientation, more autonomy",
          "Departmental undertakings earn more profit",
          "There is no difference"
        ],
        "a": 1,
        "e": "PUBLIC CORPORATION: created by statute as separate legal entity. Has own board, management, finances.",
        "h": "Public corporation: separate legal identity (by statute), own management, commercial orientation.",
        "yr": "SS1"
      },
      {
        "q": "The Nigerian Ports Authority (NPA) is an example of a:",
        "o": [
          "Private limited company",
          "Public corporation (statutory corporation) managing Nigeria's sea ports",
          "Cooperative society",
          "Sole proprietorship"
        ],
        "a": 1,
        "e": "NPA = public corporation: created by statute, manages seaports, has own board and management.",
        "h": "NPA = public corporation (statutory corporation) managing seaports.",
        "yr": "SS1"
      },
      {
        "q": "Why does government establish public enterprises?",
        "o": [
          "To compete with private businesses only",
          "To provide essential services, control natural monopolies, develop strategic industries, generate employment",
          "To maximise profits for government",
          "To give employees stable jobs"
        ],
        "a": 1,
        "e": "Public enterprise reasons: essential services, control monopolies, strategic industries, employment.",
        "h": "Public enterprises: provide essential services, control monopolies, strategic industries, employment.",
        "yr": "SS1"
      },
      {
        "q": "A MERIT of public enterprises is:",
        "o": [
          "They are always efficient and profitable",
          "They provide essential services that may not be profitable for private businesses — ensuring universal access",
          "They are always free of corruption",
          "They always make profit"
        ],
        "a": 1,
        "e": "Merit: provides ESSENTIAL SERVICES even in unprofitable areas — universal service obligation.",
        "h": "Public enterprise merit: provides essential services even in unprofitable areas.",
        "yr": "SS1"
      },
      {
        "q": "A major DEMERIT of public enterprises in Nigeria:",
        "o": [
          "They invest too much capital",
          "Inefficiency, corruption, and poor management — losses funded by taxpayers",
          "They compete too fairly with private firms",
          "They are too profitable"
        ],
        "a": 1,
        "e": "Nigerian public enterprise problems: chronic inefficiency, massive corruption, poor management, losses.",
        "h": "Public enterprise demerits: inefficiency, corruption, poor management, taxpayer-funded losses.",
        "yr": "SS1"
      },
      {
        "q": "PRIVATISATION (like NEPA → distribution companies) was meant to:",
        "o": [
          "Give enterprises to government employees",
          "Transfer to private ownership to improve efficiency, reduce government burden, introduce competition",
          "Nationalise more private companies",
          "Create more government jobs"
        ],
        "a": 1,
        "e": "PRIVATISATION: transfer to private sector for efficiency, competition, reduced government burden.",
        "h": "Privatisation: transfer to private ownership for efficiency and competition.",
        "yr": "SS1"
      },
      {
        "q": "'Political interference' as a public enterprise problem means:",
        "o": [
          "Government inspects public enterprises",
          "Politicians appoint loyalists over competent managers, make commercial decisions for political reasons",
          "The public protests against enterprises",
          "International politics affecting enterprises"
        ],
        "a": 1,
        "e": "Political interference: loyalists appointed, political pricing/contracts → inefficiency.",
        "h": "Political interference: loyalists appointed, political decisions → inefficiency.",
        "yr": "SS1"
      },
      {
        "q": "A JOINT ENTERPRISE combines:",
        "o": [
          "Two private companies only",
          "Government and private sector — government holds equity stake, private sector provides management and capital",
          "Two government departments",
          "Government and international organisations only"
        ],
        "a": 1,
        "e": "JOINT ENTERPRISE: government + private sector jointly own/manage. NNPCL JVs with Shell, Total, Chevron.",
        "h": "Joint enterprise: government + private sector together.",
        "yr": "SS1"
      },
      {
        "q": "NIPOST (Nigerian Postal Service) provides:",
        "o": [
          "Petroleum services",
          "Postal and courier services — letters, parcels, money orders, philatelic services",
          "Banking services only",
          "Insurance services"
        ],
        "a": 1,
        "e": "NIPOST: postal/courier services nationwide — letter delivery, parcels, money orders, agency banking.",
        "h": "NIPOST = Nigerian postal service (letters, parcels, money orders).",
        "yr": "SS1"
      },
      {
        "q": "CBN (Central Bank of Nigeria) is a public enterprise because:",
        "o": [
          "It is privately owned by shareholders",
          "It is government-owned, manages monetary policy, regulates banking, issues currency — public functions",
          "It is a cooperative bank",
          "It is jointly owned with foreign banks"
        ],
        "a": 1,
        "e": "CBN = government-owned central bank. Performs public functions: monetary policy, banking regulation, naira.",
        "h": "CBN = government-owned. Manages monetary policy, regulates banks, issues naira.",
        "yr": "SS1"
      },
      {
        "q": "Subsidies to public enterprises in Nigeria mean:",
        "o": [
          "Public enterprises donate to government",
          "Government provides financial support covering losses — paid by taxpayers",
          "Public enterprises earn extra profits",
          "Subsidies go directly to employees"
        ],
        "a": 1,
        "e": "Subsidies: government covers public enterprise losses from tax revenue.",
        "h": "Subsidies: government covers public enterprise losses using taxpayer money.",
        "yr": "SS1"
      },
      {
        "q": "FAAN (Federal Airports Authority of Nigeria) manages:",
        "o": [
          "Nigeria's seaports",
          "Nigerian airports (Lagos, Abuja, Port Harcourt, Kano) — ensuring safe aviation operations",
          "Nigerian railways",
          "Government printing press"
        ],
        "a": 1,
        "e": "FAAN: manages Nigeria's major airports. Ensures aviation safety and services.",
        "h": "FAAN = manages Nigerian airports (Lagos, Abuja, PH, Kano).",
        "yr": "SS1"
      },
      {
        "q": "NTA (Nigerian Television Authority) is a:",
        "o": [
          "Private television network",
          "Public broadcasting corporation owned by Federal Government, providing television services to Nigerians",
          "Newspaper company",
          "Radio station only"
        ],
        "a": 1,
        "e": "NTA = federal government public broadcaster. Operates nationwide TV stations. Oldest TV network.",
        "h": "NTA = federal government public television broadcaster.",
        "yr": "SS1"
      },
      {
        "q": "A 'natural monopoly' justifies public enterprise when:",
        "o": [
          "Government wants to eliminate all competition",
          "Infrastructure costs so high that one provider is most efficient — railways, gas pipelines",
          "Government wants to earn profits",
          "Private businesses refuse to enter a market"
        ],
        "a": 1,
        "e": "NATURAL MONOPOLY: one network (railway, electricity grid) most efficient. Government owns to prevent exploitation.",
        "h": "Natural monopoly: one network most efficient. Government owns to prevent private exploitation.",
        "yr": "SS1"
      },
      {
        "q": "Why is CBN the 'lender of last resort'?",
        "o": [
          "It lends to everyone who asks",
          "It provides emergency loans to commercial banks facing liquidity crises — preventing banking system collapse",
          "It is the cheapest lender",
          "It only lends to government"
        ],
        "a": 1,
        "e": "LENDER OF LAST RESORT: CBN provides emergency liquidity to distressed banks. Prevents banking collapse.",
        "h": "CBN = lender of last resort: emergency loans to distressed banks, prevents banking collapse.",
        "yr": "SS1"
      },
      {
        "q": "The FAILURE of many Nigerian public enterprises is attributed to:",
        "o": [
          "Too much competition from private sector",
          "Corruption, political appointments over merit, lack of market incentives, poor management",
          "Working too hard without enough capital",
          "Private sector refusing to compete with them"
        ],
        "a": 1,
        "e": "Nigerian public enterprise failure: corruption + political appointments + no market incentives + poor management.",
        "h": "Nigerian public enterprise failure: corruption + political appointments + no market incentives.",
        "yr": "SS1"
      },
      {
        "q": "The NATIONAL BROADCASTING COMMISSION (NBC) regulates:",
        "o": [
          "Nigeria's ports and shipping",
          "Broadcasting — licensing and monitoring radio and television stations in Nigeria",
          "Banking sector",
          "Stock exchange"
        ],
        "a": 1,
        "e": "NBC: grants licences to radio/TV stations, sets broadcast standards, enforces broadcasting code.",
        "h": "NBC = regulates broadcasting (radio/TV stations) in Nigeria.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Limited Companies I",
    "topicCode": "SS1-COM-18",
    "module": "Forms of Business Ownership",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Limited Companies I</span>: Limited company = members' liability limited to share capital. Types: Private Ltd (1-50 members, no public shares) and Public Plc (min 7, listed on NGX). Formation: MOA, AOA, CAC registration. Features: separate legal entity, perpetual succession, limited liability.</div>",
    "questions": [
      {
        "q": "A limited liability company is one where:",
        "o": [
          "Government owns and operates it",
          "Members' financial liability is limited to their share capital — personal assets protected from company debts",
          "Members have unlimited personal liability",
          "Only one person can be a member"
        ],
        "a": 1,
        "e": "LIMITED LIABILITY: shareholders only lose their investment. Personal assets protected.",
        "h": "Limited liability: members only lose their investment. Personal assets protected.",
        "yr": "SS1"
      },
      {
        "q": "The Memorandum of Association (MOA) contains:",
        "o": [
          "Internal rules for managing the company",
          "External rules: company name, registered address, objects (purpose), authorised share capital, member liability",
          "Share transfer procedures only",
          "Only names of directors"
        ],
        "a": 1,
        "e": "MEMORANDUM: company name, registered address, objects clause, liability clause, authorised capital.",
        "h": "Memorandum of Association: name, address, objects, capital, liability. External document.",
        "yr": "SS1"
      },
      {
        "q": "The Articles of Association (AOA) contains:",
        "o": [
          "The company's external trading rules",
          "Internal management rules: director powers, board meetings, share transfer, dividend payment, borrowing powers",
          "Only the company's address",
          "Government regulations"
        ],
        "a": 1,
        "e": "ARTICLES: director powers, board meetings, shareholder rights, share transfer, dividend procedures.",
        "h": "Articles of Association: internal rules — director powers, meetings, share transfer, dividends.",
        "yr": "SS1"
      },
      {
        "q": "A private limited company (Ltd) must have:",
        "o": [
          "Minimum 7 shareholders",
          "Minimum 1, maximum 50 shareholders",
          "Minimum 100 shareholders",
          "No minimum shareholders"
        ],
        "a": 1,
        "e": "PRIVATE LTD: minimum 1 (single-member), maximum 50 shareholders. No public share offers.",
        "h": "Private Ltd: minimum 1, maximum 50 shareholders.",
        "yr": "SS1"
      },
      {
        "q": "A public limited company (Plc) can:",
        "o": [
          "Have maximum 50 shareholders only",
          "Offer shares to the general public on the stock exchange, raise large capital, minimum 7 shareholders",
          "Restrict share transfer freely",
          "Have only one director"
        ],
        "a": 1,
        "e": "PUBLIC PLC: minimum 7 shareholders (no maximum), can offer shares publicly via NGX.",
        "h": "Public Plc: offers shares to public on stock exchange. Min 7 shareholders.",
        "yr": "SS1"
      },
      {
        "q": "'Perpetual succession' as a feature of limited companies means:",
        "o": [
          "The company operates perpetually without paying taxes",
          "The company has continuous legal existence regardless of changes in membership",
          "Directors serve for life",
          "All members must agree to continue"
        ],
        "a": 1,
        "e": "PERPETUAL SUCCESSION: company continues regardless of shareholder changes. Unlike partnerships.",
        "h": "Perpetual succession: company continues regardless of member changes.",
        "yr": "SS1"
      },
      {
        "q": "The Corporate Affairs Commission (CAC) is responsible for:",
        "o": [
          "Managing Nigeria's stock exchange",
          "Registering and regulating companies — issuing certificates of incorporation, maintaining company registry",
          "Controlling banking sector",
          "Collecting company taxes"
        ],
        "a": 1,
        "e": "CAC: registers companies, issues Certificate of Incorporation, maintains company registry.",
        "h": "CAC: registers companies, issues Certificate of Incorporation.",
        "yr": "SS1"
      },
      {
        "q": "The 'ultra vires' doctrine means:",
        "o": [
          "Companies have unlimited powers",
          "A company can only act within its MOA's objects clause — actions beyond it are void",
          "Directors have unlimited authority",
          "All actions voted on by shareholders"
        ],
        "a": 1,
        "e": "ULTRA VIRES: actions beyond the company's objects clause in MOA are void.",
        "h": "Ultra vires: company can only act within MOA's objects clause.",
        "yr": "SS1"
      },
      {
        "q": "'Separate legal entity' means a limited company:",
        "o": [
          "Is a different nationality from its owners",
          "Is treated by law as a distinct person from its shareholders — can sue/be sued in its own name",
          "Cannot employ workers",
          "Cannot make contracts"
        ],
        "a": 1,
        "e": "SEPARATE LEGAL ENTITY (Salomon v Salomon, 1897): company distinct legal person from shareholders.",
        "h": "Separate legal entity: company is distinct legal person from shareholders.",
        "yr": "SS1"
      },
      {
        "q": "The CAMA (Companies and Allied Matters Act) of Nigeria:",
        "o": [
          "Was enacted only in 1960",
          "Is the primary legislation governing companies — significantly amended in 2020",
          "Only regulates sole proprietorships",
          "Was abolished in 2020"
        ],
        "a": 1,
        "e": "CAMA: Nigeria's primary corporate law. Originally 1990; significantly amended in 2020 (CAMA 2020).",
        "h": "CAMA = Nigeria's primary company law. Governs incorporation, management, winding-up.",
        "yr": "SS1"
      },
      {
        "q": "Why is limited liability important for attracting investment?",
        "o": [
          "It makes investment risk-free",
          "Investors risk only their investment amount — personal assets protected, willing to invest without full management control",
          "Limited liability increases risk",
          "It makes companies more profitable automatically"
        ],
        "a": 1,
        "e": "LIMITED LIABILITY encourages INVESTMENT: maximum loss = investment amount. Encourages share purchase.",
        "h": "Limited liability attracts investment: only investment at risk. Personal assets safe.",
        "yr": "SS1"
      },
      {
        "q": "A private limited company (Ltd) CANNOT:",
        "o": [
          "Have shareholders",
          "Sell goods and services",
          "Invite the general public to buy its shares — must restrict share transfer",
          "Have employees"
        ],
        "a": 2,
        "e": "Private Ltd RESTRICTION: cannot publicly offer shares. No stock exchange listing.",
        "h": "Private Ltd cannot offer shares to public.",
        "yr": "SS1"
      },
      {
        "q": "'Pre-emption rights' in a private limited company means:",
        "o": [
          "Directors hire employees first",
          "Existing shareholders have first right to buy shares being sold by another shareholder before outsiders",
          "Largest shareholder controls company",
          "First director gets special votes"
        ],
        "a": 1,
        "e": "PRE-EMPTION RIGHTS: existing shareholders offered shares first before outsiders.",
        "h": "Pre-emption rights: existing shareholders first right to buy shares.",
        "yr": "SS1"
      },
      {
        "q": "A 'quorum' in a company meeting refers to:",
        "o": [
          "The CEO's voting power",
          "Minimum number of members that must be present for a meeting to validly conduct business",
          "The meeting agenda",
          "Maximum number of attendees"
        ],
        "a": 1,
        "e": "QUORUM: minimum members present for meeting to be legally valid.",
        "h": "Quorum = minimum members present for meeting to be valid.",
        "yr": "SS1"
      },
      {
        "q": "A Certificate of Incorporation is issued to a company by CAC when:",
        "o": [
          "The company makes its first profit",
          "Company meets all registration requirements — CAC confirms compliance and grants legal existence",
          "Directors are appointed",
          "Company registers with SEC"
        ],
        "a": 1,
        "e": "CERTIFICATE OF INCORPORATION: issued when company properly registered under CAMA. Proof of legal existence.",
        "h": "Certificate of Incorporation: CAC issues when registration complete. Proof of existence.",
        "yr": "SS1"
      },
      {
        "q": "'Proxy' voting in company meetings means:",
        "o": [
          "Voting by the largest shareholder only",
          "A shareholder authorises another person to attend and vote on their behalf when they cannot attend",
          "Directors vote instead of shareholders",
          "Electronic voting only"
        ],
        "a": 1,
        "e": "PROXY: written authority allowing another person to vote on shareholder's behalf.",
        "h": "Proxy: shareholder authorises another to vote on their behalf.",
        "yr": "SS1"
      },
      {
        "q": "Which must publish annual audited financial statements?",
        "o": [
          "Sole proprietorship",
          "General partnership",
          "Both Private Ltd (files with CAC) and Public Plc (publishes publicly to SEC and NGX)",
          "Small market traders"
        ],
        "a": 2,
        "e": "Filing: Private Ltd → CAC. Public Plc → SEC, NGX, and public. Sole traders: no public disclosure.",
        "h": "Ltd files with CAC. Plc publishes publicly (SEC, NGX).",
        "yr": "SS1"
      },
      {
        "q": "Under CAMA 2020, minimum share capital for a private limited company:",
        "o": [
          "₦1,000,000",
          "₦100,000",
          "No minimum stated — removed by CAMA 2020",
          "₦10,000,000"
        ],
        "a": 2,
        "e": "CAMA 2020: removed minimum share capital requirement for private Ltd. Reduced barriers.",
        "h": "CAMA 2020: no minimum share capital for private Ltd.",
        "yr": "SS1"
      },
      {
        "q": "How does a Plc differ from a Ltd in share transfer?",
        "o": [
          "Both have same rules",
          "Ltd restricts share transfer (pre-emption rights, board approval); Plc shares freely traded on NGX",
          "Plc restricts share transfer",
          "Both prohibit all transfers"
        ],
        "a": 1,
        "e": "Ltd: restricted transfer. Plc: freely traded on NGX. Anyone can buy/sell Plc shares.",
        "h": "Ltd restricts share transfer. Plc shares freely traded on NGX.",
        "yr": "SS1"
      },
      {
        "q": "Which is a feature UNIQUE to limited companies (not sole proprietorships or partnerships)?",
        "o": [
          "Paying taxes",
          "Employing workers",
          "Separate legal entity with perpetual succession and limited liability",
          "Operating in Nigeria"
        ],
        "a": 2,
        "e": "Limited company features: separate legal entity, perpetual succession, limited liability.",
        "h": "Unique to limited companies: separate legal entity + perpetual succession + limited liability.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Limited Companies II",
    "topicCode": "SS1-COM-19",
    "module": "Forms of Business Ownership",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Limited Companies II</span>: Company management: Board of Directors elected by shareholders. Share types: ordinary (voting, variable dividend), preference (fixed dividend, priority). Debentures = company debt. Winding up: compulsory (court) or voluntary. Liquidation priority order.</div>",
    "questions": [
      {
        "q": "Shareholders in a limited company elect:",
        "o": [
          "The company's customers",
          "The Board of Directors — who manage company on shareholders' behalf",
          "Government officials",
          "The company's bank"
        ],
        "a": 1,
        "e": "SHAREHOLDERS elect BOARD OF DIRECTORS at AGM. Directors manage on shareholders' behalf.",
        "h": "Shareholders elect Board of Directors at AGM.",
        "yr": "SS1"
      },
      {
        "q": "An 'ordinary share' gives the holder:",
        "o": [
          "Fixed dividend regardless of profits",
          "Voting rights at general meetings and variable dividend based on company profits",
          "Priority claim on assets in liquidation",
          "No right to sell shares"
        ],
        "a": 1,
        "e": "ORDINARY SHARES: voting rights + variable dividend (may be nil if no profit) + last in liquidation.",
        "h": "Ordinary shares: voting rights + variable dividend + last in liquidation.",
        "yr": "SS1"
      },
      {
        "q": "A 'preference share' gives the holder:",
        "o": [
          "Unlimited voting rights",
          "Fixed dividend paid before ordinary shareholders, priority in liquidation, usually no voting rights",
          "Variable dividend only",
          "First choice on all company decisions"
        ],
        "a": 1,
        "e": "PREFERENCE SHARES: FIXED dividend + PRIORITY in liquidation + usually NO VOTING RIGHTS.",
        "h": "Preference shares: fixed dividend + priority in liquidation + usually no voting.",
        "yr": "SS1"
      },
      {
        "q": "A 'debenture' is:",
        "o": [
          "A type of company share",
          "A loan instrument issued by a company — holder is a creditor earning fixed interest",
          "A government bond",
          "A company trading licence"
        ],
        "a": 1,
        "e": "DEBENTURE: debt instrument. Holder is CREDITOR (not owner). Earns fixed INTEREST.",
        "h": "Debenture = company debt. Holder is creditor (not owner). Fixed interest.",
        "yr": "SS1"
      },
      {
        "q": "'Annual General Meeting' (AGM) is held to:",
        "o": [
          "Negotiate with suppliers",
          "Shareholders meet annually to receive directors' report, declare dividends, elect directors, appoint auditors",
          "Compete with other companies",
          "Register the company with CAC"
        ],
        "a": 1,
        "e": "AGM: receive audited accounts, declare dividend, elect directors, appoint auditors.",
        "h": "AGM: annual shareholder meeting — accounts, dividends, directors, auditors.",
        "yr": "SS1"
      },
      {
        "q": "'Dividend' in a company context is:",
        "o": [
          "The company's total revenue",
          "Portion of company profit distributed to shareholders — declared at AGM based on board recommendation",
          "Monthly salary of all employees",
          "Interest paid on debentures"
        ],
        "a": 1,
        "e": "DIVIDEND: share of AFTER-TAX PROFIT distributed to shareholders. Declared at AGM.",
        "h": "Dividend: share of profit distributed to shareholders. Declared at AGM.",
        "yr": "SS1"
      },
      {
        "q": "The 'Board of Directors':",
        "o": [
          "Are the same as shareholders",
          "Are elected managers responsible for strategy, overseeing management, and major decisions on behalf of shareholders",
          "Are employees without ownership rights",
          "Are appointed by CAC"
        ],
        "a": 1,
        "e": "BOARD OF DIRECTORS: elected by shareholders to manage company on their behalf.",
        "h": "Board of Directors: elected by shareholders, sets strategy, oversees management.",
        "yr": "SS1"
      },
      {
        "q": "'Authorised share capital' means:",
        "o": [
          "The actual shares already sold to the public",
          "Maximum share capital the company is authorised to issue — as stated in MOA",
          "The company's total assets value",
          "Dividends declared in a year"
        ],
        "a": 1,
        "e": "AUTHORISED CAPITAL: maximum shares company can issue as specified in MOA.",
        "h": "Authorised share capital: maximum shares company can issue (stated in MOA).",
        "yr": "SS1"
      },
      {
        "q": "'Issued/paid-up share capital' is:",
        "o": [
          "Total authorised capital",
          "The portion of authorised capital actually issued to and paid for by shareholders",
          "Capital planned for future",
          "Capital lost through operations"
        ],
        "a": 1,
        "e": "ISSUED/PAID-UP CAPITAL: shares actually allotted to shareholders who paid. Always ≤ authorised capital.",
        "h": "Issued/paid-up capital: actually allotted and paid for. Always ≤ authorised capital.",
        "yr": "SS1"
      },
      {
        "q": "'Compulsory winding-up' occurs:",
        "o": [
          "When company decides to close voluntarily",
          "By court order — when company cannot pay debts (insolvency) or on just and equitable grounds",
          "When all directors resign",
          "When shareholders change company name"
        ],
        "a": 1,
        "e": "COMPULSORY WINDING-UP: by court order. Usually when company can't pay debts (insolvency).",
        "h": "Compulsory winding-up: court order. Usually due to insolvency.",
        "yr": "SS1"
      },
      {
        "q": "In company liquidation, the payment order is:",
        "o": [
          "Ordinary shareholders first, then preference, then creditors",
          "Secured creditors → preferential creditors → unsecured creditors → preference shareholders → ordinary shareholders last",
          "All paid equally",
          "Ordinary shareholders always receive full payment"
        ],
        "a": 1,
        "e": "LIQUIDATION ORDER: secured creditors → preferential → unsecured → preference shares → ordinary shares (last).",
        "h": "Liquidation: secured creditors first. Ordinary shareholders last.",
        "yr": "SS1"
      },
      {
        "q": "'Voluntary winding-up' can be initiated by:",
        "o": [
          "Only by court order",
          "Members (shareholders) voting to dissolve, or creditors when company is insolvent",
          "Only when company makes profit",
          "Government automatically after 20 years"
        ],
        "a": 1,
        "e": "VOLUNTARY: members' resolution (if solvent) or creditors' decision (if insolvent).",
        "h": "Voluntary winding-up: members' decision (solvent) or creditors' decision (insolvent).",
        "yr": "SS1"
      },
      {
        "q": "'Going concern' concept means:",
        "o": [
          "Company explores new markets",
          "Company assumed to continue indefinitely — assets valued at cost not liquidation prices",
          "Company just incorporated",
          "Company has unlimited funds"
        ],
        "a": 1,
        "e": "GOING CONCERN: company will continue operating. Assets at cost not break-up value.",
        "h": "Going concern: assumed company continues indefinitely. Assets valued at cost.",
        "yr": "SS1"
      },
      {
        "q": "Partnership deed is to a partnership as _____ is to a company:",
        "o": [
          "Certificate of Incorporation",
          "Articles of Association",
          "Memorandum of Association (MOA — founding document)",
          "None of the above"
        ],
        "a": 2,
        "e": "Partnership deed = MOA equivalent for company. Both are founding documents setting out basic terms.",
        "h": "Partnership deed ≈ MOA for partnership. Both are founding governing documents.",
        "yr": "SS1"
      },
      {
        "q": "Why do companies need an auditor?",
        "o": [
          "To manage the company for directors",
          "To independently examine financial statements — giving shareholders assurance accounts are accurate",
          "To handle all financial transactions",
          "To approve dividends only"
        ],
        "a": 1,
        "e": "AUDITOR: independent accountant giving shareholders assurance accounts show 'true and fair view'.",
        "h": "Auditor: independently examines accounts, reports to shareholders.",
        "yr": "SS1"
      },
      {
        "q": "A 'Special Resolution' in a company meeting requires:",
        "o": [
          "Simple majority (50%+1)",
          "At least 75% (three-quarters) majority of votes cast",
          "Unanimous agreement",
          "Only board approval"
        ],
        "a": 1,
        "e": "SPECIAL RESOLUTION: 75% majority. For major changes: alter MOA/AOA, change name, wind up.",
        "h": "Special resolution: 75% majority. For major changes.",
        "yr": "SS1"
      },
      {
        "q": "How does a company raise capital for expansion?",
        "o": [
          "Only by borrowing from banks",
          "By issuing additional shares (rights issue, public offer), issuing debentures, retaining profits, or bank loans",
          "Only through government grants",
          "By reducing dividends only"
        ],
        "a": 1,
        "e": "Company capital raising: rights issue, public offer, debentures, retained earnings, bank loans.",
        "h": "Company raises capital: shares + debentures + retained earnings + bank loans.",
        "yr": "SS1"
      },
      {
        "q": "The main difference between a debenture holder and an ordinary shareholder:",
        "o": [
          "Debenture holders vote at AGM; shareholders don't",
          "Debenture holders are CREDITORS (fixed interest, priority); shareholders are OWNERS (variable dividend, vote)",
          "Shareholders have fixed returns; debenture holders variable",
          "No difference"
        ],
        "a": 1,
        "e": "Debenture = DEBT (creditor, fixed interest, priority). Ordinary share = EQUITY (owner, variable, votes).",
        "h": "Debenture holder = creditor (fixed interest, priority). Shareholder = owner (variable dividend, votes).",
        "yr": "SS1"
      },
      {
        "q": "'Directors' remuneration' in a company refers to:",
        "o": [
          "Dividends paid to shareholders",
          "Salary, fees, bonuses paid to directors for their management services — approved at AGM",
          "Interest paid on loans",
          "Audit fees paid to accountants"
        ],
        "a": 1,
        "e": "DIRECTORS' REMUNERATION: salary/fees/bonuses to directors. Must be approved at AGM and disclosed.",
        "h": "Directors' remuneration: salary, fees, bonuses paid to directors. Approved at AGM.",
        "yr": "SS1"
      },
      {
        "q": "A company's financial year ends and accounts are prepared. These accounts must be:",
        "o": [
          "Kept secret from all shareholders",
          "Audited by an independent auditor and presented at the AGM for shareholder approval",
          "Approved only by the chairman",
          "Filed only if the company is profitable"
        ],
        "a": 1,
        "e": "Annual accounts: audited independently, presented at AGM for shareholder approval, filed with CAC.",
        "h": "Annual accounts: independently audited → presented at AGM → filed with CAC.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Trade Associations I",
    "topicCode": "SS1-COM-20",
    "module": "Trade Associations and Regulatory Bodies",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Trade Associations I</span>: Trade association = voluntary organisation of same-industry businesses. Functions: lobbying government, setting standards, training, information sharing, dispute resolution, export promotion. Examples: NACCIMA, LCCI, MAN, NECA, NLC, market trader associations.</div>",
    "questions": [
      {
        "q": "A trade association is best defined as:",
        "o": [
          "A government ministry controlling trade",
          "Voluntary organisation of businesses in the same industry formed to promote their common interests",
          "A cooperative society for farmers",
          "A company trading goods internationally"
        ],
        "a": 1,
        "e": "TRADE ASSOCIATION: voluntary organisation of same-industry businesses promoting common interests.",
        "h": "Trade association = voluntary organisation of same-industry businesses.",
        "yr": "SS1"
      },
      {
        "q": "NACCIMA stands for:",
        "o": [
          "National Association of Commerce, Commerce, Industry",
          "Nigerian Association of Chambers of Commerce, Industry, Mines and Agriculture",
          "National Chamber of Commerce, Industry, Mines",
          "Nigerian Assembly of Commercial bodies"
        ],
        "a": 1,
        "e": "NACCIMA = Nigerian Association of Chambers of Commerce, Industry, Mines and Agriculture.",
        "h": "NACCIMA = Nigerian Association of Chambers of Commerce, Industry, Mines and Agriculture.",
        "yr": "SS1"
      },
      {
        "q": "The Lagos Chamber of Commerce and Industry (LCCI) is:",
        "o": [
          "A government ministry",
          "Nigeria's oldest chamber of commerce (1888) — represents Lagos businesses, advocates for favourable policies",
          "A cooperative society",
          "A stock exchange"
        ],
        "a": 1,
        "e": "LCCI: established 1888. Nigeria's oldest chamber. Represents Lagos businesses.",
        "h": "LCCI = Nigeria's oldest chamber of commerce (1888). Represents Lagos businesses.",
        "yr": "SS1"
      },
      {
        "q": "MAN (Manufacturers Association of Nigeria) represents:",
        "o": [
          "All traders in Nigeria",
          "Manufacturing companies — advocating for policies supporting industrial development",
          "Farmers and agricultural businesses",
          "Government enterprises only"
        ],
        "a": 1,
        "e": "MAN: represents manufacturers. Advocates for: power supply, raw materials, policy, anti-dumping protection.",
        "h": "MAN = Manufacturers Association of Nigeria. Advocates for manufacturers.",
        "yr": "SS1"
      },
      {
        "q": "A PRIMARY function of a trade association is:",
        "o": [
          "Making products for its members",
          "Lobbying government for policies favourable to the industry",
          "Providing loans to members",
          "Competing with member businesses"
        ],
        "a": 1,
        "e": "PRIMARY FUNCTION: LOBBYING — representing member businesses to government and regulatory bodies.",
        "h": "Primary trade association function: lobbying government for industry-favourable policies.",
        "yr": "SS1"
      },
      {
        "q": "How do trade associations help maintain STANDARDS?",
        "o": [
          "By replacing government regulation",
          "By setting voluntary codes of practice and quality standards that members agree to follow",
          "By competing with regulatory agencies",
          "By ignoring all standards"
        ],
        "a": 1,
        "e": "Standards: trade associations set CODES OF PRACTICE and voluntary standards for members.",
        "h": "Trade associations: set voluntary codes of practice and quality standards.",
        "yr": "SS1"
      },
      {
        "q": "The NLC (Nigeria Labour Congress) is:",
        "o": [
          "An association of employers",
          "Nigeria's central trade union body representing organised workers — negotiating wages and conditions",
          "A trade association for market women",
          "A manufacturers' lobby group"
        ],
        "a": 1,
        "e": "NLC: central trade union federation representing Nigerian workers. Negotiates wages and working conditions.",
        "h": "NLC = trade union for workers. Negotiates wages and conditions with employers.",
        "yr": "SS1"
      },
      {
        "q": "Market women/traders associations in Nigeria:",
        "o": [
          "Eliminate competition between traders",
          "Collectively represent traders' interests to government, set trading rules, resolve disputes, organise welfare",
          "Control all market prices",
          "Own the markets"
        ],
        "a": 1,
        "e": "Market trader associations: represent to government/market authorities, set rules, resolve disputes, welfare.",
        "h": "Market traders association: represents traders, sets rules, resolves disputes.",
        "yr": "SS1"
      },
      {
        "q": "PENCOM (pension regulator) differs from a trade association because:",
        "o": [
          "They are identical",
          "PENCOM has statutory legal powers to enforce pension laws; trade associations are voluntary with no legal enforcement powers",
          "Trade associations have more power",
          "PENCOM represents workers not government"
        ],
        "a": 1,
        "e": "REGULATOR = statutory powers (legal enforcement). TRADE ASSOC = voluntary, no enforcement powers over non-members.",
        "h": "Regulator: statutory powers. Trade assoc: voluntary, no enforcement powers.",
        "yr": "SS1"
      },
      {
        "q": "'Information sharing' as a trade association function:",
        "o": [
          "Keeping market information secret from members",
          "Providing market research, industry statistics, trade opportunities, and competitor information — helping better decisions",
          "Sharing customer personal data",
          "Publishing competitors' secrets"
        ],
        "a": 1,
        "e": "Information sharing: market trends, regulations, opportunities, best practices → better decisions.",
        "h": "Trade association info sharing: market research, statistics, opportunities → better decisions.",
        "yr": "SS1"
      },
      {
        "q": "Trade associations provide TRAINING by:",
        "o": [
          "Building schools for members' children",
          "Organising industry-specific courses, workshops, and seminars to upgrade members' skills",
          "Providing university education free",
          "Replacing vocational colleges"
        ],
        "a": 1,
        "e": "TRAINING: trade associations organise professional development courses and technical training for members.",
        "h": "Trade associations: organise training, workshops, seminars for member skill development.",
        "yr": "SS1"
      },
      {
        "q": "NECA (Nigeria Employers Consultative Association) represents:",
        "o": [
          "Workers (employees)",
          "Employers — advocating employer interests in labour relations, employment policy",
          "Market traders",
          "Small businesses only"
        ],
        "a": 1,
        "e": "NECA: represents EMPLOYERS. Counterpart to NLC in industrial/labour relations.",
        "h": "NECA = employers' association. Counterpart to NLC.",
        "yr": "SS1"
      },
      {
        "q": "How does a trade association help members facing ANTI-COMPETITIVE PRACTICES?",
        "o": [
          "By ignoring unfair competition",
          "By collectively representing members' concerns to government/regulatory bodies (FCCPC) and advocating for competition law enforcement",
          "By retaliating against unfair competitors",
          "By joining unfair competitors"
        ],
        "a": 1,
        "e": "Anti-competitive: trade associations collectively report to FCCPC and regulators. More impact than individuals.",
        "h": "Trade association: collectively reports anti-competitive practices to regulators.",
        "yr": "SS1"
      },
      {
        "q": "FCCPC differs from a trade association because:",
        "o": [
          "They are the same type",
          "FCCPC is a government agency with statutory power to enforce competition law; trade associations are private voluntary groups",
          "Trade associations have more enforcement power",
          "FCCPC only represents manufacturers"
        ],
        "a": 1,
        "e": "FCCPC: government regulator with LEGAL POWERS. Trade assoc: VOLUNTARY private body.",
        "h": "FCCPC = government regulator with legal powers. Trade assoc = voluntary private group.",
        "yr": "SS1"
      },
      {
        "q": "NAMB (Nigerian Association of Master Bakers) advocates for:",
        "o": [
          "All food manufacturers",
          "Master bakers — flour price stability, bakery regulations, gas/electricity access, market conditions",
          "Only government bakeries",
          "Flour millers"
        ],
        "a": 1,
        "e": "NAMB: represents master bakers. Advocates for flour prices, gas supply, baking regulations.",
        "h": "NAMB = master bakers. Advocates for flour prices, gas supply, baking regulations.",
        "yr": "SS1"
      },
      {
        "q": "Trade associations promote EXPORT TRADE by:",
        "o": [
          "Restricting members from exporting",
          "Organising trade missions abroad, providing foreign market intelligence, facilitating foreign buyer introductions",
          "Building export factories for members",
          "Replacing NEPC"
        ],
        "a": 1,
        "e": "Export promotion: trade missions, international trade fairs, market intelligence, foreign buyer introductions.",
        "h": "Trade associations: trade missions, trade fairs, foreign market intelligence.",
        "yr": "SS1"
      },
      {
        "q": "NURTW (National Union of Road Transport Workers) is:",
        "o": [
          "A trade association for transport companies",
          "A trade union for road transport workers (drivers, conductors)",
          "A government transport department",
          "A cooperative for buying vehicles"
        ],
        "a": 1,
        "e": "NURTW: trade UNION for road transport workers. Different from transport company owners' associations.",
        "h": "NURTW = trade union for road transport workers (not employers' association).",
        "yr": "SS1"
      },
      {
        "q": "Main objective of most trade associations:",
        "o": [
          "Maximum profit for the association itself",
          "Promoting and protecting the common interests of members — lobbying, standards, training, information, representing industry",
          "Eliminating all competition between members",
          "Replacing government regulation"
        ],
        "a": 1,
        "e": "MAIN OBJECTIVE: PROMOTING MEMBERS' INTERESTS — lobbying, standards, training, information, representation.",
        "h": "Trade association main objective: promote and protect members' common interests.",
        "yr": "SS1"
      },
      {
        "q": "'Dispute resolution' as a trade association function:",
        "o": [
          "Going to court for all disputes",
          "Providing informal mediation/arbitration to resolve disputes between members — cheaper and faster than courts",
          "Filing police reports against members",
          "Expelling all disputing members"
        ],
        "a": 1,
        "e": "DISPUTE RESOLUTION: mediation/arbitration between members. Cheaper, faster, less damaging than courts.",
        "h": "Trade association dispute resolution: mediation/arbitration between members.",
        "yr": "SS1"
      },
      {
        "q": "How does trade association membership benefit a SMALL BUSINESS?",
        "o": [
          "Small businesses don't benefit",
          "Gives collective voice with government and large buyers, plus access to training, information, and networking they couldn't afford alone",
          "Only helps large companies",
          "Creates dependence"
        ],
        "a": 1,
        "e": "Small business benefits: COLLECTIVE VOICE + affordable resources + networking = punch above weight.",
        "h": "Small business: collective voice + resources + networking = greater influence.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Trade Associations II",
    "topicCode": "SS1-COM-21",
    "module": "Trade Associations and Regulatory Bodies",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Trade Associations II</span>: Consumer protection: FCCPC, NAFDAC, SON, NESREA. Consumer rights: safety, information, choice, redress. Sector regulators: NCC (telecoms), NAICOM (insurance), SEC (capital market), PENCOM (pensions), CBN (banking consumer protection).</div>",
    "questions": [
      {
        "q": "FCCPC was established to:",
        "o": [
          "Promote exports of Nigerian goods",
          "Protect consumers against unfair trade practices, substandard goods, and anti-competitive business behaviour",
          "Regulate banking sector only",
          "Control all prices in Nigeria"
        ],
        "a": 1,
        "e": "FCCPC: protects consumers from substandard goods, false advertising, price manipulation, anti-competitive practices.",
        "h": "FCCPC: protects consumers from unfair practices, substandard goods, anti-competitive behaviour.",
        "yr": "SS1"
      },
      {
        "q": "NAFDAC protects consumers by:",
        "o": [
          "Manufacturing drugs for consumers",
          "Regulating and enforcing standards for food, drugs, cosmetics, chemicals — ensuring safety before sale",
          "Setting prices for medicines",
          "Distributing free medicines"
        ],
        "a": 1,
        "e": "NAFDAC: regulates food, drugs, cosmetics, chemicals. Registers/approves, inspects, seizes substandard goods.",
        "h": "NAFDAC: regulates and enforces safety standards for food, drugs, cosmetics.",
        "yr": "SS1"
      },
      {
        "q": "SON (Standards Organisation of Nigeria) sets and enforces:",
        "o": [
          "Labour standards for workers",
          "Technical standards for manufactured products — ensuring goods meet minimum quality requirements",
          "Financial accounting standards",
          "Environmental standards only"
        ],
        "a": 1,
        "e": "SON: sets Nigerian Industrial Standards (NIS). Certifies products with SON Quality Mark.",
        "h": "SON: sets Nigerian Industrial Standards. Issues SON Quality Mark.",
        "yr": "SS1"
      },
      {
        "q": "Consumer's 'right to safety' means:",
        "o": [
          "Right to demand free products",
          "Right to be protected against goods/services hazardous to health or life",
          "Safety only applies to industrial workers",
          "Consumers must test products themselves"
        ],
        "a": 1,
        "e": "RIGHT TO SAFETY: products must not be hazardous when used as intended. Enforced by NAFDAC, SON, FCCPC.",
        "h": "Right to safety: products must not be hazardous to health/life.",
        "yr": "SS1"
      },
      {
        "q": "The NCC (Nigerian Communications Commission) regulates:",
        "o": [
          "Road transport sector",
          "Telecommunications — licensing operators, setting tariffs, ensuring quality of service",
          "Banking and financial services",
          "Food and drug safety"
        ],
        "a": 1,
        "e": "NCC: licenses telecom operators (MTN, Airtel, Glo, 9Mobile), sets quality standards, regulates tariffs.",
        "h": "NCC = regulates telecoms (licenses MTN, Airtel, Glo). Sets tariffs and quality standards.",
        "yr": "SS1"
      },
      {
        "q": "NAICOM (National Insurance Commission) regulates Nigeria's:",
        "o": [
          "Banking sector",
          "Insurance sector — licensing insurance companies, protecting policyholders, enforcing insurance laws",
          "Pension fund sector",
          "Stock exchange"
        ],
        "a": 1,
        "e": "NAICOM: licenses insurance companies, sets capital requirements, monitors solvency, protects policyholders.",
        "h": "NAICOM = regulates insurance companies. Protects policyholders.",
        "yr": "SS1"
      },
      {
        "q": "Consumer's 'right to information' means:",
        "o": [
          "Right to access any company's internal records",
          "Right to receive accurate, clear information about products — ingredients, prices, usage, risks — before purchasing",
          "Consumers must research all products themselves",
          "Only government can provide product information"
        ],
        "a": 1,
        "e": "RIGHT TO INFORMATION: accurate, complete information about products (ingredients, price, risks, usage).",
        "h": "Right to information: accurate product information (ingredients, price, risks) before purchase.",
        "yr": "SS1"
      },
      {
        "q": "NESREA (National Environmental Standards and Regulations Enforcement Agency) focuses on:",
        "o": [
          "Setting food safety standards",
          "Enforcing environmental laws — pollution control, environmental impact assessments, protecting natural resources",
          "Regulating insurance companies",
          "Controlling communications"
        ],
        "a": 1,
        "e": "NESREA: enforces Nigeria's environmental laws. Controls pollution, monitors industrial emissions.",
        "h": "NESREA: enforces environmental laws — pollution control, EIA requirements.",
        "yr": "SS1"
      },
      {
        "q": "CBN's role in CONSUMER PROTECTION in banking:",
        "o": [
          "Setting up banks",
          "Ensuring banks treat customers fairly — transparent charges, responsible lending, complaint resolution through Consumer Protection Framework",
          "Making direct loans to consumers",
          "Setting all bank charges at zero"
        ],
        "a": 1,
        "e": "CBN consumer protection: Consumer Protection Framework — transparent fees, responsible lending, complaint resolution.",
        "h": "CBN consumer protection: transparent bank charges, fair treatment, complaint resolution.",
        "yr": "SS1"
      },
      {
        "q": "A consumer who buys expired food should report to:",
        "o": [
          "The police only",
          "NAFDAC and/or FCCPC — food safety and consumer protection agencies",
          "The company CEO directly",
          "Their bank"
        ],
        "a": 1,
        "e": "Expired food: NAFDAC (food safety) and FCCPC (consumer protection). NAFDAC can seize stock and prosecute.",
        "h": "Expired food: report to NAFDAC (food safety) and FCCPC (consumer protection).",
        "yr": "SS1"
      },
      {
        "q": "SEC protects investors by:",
        "o": [
          "Setting up companies for investors",
          "Regulating capital markets — ensuring accurate financial disclosure and preventing securities fraud",
          "Managing pension funds",
          "Licensing banks"
        ],
        "a": 1,
        "e": "SEC: requires accurate disclosure, prevents insider trading, regulates stockbrokers, investigates market fraud.",
        "h": "SEC: protects investors through accurate disclosure requirements and preventing securities fraud.",
        "yr": "SS1"
      },
      {
        "q": "SON Quality Mark indicates:",
        "o": [
          "Product manufactured in Nigeria only",
          "Product tested and certified to meet Nigerian Industrial Standards — safe and fit for purpose",
          "Product is most expensive in category",
          "Government endorsement of brand"
        ],
        "a": 1,
        "e": "SON Quality Mark (NIS mark): independently tested and meets Nigerian Industrial Standard.",
        "h": "SON Quality Mark = product meets Nigerian Industrial Standards. Independently certified.",
        "yr": "SS1"
      },
      {
        "q": "'Anti-dumping' protection involves:",
        "o": [
          "Preventing Nigerian goods from being exported",
          "Protecting Nigerian manufacturers from foreign goods sold below production cost — destroying local industries",
          "Dumping waste in Nigerian waters",
          "Preventing all price increases"
        ],
        "a": 1,
        "e": "ANTI-DUMPING: tariffs on goods sold below cost by foreign producers. Protects local manufacturers.",
        "h": "Anti-dumping: tariffs on goods sold below cost. Protects local manufacturers.",
        "yr": "SS1"
      },
      {
        "q": "Consumer's 'right to redress' means:",
        "o": [
          "Consumers can dress however they want in shops",
          "Consumers can seek fair resolution — repair, replacement, or refund — when goods or services fail standards",
          "Consumers can take goods without paying",
          "Consumers can bargain on all prices"
        ],
        "a": 1,
        "e": "RIGHT TO REDRESS: when products defective/service inadequate, consumer can seek refund/replacement/repair.",
        "h": "Right to redress: repair, replacement, or refund when products are defective.",
        "yr": "SS1"
      },
      {
        "q": "NAFDAC's work protects Nigerian children because:",
        "o": [
          "NAFDAC only protects adults",
          "NAFDAC ensures paediatric medicines, infant formula, children's food, and toys meet safety standards — children are more vulnerable",
          "Children's products are excluded",
          "By banning all children's products"
        ],
        "a": 1,
        "e": "Children's protection: NAFDAC regulates paediatric drugs, infant formula, children's foods, toys.",
        "h": "NAFDAC protects children: regulates paediatric medicines, infant formula, children's foods.",
        "yr": "SS1"
      },
      {
        "q": "PENCOM protects workers by:",
        "o": [
          "Setting wages",
          "Regulating pension fund administrators, ensuring contributions invested safely, protecting retirement savings",
          "Providing health insurance",
          "Regulating labour unions"
        ],
        "a": 1,
        "e": "PENCOM: licenses and supervises PFAs, ensures contributions remitted/invested safely, protects retirement savings.",
        "h": "PENCOM: regulates pension funds, ensures contributions safe, protects retirement savings.",
        "yr": "SS1"
      },
      {
        "q": "Consumer protection organisations strengthen commerce by:",
        "o": [
          "Making it harder to do business",
          "Building consumer confidence — when consumers trust products are safe and businesses accountable, they buy more",
          "Reducing all trade activity",
          "Competing with businesses"
        ],
        "a": 1,
        "e": "Consumer protection → confidence → more buying → more commerce. Protection strengthens markets.",
        "h": "Consumer protection → consumer confidence → more commerce.",
        "yr": "SS1"
      },
      {
        "q": "NESREA enforcing environmental standards benefits society by:",
        "o": [
          "Reducing manufacturing productivity",
          "Protecting public health (clean air/water), preserving natural resources, preventing environmental degradation",
          "Increasing production costs only",
          "Eliminating manufacturing"
        ],
        "a": 1,
        "e": "Environmental protection: public health, resource conservation, sustainable development.",
        "h": "Environmental protection: cleaner air/water → public health + resource conservation.",
        "yr": "SS1"
      },
      {
        "q": "When telecom subscribers have unresolved complaints, they escalate to:",
        "o": [
          "The police",
          "NCC (Nigerian Communications Commission) — the telecom sector regulator",
          "NAFDAC",
          "CBN"
        ],
        "a": 1,
        "e": "NCC COMPLAINTS: if operator doesn't resolve, escalate to NCC. NCC can impose fines on operators.",
        "h": "Telecom complaints → escalate to NCC if operator doesn't resolve.",
        "yr": "SS1"
      },
      {
        "q": "Effective regulatory bodies benefit both producers and consumers because:",
        "o": [
          "Only consumers benefit",
          "Producers benefit from fair competition (no dumping/counterfeiting); consumers benefit from safe products and fair prices",
          "Regulation always hurts businesses",
          "Only protects large corporations"
        ],
        "a": 1,
        "e": "Both benefit: producers (fair competition) + consumers (safety, fair prices) + market trust.",
        "h": "Effective regulation: producers (fair competition) + consumers (safety) + market trust.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Transportation I",
    "topicCode": "SS1-COM-22",
    "module": "Aids to Trade",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Transportation I</span>: Transportation removes PLACE hindrance. Types: land (road/rail), water (inland/ocean), air, pipeline. NRC (rail), NPA (ports), FAAN (airports). Choice factors: nature of goods, urgency, cost, distance, value. Intermodal transport.</div>",
    "questions": [
      {
        "q": "Transportation removes the hindrance of:",
        "o": [
          "Time",
          "Risk",
          "Place — moves goods from where produced to where needed",
          "Finance"
        ],
        "a": 2,
        "e": "TRANSPORT removes PLACE hindrance: moves goods from production location to consumption.",
        "h": "Transport removes PLACE hindrance: moves goods from production to consumption.",
        "yr": "SS1"
      },
      {
        "q": "Which is a mode of LAND transportation?",
        "o": [
          "Ship transportation",
          "Road (trucks, lorries) and rail (trains) transportation",
          "Pipeline transportation",
          "Air cargo transportation"
        ],
        "a": 1,
        "e": "LAND TRANSPORT: (1) ROAD — trucks, lorries, buses; (2) RAIL — trains on railway lines.",
        "h": "Land transport: road (trucks, lorries) and rail (trains).",
        "yr": "SS1"
      },
      {
        "q": "The Nigerian Railway Corporation (NRC) provides:",
        "o": [
          "Air transport",
          "Water transport",
          "Rail transport — trains connecting Nigerian cities",
          "Road transport"
        ],
        "a": 2,
        "e": "NRC: manages Nigeria's railway network. Standard gauge rail. Carries passengers and freight.",
        "h": "NRC = railway operator. Standard gauge trains. Passengers and freight.",
        "yr": "SS1"
      },
      {
        "q": "NPA (Nigeria Ports Authority) manages:",
        "o": [
          "Airports",
          "Seaports — Lagos Apapa, Tin Can Island, Port Harcourt, Warri, Calabar",
          "Railway stations",
          "Federal roads"
        ],
        "a": 1,
        "e": "NPA: manages Nigeria's seaports — Lagos (Apapa, Tin Can), Port Harcourt, Warri, Calabar, Onne.",
        "h": "NPA = manages seaports (Lagos Apapa, Tin Can, Port Harcourt, Warri, Calabar).",
        "yr": "SS1"
      },
      {
        "q": "AIR transport is most suitable for goods that are:",
        "o": [
          "Heavy and bulky (iron ore, crude oil)",
          "High-value, perishable, or time-sensitive (flowers, pharmaceuticals, electronics, urgent documents)",
          "Cheap and low-value",
          "Liquid commodities"
        ],
        "a": 1,
        "e": "AIR CARGO: HIGH-VALUE, PERISHABLE, or TIME-SENSITIVE goods. Too expensive for bulk/heavy.",
        "h": "Air cargo: high-value, perishable, or time-sensitive goods.",
        "yr": "SS1"
      },
      {
        "q": "PIPELINE transportation carries mainly:",
        "o": [
          "Solid goods like machinery",
          "Liquid and gas commodities — crude oil, natural gas, refined petroleum products",
          "Passengers only",
          "Agricultural produce"
        ],
        "a": 1,
        "e": "PIPELINE: carries liquids and gases — crude oil, natural gas, refined petroleum products.",
        "h": "Pipeline: carries liquids and gases — crude oil, natural gas, refined petroleum.",
        "yr": "SS1"
      },
      {
        "q": "WATER transport (ocean shipping) is most suitable for:",
        "o": [
          "Urgent time-sensitive goods",
          "Expensive electronics that must arrive fast",
          "Large volume, heavy, or bulky goods transported internationally — lowest cost per tonne",
          "Highly perishable goods"
        ],
        "a": 2,
        "e": "OCEAN SHIPPING: BULK CARGO, HEAVY GOODS, LONG DISTANCE INTERNATIONAL TRADE. Cheapest per tonne.",
        "h": "Ocean shipping: large volumes, heavy/bulky, international. Cheapest per tonne.",
        "yr": "SS1"
      },
      {
        "q": "FAAN (Federal Airports Authority of Nigeria) manages:",
        "o": [
          "Nigerian seaports",
          "Nigerian airports — runway maintenance, terminal services, security, navigation aids",
          "Nigerian railway stations",
          "Road construction"
        ],
        "a": 1,
        "e": "FAAN: manages Nigeria's civil airports. Major: Lagos MMIA, Abuja NAIA, Port Harcourt, Kano.",
        "h": "FAAN = manages Nigeria's airports.",
        "yr": "SS1"
      },
      {
        "q": "APAPA PORT in Lagos is significant because:",
        "o": [
          "It is Nigeria's largest airport",
          "It handles the majority of Nigeria's seaborne imports and exports — largest port complex in West Africa",
          "It connects Lagos to Abuja by rail",
          "It is a major oil refinery"
        ],
        "a": 1,
        "e": "APAPA PORT: Nigeria's largest and busiest seaport. Handles majority of Nigeria's container trade.",
        "h": "Apapa Port: Nigeria's largest seaport. Handles majority of seaborne trade.",
        "yr": "SS1"
      },
      {
        "q": "Road transport's advantage over rail in Nigeria:",
        "o": [
          "Road transport cheaper per tonne for long distances",
          "Road offers door-to-door delivery flexibility — reaches any location with a road, unlike fixed rail tracks",
          "Rail transport is more expensive",
          "Road transport always faster"
        ],
        "a": 1,
        "e": "ROAD ADVANTAGE: DOOR-TO-DOOR service — trucks deliver directly to factory/warehouse/market.",
        "h": "Road advantage: door-to-door delivery. Rail fixed to tracks.",
        "yr": "SS1"
      },
      {
        "q": "Inland water transport in Nigeria uses:",
        "o": [
          "Only Lagos Lagoon",
          "Nigeria's navigable rivers (Niger, Benue), lakes, and coastal waterways",
          "Only international shipping lanes",
          "Underground water tunnels"
        ],
        "a": 1,
        "e": "INLAND WATER NIGERIA: Niger River (1,600+km), Benue River, Lagos Lagoon and coastal creeks.",
        "h": "Inland water Nigeria: Niger River, Benue River, Lagos Lagoon, coastal creeks.",
        "yr": "SS1"
      },
      {
        "q": "A FREIGHT FORWARDER is:",
        "o": [
          "A person who carries goods physically",
          "Agent who organises goods transportation — booking cargo space, handling documentation, coordinating logistics",
          "Customs officer at port",
          "Warehouse operator only"
        ],
        "a": 1,
        "e": "FREIGHT FORWARDER: logistics agent booking cargo, preparing documentation, coordinating logistics for traders.",
        "h": "Freight forwarder: organises cargo transport, documentation, and logistics.",
        "yr": "SS1"
      },
      {
        "q": "The BILL OF LADING is:",
        "o": [
          "A restaurant bill",
          "A legal shipping document — receipt of goods, contract of carriage, and document of title",
          "A tax invoice for customs",
          "A document only for air cargo"
        ],
        "a": 1,
        "e": "BILL OF LADING (B/L): receipt + contract of carriage + document of title. Essential for sea trade.",
        "h": "Bill of lading: receipt + contract of carriage + document of title.",
        "yr": "SS1"
      },
      {
        "q": "Transportation contributes to PRICE REDUCTION because:",
        "o": [
          "Transport companies reduce prices arbitrarily",
          "Efficient transport reduces distribution costs, eliminates artificial scarcity, enables competition — all reducing prices",
          "Transport always increases prices",
          "Only road transport reduces prices"
        ],
        "a": 1,
        "e": "Transport and prices: lower distribution costs + eliminates scarcity + enables competition.",
        "h": "Transport reduces prices: lower costs + eliminates scarcity + enables competition.",
        "yr": "SS1"
      },
      {
        "q": "Which factor most determines choice of air vs sea transport?",
        "o": [
          "Trader's personal preference",
          "Nature and value of goods, urgency, and cost — perishable/high-value/urgent = air; bulk/heavy/non-urgent = sea",
          "Government regulations only",
          "Distance only"
        ],
        "a": 1,
        "e": "Transport choice: nature of goods + urgency + cost + distance + value. Not one factor alone.",
        "h": "Transport choice: nature of goods + urgency + cost + distance + value.",
        "yr": "SS1"
      },
      {
        "q": "Nigeria's INTERMODAL TRANSPORT means:",
        "o": [
          "Only one type of transport",
          "Using multiple transport modes in combination (ship → truck → rail) to move goods efficiently",
          "Transport by international companies only",
          "Transport on international waters only"
        ],
        "a": 1,
        "e": "INTERMODAL: seamlessly combining multiple transport modes for optimal cost, speed, and reliability.",
        "h": "Intermodal: combine multiple transport modes (ship + truck + rail).",
        "yr": "SS1"
      },
      {
        "q": "THIRD-PARTY LOGISTICS (3PL) providers offer:",
        "o": [
          "Government transport services only",
          "Comprehensive outsourced logistics — warehousing, distribution, transportation management",
          "Only driver recruitment",
          "Only customs clearance"
        ],
        "a": 1,
        "e": "3PL: comprehensive outsourced logistics. DHL, GIG Logistics. Businesses focus on core operations.",
        "h": "3PL: comprehensive outsourced logistics (warehousing, transport, distribution).",
        "yr": "SS1"
      },
      {
        "q": "The LAGOS-IBADAN EXPRESSWAY is important to Nigerian commerce because:",
        "o": [
          "Connects Nigeria to international markets",
          "It is Nigeria's busiest road corridor — connecting Lagos port to Ibadan and southwest, carrying huge goods volumes",
          "Only used by private vehicles",
          "It is an international highway"
        ],
        "a": 1,
        "e": "Lagos-Ibadan Expressway: Nigeria's busiest road. Connects Lagos port to southwest. Critical commerce route.",
        "h": "Lagos-Ibadan Expressway: Nigeria's busiest road. Connects Lagos port to southwest.",
        "yr": "SS1"
      },
      {
        "q": "TRANSHIPMENT as a transport concept means:",
        "o": [
          "Transporting by ship only",
          "Transferring cargo from one vessel/mode to another at an intermediate point during transit",
          "Direct origin-to-destination shipping",
          "Shipping damaged goods"
        ],
        "a": 1,
        "e": "TRANSHIPMENT: cargo transferred at hub port. Lagos is transhipment hub for West African landlocked countries.",
        "h": "Transhipment: cargo transferred at intermediate hub before final destination.",
        "yr": "SS1"
      },
      {
        "q": "The main advantage of RAIL transport over ROAD for heavy goods:",
        "o": [
          "Rail is faster for all journeys",
          "Rail is cheaper per tonne for long distances and large volumes — lower fuel and maintenance costs per unit",
          "Road transport always cheaper",
          "Rail cannot carry heavy goods"
        ],
        "a": 1,
        "e": "RAIL ADVANTAGE: cheaper per tonne for long distances with heavy/bulk cargo. Lower fuel per unit.",
        "h": "Rail advantage: cheaper per tonne for long distances with heavy/bulk cargo.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Transportation II",
    "topicCode": "SS1-COM-23",
    "module": "Aids to Trade",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Transportation II</span>: Transport documents: bill of lading (sea), airway bill (air), consignment note (road/rail). NIMASA (maritime), FRSC (road safety). Problems: poor roads, overloading, Apapa congestion, piracy. Demurrage, letter of credit, cabotage law.</div>",
    "questions": [
      {
        "q": "The AIRWAY BILL differs from a Bill of Lading in that:",
        "o": [
          "They are identical",
          "Airway bill is for air freight; bill of lading for sea freight. Airway bill is NOT a document of title",
          "Both are for sea transport",
          "Airway bills are not legal documents"
        ],
        "a": 1,
        "e": "AIRWAY BILL: air transport document — receipt + contract. NOT a document of title. To named consignee only.",
        "h": "Airway bill: air cargo document. NOT document of title. Goods to named consignee only.",
        "yr": "SS1"
      },
      {
        "q": "NIMASA (Nigerian Maritime Administration and Safety Agency):",
        "o": [
          "Manages Nigerian airports",
          "Regulates shipping — maritime safety, vessel registration, seafarer certification, combating piracy",
          "Collects import duties at ports",
          "Manages Nigerian railways"
        ],
        "a": 1,
        "e": "NIMASA: vessel registration/inspection, maritime safety, seafarer certification, anti-piracy, cabotage regulation.",
        "h": "NIMASA: maritime regulator — vessel registration, safety, anti-piracy, seafarer certification.",
        "yr": "SS1"
      },
      {
        "q": "The FRSC (Federal Road Safety Corps) contributes by:",
        "o": [
          "Building federal roads",
          "Enforcing road traffic laws, investigating accidents, promoting road safety education, rescuing accident victims",
          "Regulating air transport",
          "Managing railway crossings"
        ],
        "a": 1,
        "e": "FRSC: enforces Road Traffic Act, vehicle registration/roadworthiness, driver licensing, accident investigation.",
        "h": "FRSC: enforces road traffic laws, promotes road safety, licenses drivers.",
        "yr": "SS1"
      },
      {
        "q": "POOR ROADS affect Nigerian commerce by:",
        "o": [
          "Making trade more efficient",
          "Increasing transport costs, damaging goods, delaying deliveries, making remote areas commercially isolated",
          "Only affecting private cars",
          "Having no effect on business"
        ],
        "a": 1,
        "e": "Poor roads: higher costs, goods damaged, delays, remote areas inaccessible = commercial isolation.",
        "h": "Poor roads: higher costs + damaged goods + delays + commercial isolation.",
        "yr": "SS1"
      },
      {
        "q": "CONSIGNMENT NOTE is used for:",
        "o": [
          "Sea transport",
          "Air transport",
          "Road and rail transport of goods — issued by carrier as receipt and contract",
          "Pipeline transport"
        ],
        "a": 2,
        "e": "CONSIGNMENT NOTE: road and rail transport document — receipt + contract of carriage. Not document of title.",
        "h": "Consignment note: road and rail cargo document. Receipt + contract of carriage.",
        "yr": "SS1"
      },
      {
        "q": "OVERLOADING of trucks is a problem because:",
        "o": [
          "Overloaded trucks are faster",
          "Damages road surfaces, increases accident risk, and increases goods damage risk",
          "Overloading saves fuel",
          "FRSC encourages overloading"
        ],
        "a": 1,
        "e": "Overloading: damages roads, accident risk (tyre bursts), goods damage, vehicle wear.",
        "h": "Overloading: damages roads + accident risk + goods damage.",
        "yr": "SS1"
      },
      {
        "q": "The CABOTAGE LAW means:",
        "o": [
          "Only foreign ships can trade between Nigerian ports",
          "Only Nigerian-owned and crewed vessels can carry cargo between Nigerian ports (coastal trade)",
          "All ships must stop at Apapa port",
          "Ship owners must pay higher taxes"
        ],
        "a": 1,
        "e": "CABOTAGE: reserves coastal trade for Nigerian-owned, Nigerian-crewed vessels. Promotes Nigerian shipping.",
        "h": "Cabotage: only Nigerian-owned ships carry cargo between Nigerian coastal ports.",
        "yr": "SS1"
      },
      {
        "q": "TRAFFIC CONGESTION at Apapa Port affects commerce by:",
        "o": [
          "Reducing transport costs",
          "Causing severe delays, demurrage charges, higher import costs, supply chain disruption",
          "Improving efficiency",
          "Only affecting oil imports"
        ],
        "a": 1,
        "e": "Apapa congestion: trucks queue days → demurrage + supply chain disruption + higher import costs.",
        "h": "Apapa congestion: delays → demurrage charges + supply chain disruption.",
        "yr": "SS1"
      },
      {
        "q": "The LETTER OF CREDIT (L/C) is important because:",
        "o": [
          "It is a love letter between traders",
          "Bank guarantees payment to seller when shipping documents presented — reduces non-payment risk in international trade",
          "It replaces all shipping documents",
          "Only Nigeria uses L/C"
        ],
        "a": 1,
        "e": "LETTER OF CREDIT: bank guarantees payment to exporter when correct documents presented. Reduces risk.",
        "h": "Letter of credit: bank guarantees payment when shipping documents presented.",
        "yr": "SS1"
      },
      {
        "q": "Marine CARGO INSURANCE covers goods:",
        "o": [
          "Only during manufacturing",
          "During sea transportation — protects against loss/damage from storms, sinking, piracy, fire",
          "During warehouse storage only",
          "During road transport only"
        ],
        "a": 1,
        "e": "MARINE CARGO INSURANCE: covers sea transit against storms, sinking, piracy, fire, collision.",
        "h": "Marine cargo insurance: sea transit coverage — storms, piracy, sinking, fire.",
        "yr": "SS1"
      },
      {
        "q": "ABUJA-KADUNA STANDARD GAUGE RAIL benefited commerce by:",
        "o": [
          "Connecting Nigeria to Cameroon",
          "Providing faster, safer, and cheaper passenger and freight transport between Abuja and Kaduna",
          "Making road transport unnecessary",
          "Being used only by tourists"
        ],
        "a": 1,
        "e": "Abuja-Kaduna rail (2016): faster (90 mins vs 3+ hrs road), safer, freight capacity, road decongestion.",
        "h": "Abuja-Kaduna rail: faster, safer, cheaper transport. Reduces road accidents.",
        "yr": "SS1"
      },
      {
        "q": "LIGHTER (vessel) in port transport refers to:",
        "o": [
          "A ship that carries only light goods",
          "A flat-bottomed barge that transfers cargo between a ship anchored offshore and the shore",
          "A small motorboat for passengers",
          "A petroleum tanker"
        ],
        "a": 1,
        "e": "LIGHTER/LIGHTERAGE: flat-bottomed barge transferring cargo between offshore ship and quayside.",
        "h": "Lighter = flat-bottomed barge transferring cargo between anchored ship and shore.",
        "yr": "SS1"
      },
      {
        "q": "FREIGHT RATE determines:",
        "o": [
          "Speed of trains",
          "The charge for transporting goods — based on distance, weight, and commodity type",
          "Number of passengers allowed",
          "Fuel consumption"
        ],
        "a": 1,
        "e": "FREIGHT RATE: price charged for transporting goods. Factors: distance, weight, commodity type, urgency.",
        "h": "Freight rate: carrier's charge for goods transport. Based on distance, weight, commodity.",
        "yr": "SS1"
      },
      {
        "q": "PIRACY in the Gulf of Guinea affects maritime commerce by:",
        "o": [
          "Helping Nigerian shipping grow",
          "Increasing insurance costs, deterring shipping companies, threatening crew safety — raising trade costs",
          "Having no effect",
          "Only affecting oil tankers"
        ],
        "a": 1,
        "e": "Gulf of Guinea piracy: higher insurance, shipping detours, crew kidnapping = higher trade costs.",
        "h": "Gulf of Guinea piracy: higher insurance + shipping detours + crew kidnapping = higher costs.",
        "yr": "SS1"
      },
      {
        "q": "DEMURRAGE charges occur when:",
        "o": [
          "A ship arrives early",
          "A shipper delays loading/unloading beyond agreed laytime — shipping company charges daily fees",
          "Ships are too slow",
          "Cargo is overweight"
        ],
        "a": 1,
        "e": "DEMURRAGE: daily charge when shipper fails to load/unload within agreed laytime.",
        "h": "Demurrage: daily charge for loading/unloading delay beyond agreed time.",
        "yr": "SS1"
      },
      {
        "q": "Future of Nigerian transportation involves:",
        "o": [
          "Reducing all transport investment",
          "Modernising rail (standard gauge), improving ports (Lekki Deep Sea Port), expanding airports, developing waterways",
          "Returning to only road transport",
          "Eliminating private transport companies"
        ],
        "a": 1,
        "e": "Nigeria transport future: rail expansion, Lekki Deep Sea Port, airport upgrades, inland waterway development.",
        "h": "Nigeria transport future: standard gauge rail + Lekki Deep Sea Port + airports + waterways.",
        "yr": "SS1"
      },
      {
        "q": "MULTIMODAL TRANSPORT DOCUMENT (MTD) is used when:",
        "o": [
          "Only sea transport is used",
          "Goods travel by more than one transport mode — single document covers entire journey",
          "Road transport only",
          "Air transport only"
        ],
        "a": 1,
        "e": "MULTIMODAL TRANSPORT DOCUMENT: single document for journey using two or more transport modes.",
        "h": "Multimodal transport document: single document for multi-mode journey.",
        "yr": "SS1"
      },
      {
        "q": "INSURANCE CERTIFICATE in international trade:",
        "o": [
          "Proves the goods were inspected",
          "Proves that cargo insurance is in place — required to present to bank under letter of credit",
          "Is the same as a bill of lading",
          "Only required for air cargo"
        ],
        "a": 1,
        "e": "INSURANCE CERTIFICATE: proof cargo is insured. Required document under letter of credit transactions.",
        "h": "Insurance certificate: proves cargo is insured. Required for letter of credit.",
        "yr": "SS1"
      },
      {
        "q": "FEEDER VESSELS in Nigerian ports are:",
        "o": [
          "Ships that bring water to larger ships",
          "Smaller ships collecting cargo from regional ports (PH, Warri) to transfer to larger vessels at Lagos",
          "Ships that feed fish to fishermen",
          "Petroleum tankers only"
        ],
        "a": 1,
        "e": "FEEDER VESSELS: smaller ships linking regional ports to hub ports. Transfer cargo to/from larger ships.",
        "h": "Feeder vessels: smaller ships linking regional ports to main hub.",
        "yr": "SS1"
      },
      {
        "q": "The main challenge facing Nigerian transportation development is:",
        "o": [
          "Too many roads",
          "Poor infrastructure (bad roads, inadequate rail), funding gaps, maintenance failures, and insecurity along transport corridors",
          "Too much investment",
          "Too many ports"
        ],
        "a": 1,
        "e": "Nigeria transport challenges: poor roads, inadequate rail, funding gaps, maintenance failures, insecurity.",
        "h": "Nigeria transport challenges: poor roads + inadequate rail + funding gaps + insecurity.",
        "yr": "SS1"
      }
    ]
  },
  {
    "topic": "Communication",
    "topicCode": "SS1-COM-24",
    "module": "Aids to Trade",
    "term": "Third Term",
    "contentHTML": "<div class=\"learn-intro\"><span class=\"learn-keyword\">Communication</span>: Communication removes INFORMATION hindrance. Types: written (letters, emails), oral (phone, meetings), visual (TV, internet), electronic (EDI, social media). Documents: quotation, purchase order, invoice, receipt, proforma invoice. NCC regulates telecoms.</div>",
    "questions": [
      {
        "q": "Communication removes the hindrance of:",
        "o": [
          "Place",
          "Time",
          "Information — enables buyers and sellers to exchange information across distances",
          "Risk"
        ],
        "a": 2,
        "e": "COMMUNICATION removes INFORMATION HINDRANCE: buyers/sellers exchange information for trading.",
        "h": "Communication removes INFORMATION hindrance.",
        "yr": "SS1"
      },
      {
        "q": "Which is a WRITTEN form of business communication?",
        "o": [
          "Telephone call",
          "Face-to-face meeting",
          "Business letters, emails, reports, quotations, invoices",
          "Television advertisements"
        ],
        "a": 2,
        "e": "WRITTEN: business letters, emails, reports, quotations, invoices, purchase orders, contracts.",
        "h": "Written communication: letters, emails, reports, invoices, purchase orders.",
        "yr": "SS1"
      },
      {
        "q": "A QUOTATION in business communication is:",
        "o": [
          "A famous saying",
          "A formal document stating the price, terms, and conditions at which a seller will supply goods/services",
          "A telephone message",
          "An advertisement"
        ],
        "a": 1,
        "e": "QUOTATION: seller's formal document — price, quantity, delivery terms, payment terms, validity period.",
        "h": "Quotation: seller's formal document stating price and terms for supplying goods.",
        "yr": "SS1"
      },
      {
        "q": "Mobile phones transformed Nigerian commerce by:",
        "o": [
          "Replacing all business offices",
          "Enabling instant communication between buyers, sellers, banks, logistics providers — especially connecting rural areas",
          "Making face-to-face meetings irrelevant",
          "Only useful for personal calls"
        ],
        "a": 1,
        "e": "MOBILE PHONES: remote trading, mobile banking, mobile money transfers, instant supplier contact.",
        "h": "Mobile phones: remote trading, mobile banking, mobile money, instant supplier contact.",
        "yr": "SS1"
      },
      {
        "q": "INTERNET COMMUNICATION enabled Nigerian businesses to:",
        "o": [
          "Eliminate all physical stores",
          "Sell to customers worldwide (e-commerce), access global market information, conduct video meetings, manage supply chains",
          "Replace all telephone communication",
          "Only communicate with foreign companies"
        ],
        "a": 1,
        "e": "INTERNET: global e-commerce, real-time market intelligence, video conferencing, supply chain management.",
        "h": "Internet: global e-commerce + market intelligence + remote meetings + supply chain.",
        "yr": "SS1"
      },
      {
        "q": "SOCIAL MEDIA (WhatsApp, Instagram, Facebook) became a commerce tool because:",
        "o": [
          "Only young people use social media",
          "Businesses use WhatsApp for orders/support, Instagram for showcasing, Facebook marketplace for selling — low-cost digital commerce",
          "Social media has no commercial use",
          "Only for personal communication"
        ],
        "a": 1,
        "e": "Social media commerce: WhatsApp Business (orders), Instagram (product showcase), Facebook Marketplace.",
        "h": "Social media: WhatsApp orders, Instagram shops, Facebook marketplace.",
        "yr": "SS1"
      },
      {
        "q": "A PURCHASE ORDER is a document that:",
        "o": [
          "A seller sends to buyer",
          "A BUYER sends to seller — formally requesting specific goods/services at agreed prices and terms",
          "Confirms payment receipt",
          "Acknowledges goods delivery"
        ],
        "a": 1,
        "e": "PURCHASE ORDER (PO): buyer's formal document to seller specifying goods needed and terms.",
        "h": "Purchase order: buyer's formal document to seller specifying goods and terms.",
        "yr": "SS1"
      },
      {
        "q": "The NCC ensures communication services support commerce by:",
        "o": [
          "Building communication towers directly",
          "Regulating telecom operators to maintain quality — ensuring reliable internet, phone calls, data services for business",
          "Providing free communication for businesses",
          "Eliminating all private telecom companies"
        ],
        "a": 1,
        "e": "NCC: sets QoS standards, licenses operators, handles complaints, manages spectrum, ensures competition.",
        "h": "NCC ensures reliable telecoms: QoS standards, competition, affordable service.",
        "yr": "SS1"
      },
      {
        "q": "An INVOICE is a document that:",
        "o": [
          "Asks buyer to return goods",
          "Seller's formal demand for payment — lists goods supplied, quantities, prices, total due, payment terms",
          "Welcomes a new customer",
          "Confirms receipt of payment"
        ],
        "a": 1,
        "e": "INVOICE: seller's demand for payment after delivering goods. Contains all billing details.",
        "h": "Invoice: seller's demand for payment after goods delivered.",
        "yr": "SS1"
      },
      {
        "q": "ELECTRONIC DATA INTERCHANGE (EDI) means:",
        "o": [
          "Electronic newspapers",
          "Computer-to-computer exchange of business documents (invoices, purchase orders) in standardised formats",
          "Electronic display of prices",
          "Cashless payment only"
        ],
        "a": 1,
        "e": "EDI: direct computer-to-computer exchange of standard business documents — eliminating paper.",
        "h": "EDI: computer-to-computer automatic exchange of business documents. Eliminates paper.",
        "yr": "SS1"
      },
      {
        "q": "Online banking improved Nigerian commerce by:",
        "o": [
          "Eliminating the need for banks",
          "Businesses can initiate payments, check balances, manage accounts 24/7 without visiting branches — improving cash flow",
          "Online banking only for personal accounts",
          "It makes payments slower"
        ],
        "a": 1,
        "e": "ONLINE BANKING: 24/7 payment initiation, real-time balances, instant confirmations, bulk payments.",
        "h": "Online banking: 24/7 payments, real-time balances, instant confirmations.",
        "yr": "SS1"
      },
      {
        "q": "A RECEIPT is a document that:",
        "o": [
          "Requests payment from buyer",
          "Confirms payment has been received — issued by seller to buyer as proof of payment",
          "Requests delivery of goods",
          "Sends a quotation to buyer"
        ],
        "a": 1,
        "e": "RECEIPT: confirms payment received. Types: handwritten, printed till receipt, electronic email confirmation.",
        "h": "Receipt: seller confirms payment received. Proof of payment.",
        "yr": "SS1"
      },
      {
        "q": "VIDEO CONFERENCING (Zoom, Google Meet) benefits Nigerian businesses by:",
        "o": [
          "Replacing all business activities",
          "Enabling meetings between parties in different cities or countries without travel costs",
          "Only for large corporations",
          "Making telephones obsolete"
        ],
        "a": 1,
        "e": "VIDEO CONFERENCING: reduced travel costs, faster decisions, international reach, meeting recordings.",
        "h": "Video conferencing: reduces travel costs, remote meetings, faster decisions.",
        "yr": "SS1"
      },
      {
        "q": "A PROFORMA INVOICE differs from a regular invoice because:",
        "o": [
          "They are identical",
          "Proforma sent BEFORE delivery — for buyer to arrange payment/import licence. Regular invoice after delivery",
          "Proforma only for exports",
          "Only importers receive proforma invoices"
        ],
        "a": 1,
        "e": "PROFORMA INVOICE: preliminary, before shipment. Regular (commercial) invoice: after delivery, actual payment.",
        "h": "Proforma: before delivery (for LC/import licence). Regular invoice: after delivery.",
        "yr": "SS1"
      },
      {
        "q": "RADIO BROADCASTING contributes to commerce by:",
        "o": [
          "Only providing entertainment",
          "Advertising products (especially rural areas), broadcasting commodity prices, providing business news",
          "Replacing television advertising",
          "Only in cities"
        ],
        "a": 1,
        "e": "RADIO: advertises to rural areas, broadcasts farm commodity prices, provides business news.",
        "h": "Radio: rural advertising + commodity price broadcasts + business news.",
        "yr": "SS1"
      },
      {
        "q": "COMMUNICATION failure between buyer and seller leads to:",
        "o": [
          "Better trade relationships",
          "Misunderstandings about specifications, delivery times, prices — leading to wrong goods, disputes, customer dissatisfaction",
          "Higher profits",
          "Faster delivery"
        ],
        "a": 1,
        "e": "Communication failure: wrong goods, delivery failures, payment disputes, customer dissatisfaction.",
        "h": "Communication failure: wrong goods, delivery failures, payment disputes.",
        "yr": "SS1"
      },
      {
        "q": "NIPOST contributes to commerce through:",
        "o": [
          "Banking services only",
          "Delivering mail/parcels, money orders, agency services — enabling physical communication and parcel movement nationwide",
          "Manufacturing communication devices",
          "Regulating all communication"
        ],
        "a": 1,
        "e": "NIPOST: letter/parcel delivery, money orders, e-commerce last-mile delivery, agency banking.",
        "h": "NIPOST: mail/parcel delivery + money orders + e-commerce delivery.",
        "yr": "SS1"
      },
      {
        "q": "In e-commerce, the TRACK AND TRACE system communicates:",
        "o": [
          "Whether goods can be returned",
          "Real-time location and status of ordered goods as they move through the logistics network — building customer trust",
          "Competitor prices",
          "Bank account details"
        ],
        "a": 1,
        "e": "TRACK AND TRACE: real-time order location updates. Reduces enquiries, builds customer trust.",
        "h": "Track and trace: real-time order location updates for customers.",
        "yr": "SS1"
      },
      {
        "q": "Which combination most transformed small business commerce in Nigeria?",
        "o": [
          "Only fax and telephone",
          "Mobile phones + internet + social media + mobile money — enables marketing, selling, customer communication, and payment from anywhere",
          "Only radio and television",
          "Only postal mail"
        ],
        "a": 1,
        "e": "Mobile + internet + social media + mobile money: complete business operation from smartphone.",
        "h": "Mobile + internet + social media + mobile money: complete small business from smartphone.",
        "yr": "SS1"
      },
      {
        "q": "Good communication in commerce leads to:",
        "o": [
          "Confusion between buyer and seller",
          "Better buyer-seller relationships, fewer disputes, faster transactions, greater trust, and more efficient commerce",
          "Higher transaction costs only",
          "Slower business operations"
        ],
        "a": 1,
        "e": "Good communication: better relationships, fewer disputes, faster transactions, greater trust, efficient commerce.",
        "h": "Good communication: better relationships, fewer disputes, faster transactions.",
        "yr": "SS1"
      }
    ]
  }
];
